export default {
  "bcase": {
    "header": {
      "tooltip": {
        "save": "Uložit",
        "edit_enable": "Povolit úpravy",
        "edit_disable": "Zakázat úpravy",
        "maximize": "Maximalizovat",
        "minimize": "Minimalizovat",
        "attachments": "Přílohy"
      }
    }
  },
    "oauth2_consent": {
        "title": "Povolit aplikaci {application} přístup k Liftbase?",
        "intro": "Než budete pokračovat, zkontrolujte, k jakým údajům bude mít tato aplikace přístup.",
        "application": "Aplikace",
        "client_id": "ID aplikace",
        "callback": "Cíl zpětného volání",
        "identity_notice": "Název aplikace pochází z připojující se aplikace. Před povolením ověřte cíl zpětného volání.",
        "permissions": "Oprávnění",
        "duration": "Doba přístupu",
        "token_lifetime": "Platnost tokenu",
        "token_lifetime_value": "{accessMinutes} minut",
        "renewal": "Obnovení bez výzvy",
        "renewal_value": "až {authorizationDays} dnů",
        "readonly": "Pouze čtení",
        "notice": "Přístup zůstává omezen vašimi stávajícími oprávněními Liftbase a platí pouze pro tuto aplikaci.",
        "allow": "Povolit přístup",
        "deny": "Odmítnout",
        "submit_error": "Autorizaci se nepodařilo spustit. Zkuste to znovu.",
        "submit_error_invalid_request": "Tento požadavek na autorizaci vypršel nebo je neplatný. Spusťte připojení znovu v aplikaci.",
        "submit_error_invalid_redirect": "Cíl návratu aplikace je neplatný. Spusťte připojení znovu.",
        "error_title": "Žádost o autorizaci je neplatná",
        "error_description": "Vraťte se do aplikace a spusťte připojení znovu.",
        "unverified_title": "Neověřená aplikace",
        "unverified_warning": "Tato aplikace nebyla společností Liftbase ověřena jako důvěryhodný poskytovatel třetí strany. Zobrazený název může pocházet od jiného poskytovatele. Před povolením přístupu pečlivě zkontrolujte URL přesměrování.",
        "scope": {
            "mcp": {
                "title": "Čtení povolených dat Liftbase",
                "description": "Nákupy, faktury, smlouvy, workflow, bankovní výpisy a likvidita — pouze čtení, bez zápisu."
            }
        }
    },
    "administration": "Správa",
    "master_data": "Kmenová data",
    "admin_page": {
        "no_permission": "Nemáte oprávnění pro přístup do administrační oblasti.",
        "confirm_before_delete_msg": "Opravdu chcete odstranit tento záznam? (ID #{id})",
        "confirm_before_delete_from_db_msg": "Opravdu chcete smazat tento záznam? (ID #{id})",
        "confirm_before_delete_from_db_title": "Trvale smazat",
        "confirm_before_delete_from_db_btn": "Vymazat",
        "block_user_msg": "Opravdu chcete zablokovat uživatele {name}? Osoba se pak nebude moci přihlásit.",
        "block_user_title": "Přihlašovací blok",
        "block_user_btn": "Blok",
        "unblock_user_msg": "Opravdu chcete odemknout {name}? Daná osoba se pak bude moci znovu přihlásit.",
        "unblock_user_title": "Odemknout přihlášení",
        "unblock_user_btn": "Odemknout",
        "tour": {
            "menu_title": "Sekce",
            "menu": "Zde vidíte sekce administrační oblasti, kde můžete spravovat a upravovat kmenová data a nastavení.",
            "client_menu_title": "Správa společností",
            "client_menu": "Zde můžete přidat, zobrazit nebo upravit všechny společnosti.",
            "client_list": "Zde si můžete prohlédnout všechny společnosti.",
            "new_client": "Kliknutím sem založíte novou společnost.",
            "view_mode": "<p>Zde můžete přepnout ze zobrazit seznam do zobrazení tabulky a nastavit více položek najednou nebo získat lepší přehled.</p> Zobrazení tabulky lze také použít pro export nebo import dat. Po úpravě nezapomeňte tabulku uložit."
        }
    },
    "version": "Verze",
    "yes": "Ano",
    "no": "Ne",
    "recommended": "Doporučeno",
    "never": "Nikdy",
    "add": "Přidat",
    "edit": "Upravit",
    "delete": "Vymazat",
    "save": "Uložit",
    "cancel": "Zrušit",
    "apply": "Použít",
    "next": "další",
    "back": "Zadní",
    "finish": "Dokončit",
    "ok": "OK",
    "open": "Otevřené",
    "dashboard": "Ukazatele",
    "dashboards": "Dashboards",
    "einvoice_dashboard": "Dashboard e‑faktur",
    "invoice_dashboard": "Incoming Invoice Dashboard",
    "outgoing_invoice_dashboard": "Outgoing Invoice Dashboard",
    "overview": "Přehled",
    "operator": "Operátor",
    "profile": "Profil",
    "help": "Pomoc",
    "logout": "Odhlásit se",
    "tenant_switcher": {
        "error": "Tenant se nepodařilo přepnout.",
        "error_passkey": "Přepnutí tenantu není pro passkey relace dostupné.",
        "error_saml": "Tento tenant nelze otevřít z aktuální SSO relace."
    },
    "list_view": "Zobrazit seznam",
    "table_view": "Zobrazit tabulku",
    "archive": "Archiv",
    "active": "Aktivní",
    "email": "E-mail",
    "name": "Název",
    "tax": "daň (%)",
    "value": "Množství",
    "number": "Číslo",
    "currency": "Měna",
    "actions": "Akce",
    "system": "Systém",
    "from": "Z",
    "of": "Z",
    "until": "až do",
    "up_to": "až do",
    "show_more": "Zobrazit více",
    "refresh": "Obnovit",
    "calculate": "Vypočítat",
    "calc_brutto_from_net": "Vypočítat hrubou z čisté",
    "calc_net_from_brutto": "Vypočítat čistou z hrubé",
    "cost_center_id": "Nákladové středisko",
    "cost_centers": "Nákladová střediska",
    "budget_id": "Rozpočet",
    "budgets": "Rozpočty",
    "branch_id": "Pobočka",
    "branches": "Pobočky",
    "employee_id": "Zaměstnanec",
    "employees": "Zaměstnanec",
    "vehicles": "Motorová vozidla",
    "financial_dimension_id": "Finanční dimenze",
    "financial_dimensions": "Finanční dimenze",
    "tax_group_id": "Skupina daně z prodeje",
    "tax_groups": "Skupiny daně z prodeje",
    "tax_item_group_id": "Skupina položek daně z prodeje",
    "tax_item_groups": "Skupiny položek daně z prodeje",
    "profit_center_id": "Ziskové centrum",
    "profit_centers": "Zisková centra",
    "client_id": "Společnost",
    "clients": "Společnosti",
    "department_id": "Oddělení",
    "departments": "Oddělení",
    "d365_branch_id": "Pobočka",
    "d365_employee_id": "Zaměstnanec",
    "d365_department_id": "D365 Oddělení",
    "d365_area_id": "D365 Oblast",
    "d365_labor_wert_id": "D365 Laboratorní hodnota",
    "d365_project_id": "D365 Projekt",
    "d365_sales_channel_id": "D365 Prodejní kanál",
    "d365_vehicle_id": "Motorové vozidlo",
    "d365_branches": "Pobočky",
    "d365_employees": "Zaměstnanec",
    "d365_departments": "D365 Oddělení",
    "location_id": "Umístění",
    "consignee_id": "Příjem zboží",
    "address_id": "Doručovací adresa",
    "cost_type_id": "Typ nákladu",
    "lb_user_id": "Osoba",
    "users": "Osoby",
    "task_group_id": "Skupina úkolů",
    "task_groups": "Skupiny úkolů",
    "user_task_group": "Uživatel/Skupina úkolů",
    "user_task_groups": "Uživatelé/Skupiny úkolů",
    "products": "Produktový katalog",
    "product_group_id": "Skupina produktů",
    "product_groups": "Skupiny produktů",
    "supplier_id": "Dodavatel",
    "business_partner_id": "Obchodní partner",
    "suppliers": "Dodavatelé",
    "business_partners": "Obchodní partneři",
    "procurement_id": "Nákupní objednávka",
    "procurements": "Nákupní objednávky",
    "contract_id": "Smlouva",
    "contracts": "Smlouvy",
    "user_select_product_id": "Osoba 'Výběr produktu'",
    "user_send_order_id": "Osoba 'Objednání'",
    "user_clearing_id": "Osoba 'Objasněno'",
    "user_consignee_id": "Osoba 'Příjem zboží'",
    "user_invoice_manual_check_id": "Osoba „Ruční kontrola (faktura)“",
    "user_invoice_clearing_id": "Osoba 'Objasnění účetnictví'",
    "user_accounting_id": "Uživatel „Účetnictví“",
    "user_contract_clearing_id": "Osoba 'Objasnění smlouvy'",
    "ledger_account_id": "Účet G/L",
    "ledger_accounts": "Účetní záznamy",
    "posting_key_id": "Klíč zaúčtování",
    "posting_keys": "Účtovací klíče",
    "permission_id": "Skupina oprávnění",
    "permissions": "Skupiny oprávnění",
    "invoices": "Faktury",
    "invoice_id": "Faktura",
    "outgoing_invoice_id": "Odchozí faktura",
    "outgoing_invoices": "Odchozí faktury",
    "incoming_revenue_type": "Typ příjmu",
    "incoming_revenue_type_id": "Typ příjmu",
    "configurations": "Nastavení",
    "marketplace_id": "Tržiště",
    "provider_id": "Poskytovatel tržiště",
    "notes": "Poznámka",
    "search": "Hledat",
    "no_data": "Nebyly nalezeny žádné záznamy",
    "months": "měsíce",
    "select_valid_option": "Vyberte platný záznam.",
    "price_restricted": "Informace o cenách jsou momentálně deaktivovány.",
    "procurement_line": {
        "description": "Produkt",
        "item_number": "Číslo položky",
        "is_cost_center_fixed": "Pevná předvolba",
        "image_url": "Adresa URL obrázku",
        "webshop_url": "Adresa URL obchodu",
        "offer_number": "Číslo nabídky",
        "offer_date": "Datum nabídky",
        "include_tax": "vč. DPH {tax}",
        "offer_msg": "Podle nabídky {offer_number}",
        "offer_date_msg": "dne {offer_date}",
        "delivery_completed": "Položka dokončena",
        "total_price_brutto": "Celková hrubá cena",
        "total_price_netto": "Celková čistá cena",
        "type_total_price_brutto": "currency",
        "type_price_brutto": "currency",
        "type_total_price_netto": "currency",
        "type_price_netto": "currency"
    },
    "product_catalog": {
        "description": "Položka",
        "alias": "Popis pro vyhledávání",
        "item_number": "Číslo položky",
        "is_cost_center_fixed": "Pevné zadání",
        "image_url": "Adresa URL obrázku",
        "webshop_url": "Adresa URL obchodu",
        "offer_number": "Číslo nabídky",
        "offer_date": "Datum nabídky",
        "type_price_netto": "currency",
        "type_price_brutto": "currency",
        "form_sequence": "name,item_number,product_group_id,supplier_id,location_id,cost_center_id,is_cost_center_fixed,tax,price_netto,price_brutto,unit,image_url,webshop_url,offer_number,offer_date",
        "page": {
            "new": "Nový výrobek",
            "supplier_tooltip": "Vyberte dodavatele z kmenových dat nebo přidejte nového zadáním nového názvu.",
            "supplier_new_tooltip": "Tento dodavatel bude uložen ve vašich kmenových datech při přidávání produktu.",
            "should_save": "Uložit do Katalogu produktů",
            "sections": {
                "basic": "Základní údaje",
                "supplier": "Klasifikace a dodavatel",
                "pricing": "Ceny a daň",
                "accounting": "Účtování",
                "media_offer": "Média a nabídka",
                "permissions": "Oprávnění"
            },
            "validation": {
                "name_required": "Zadejte jméno.",
                "supplier_required": "Vyberte dodavatele nebo přidejte nového.",
                "image_url_invalid": "Zadejte prosím platnou adresu URL.",
                "webshop_url_invalid": "Zadejte prosím platnou adresu URL.",
                "tax_invalid": "Zadejte platnou sazbu daně."
            },
            "tour": {
                "name": "Uveďte významný název produktu.",
                "number": "Zde můžete zadat číslo položky produktu.",
                "product_group": "Vyberte skupinu produktů, do které produkt patří.",
                "supplier": "Vyberte dodavatele produktu, u kterého chcete produkt objednat.",
                "price": "Zadejte sazbu daně a čistou nebo hrubou cenu. Ostatní cena bude vypočtena pomocí daňové sazby.",
                "unit": "Uveďte jednotku, ve které se výrobek měří, např. „položky“, „kg“ nebo „litry“.",
                "url": "Zde můžete přidat adresu URL obrázku k produktu. Navíc, pokud je k dispozici, můžete přidat odkaz na stránku produktu v obchodě.",
                "offer": "Pokud existuje nabídka na produkt, můžete zde zadat číslo nabídky a datum, aby se zobrazily v objednávkovém PDF.",
                "btn_save": "Jakmile přidáte všechny informace, uložte produkt do katalogu produktů."
            }
        }
    },
    "product_group": {
        "form_sequence": "name,description,user_select_product_id",
        "page": {
            "new": "Nová skupina produktů",
            "no_product_group": "Bez skupiny položek",
            "validation": {
                "name_required": "Zadejte jméno."
            },
            "tour": {
                "name": "Zadejte smysluplný název skupiny produktů.",
                "btn_save": "Jakmile zadáte všechny informace, přidejte skupinu produktů."
            }
        }
    },
    "procurement": {
        "description": "Nákupní objednávka",
        "order_description": "Objednávka",
        "name": "Jméno",
        "number": "Číslo objednávky",
        "order_number_formatted": "Číslo objednávky",
        "contract_number": "Číslo smlouvy",
        "creator_id": "Vytvořeno",
        "created_at": "Datum vytvoření",
        "delivery_date": "Datum dodání",
        "delivery_address_id": "Doručovací adresa",
        "billing_address_text": "fakturační adresa",
        "status": "Stav",
        "show_notes_pdf": "Zobrazit v PDF objednávky",
        "open_value": "Otevřená hodnota objednávky",
        "open_value_recurring": "∞ dKueZ",
        "open_value_exceeds_with_invoice": "Tato faktura překračuje hodnotu objednávky.",
        "total_brutto": "Celkový hrubý",
        "total_netto": "Celková čistá",
        "total_netto_abbr": "-Síť",
        "payment_in_advance": "Platba předem",
        "has_invoices": "Faktura zaznamenána",
        "invoice_count": "Faktury (množství)",
        "completely_invoiced": "Plně vyfakturováno",
        "is_fully_allocated": "Plně vyfakturováno",
        "payment_timing": "Typ platby",
        "usage_type": "Frekvence",
        "type": "Typ objednávky",
        "type_options": {
            "single_invoice": "eKuez s jednou fakturou",
            "recurring_invoice": "dKuez s jednou fakturou",
            "recurring_contract": "dKuez s opakovanou fakturou"
        },
        "statuses": {
            "open": "Výběr produktu",
            "approved": "Objednáno",
            "ordered": "Čekání na doručení",
            "declined": "Odmítnuto",
            "completed": "Dokončeno",
            "historical-imported": "Importováno jako historie",
            "approval": "Odsouhlaseno",
            "clearing": "Objasněno",
            "draft": "Návrh"
        },
        "page": {
            "ai_fill_menu": "Vyplnit objednávku pomocí AI",
            "completely_invoiced_auto_tooltip": "Automaticky označeno systémem, protože částka alokovaná fakturami je stejná nebo vyšší než hodnota objednávky.",
            "completely_invoiced_final_invoice_tooltip": "Označeno jako plně vyfakturované pomocí {invoices}.",
            "completely_invoiced_final_invoice_tooltip_prefix": "Označeno jako plně vyfakturované pomocí ",
            "completely_invoiced_final_invoice_tooltip_separator": ", ",
            "completely_invoiced_final_invoice_tooltip_suffix": ".",
            "ai": {
                "title": "Nákupní asistent (AI)",
                "months": "Období (měsíce)",
                "products_limit": "Produkty (počet)",
                "suppliers_limit": "Dodavatelé (počet)",
                "contracts_limit": "Smlouvy (počet)",
                "order_without_template_btn": "Objednat bez šablony",
                "or_create_based_on_existing_msg": "nebo vytvořte novou objednávku na základě následujících existujících objednávek nebo smluv:",
                "recent_products": "Vaše naposledy objednané produkty",
                "top_products": "Nejlepší produkty",
                "top_suppliers": "Nejlepší dodavatelé",
                "orders_count": "{n} objednávek",
                "active_contracts": "Aktivní smlouvy",
                "contract_end_date": "Datum ukončení",
                "procurements_count": "{n} objednávek",
                "loading_text": "Zpracovává se návrh AI…",
                "processing_title": "Vytváří se vaše objednávka pomocí AI",
                "processing_subtitle": "To může trvat 15–20 sekund. Nechte prosím tuto stránku otevřenou.",
                "invoices_count": "{n} faktur",
                "magic_order": {
                    "label": "Vytvořit objednávku na základě posledních nákupních návyků",
                    "tooltip": ""
                },
                "msg_success": "Údaje objednávky byly automaticky předvyplněny",
                "msg_not_found": "Nenalezena žádná odpovídající objednávka",
                "msg_failed": "Návrh AI se nezdařil",
                "msg_not_possible": "Předvyplnění AI není možné"
            },
            "new_from_contract": "Objednávka ze smlouvy",
            "no_delivery_address": "Žádná dodací adresa",
            "no_budget": "Žádný rozpočet",
            "new": "Nová objednávka",
            "create_btn": "Zahájit objednávku",
            "copy_btn_tooltip": "Kopírovat objednávku",
            "magic_suggestions_btn_tooltip": "Získejte chytré návrhy na základě dynamických kritérií (nedávné nákupy, dodavatelé, smlouvy).",
            "magic_suggestions_no_data": "Pro vybraná kritéria nebyly nalezeny žádné návrhy AI.",
            "magic_suggestions_applied": "Návrhy AI byly použity.",
            "magic_suggestions_dialog": {
                "title": "Návrhy pro tuto objednávku",
                "message": "Vyberte pole, která chcete vyplnit na základě návrhů AI.",
                "info_based_on_last_order": "Tento návrh byl vygenerován AI na základě vaší poslední objednávky.",
                "no_data": "Pro tuto objednávku nebyly nalezeny žádné návrhy."
            },
            "offer_document": {
                "add_from_document": "Přidat z nabídky",
                "dialog_title": "Importovat položky z nabídky",
                "loading_text": "Rozpoznávání nabídky...",
                "upload_info1": "Přetáhněte PDF nabídky sem <br>nebo <br> <em>vyberte soubor</em>.",
                "upload_info2": "PDF soubory do 30 MB.",
                "preview_message": "Vyberte položky, které se mají přidat jako produkty.",
                "no_lines": "Nebyly nalezeny žádné položky nabídky.",
                "new_upload": "Zahodit a nahrát znovu",
                "retry": "Zkusit znovu",
                "retry_wait": "nebo počkejte ještě několik sekund",
                "file_invalid": "Nahrávejte pouze PDF soubory.",
                "file_too_large": "Nahrávejte pouze soubory do 30 MB.",
                "extract_failed": "Nabídku se nepodařilo rozpoznat.",
                "file_save_failed": "PDF nabídky se nepodařilo uložit.",
                "lines_applied": "Položky nabídky byly přidány.",
                "supplier_required": "Před importem položek vyberte dodavatele.",
                "supplier_recognized": "Rozpoznaný dodavatel: {supplier_name}.",
                "supplier_missing": "Vyberte nebo vytvořte dodavatele.",
                "create_supplier": "Vytvořit \"{supplier_name}\"",
                "create_supplier_confirm_title": "Vytvořit dodavatele",
                "create_supplier_confirm_message": "Chcete vytvořit \"{supplier_name}\" jako nového dodavatele?",
                "create_supplier_confirm_btn": "Vytvořit",
                "create_supplier_success": "Dodavatel vytvořen.",
                "create_supplier_failed": "Dodavatele se nepodařilo vytvořit.",
                "supplier_note_website": "Web",
                "supplier_note_contact": "Kontakt",
                "supplier_note_extra_ibans": "Další IBANy"
            },
            "delivery_date_tooltip": "Termín dodání bude vytištěn na objednávkovém PDF a poté může být zaslán dodavateli.",
            "order_sender": "Umístění objednávky",
            "product_selector": "Výběr produktu",
            "product_search": "Hledat produkty",
            "before_leave_msg": "Vaše nákupní objednávka nebyla uložena. Opravdu chcete stránku opustit?",
            "confirm_without_approval_limit_msg": "Žádná z vybraných osob nemá potřebný schvalovací limit pro hodnotu této objednávky. Další schválení lze přidat později. Opravdu chcete pokračovat?",
            "confirm_without_approval_limit_title": "Limit schválení",
            "confirm_product_selection_without_product_msg": "Nevybrali jste žádný produkt. Opravdu chcete pokračovat?",
            "confirm_product_selection_without_product_title": "Není vybrán žádný produkt",
            "no_approval_limit_msg": "Váš limit schválení není pro tuto objednávku dostatečný. Přidejte ke schválení další osobu s odpovídajícím limitem schválení.",
            "no_approval_limit_title": "Limit schválení",
            "product_group_missing_msg": "Všechny produkty musí být přiřazeny do skupiny produktů. Přejděte na kartu „Skupiny produktů“ nad seznamem produktů a přiřaďte každému produktu skupinu produktů.",
            "product_group_missing_title": "Přiřadit skupinu produktů",
            "product_group_missing_btn": "Rozuměl",
            "min_approval_one_person": "1 osoba",
            "min_approval_qty": "{qty} různých osob",
            "min_approval_error_msg": "Schválení pro tuto objednávku nestačí. Přidejte další osobu ke schválení. Tato nákupní objednávka musí být schválena <b>nejméně {min_approval_msg}</b>.",
            "min_approval_error_title": "Nedostatečné schválení",
            "order_not_completed_msg": "Nezadali jste objednávky na všechny produkty ani jste je nepotvrdili. Ujistěte se, že jste objednali všechny produkty v seznamu produktů a v případě potřeby je potvrďte.",
            "order_not_completed_title": "Nejprve dokončete objednávky",
            "order_not_completed_btn": "Rozuměl",
            "confirm_delivery_not_completed_msg": "Nepotvrdili jste všechny příjemky zboží. Opravdu chcete dokončit nákupní objednávku? <br> <i>Tuto akci nelze vrátit zpět</i>.",
            "confirm_delivery_not_completed_title": "Nevyřízené příjmy zboží",
            "confirm_delivery_not_completed_btn": "Kompletní",
            "default_confirm_btn": "Pokračovat",
            "budget_exceeded_msg": "Rozpočet překročen",
            "approval_limit_exceeded_msg": "Překročen limit schválení",
            "external_order_number_msg": "Zadejte externí číslo objednávky.",
            "external_order_number_title": "Zadejte externí číslo objednávky",
            "no_edit_permission": "Chybí vám oprávnění upravovat data. Odešlete objednávku k vymazání prostřednictvím akcí, abyste provedli změny v datech.",
            "add_invoice_after_order_message": "Fakturu můžete vytvořit po zahájení požadavku na nákup.",
            "no_invoice": "Pro tento požadavek na nákup zatím nebyly zaznamenány žádné faktury.",
            "tabs": {
                "lines": "Položky",
                "invoices": "Faktury"
            },
            "delivery_dialog": {
                "title": "Potvrďte příjem zboží",
                "confirm_btn": "Potvrdit",
                "message": "Zadejte nedávno přijaté množství.<br> Chybí {missing_qty} z {quantity} {unit}.",
                "qty_exceeded_msg": "Chybějící množství nesmí být překročeno.",
                "qty_must_be_greater_msg": "Množství musí být větší než 0.",
                "invalid_format": "Použijte platný číselný formát."
            },
            "order_sender_dialog": {
                "title": "Výchozí role pro umístění objednávky",
                "info": "Osoba v kroku 'Umístění objednávky' je určena na základě výchozích rolí pro oddělení, společnost, výchozích globálních rolí a osoby, která vytvořila nákupní objednávku. Osoba v horní části seznamu je pro úkol předem vybrána."
            },
            "consignee_dialog": {
                "title": "Výchozí role pro příjem zboží",
                "info": "Osoba v kroku 'Příjem zboží' je určena na základě výchozích rolí pro oddělení, společnost, výchozích globálních rolí a osoby, která vytvořila nákupní objednávku. Osoba v horní části seznamu je pro úkol předem vybrána."
            },
            "select_product_dialog": {
                "title": "Výchozí role pro výběr produktu",
                "info": "Osoba v kroku 'Výběr produktu' je určena na základě výchozích rolí pro oddělení, společnost, výchozích globálních rolí a osoby, která vytvořila nákupní objednávku. Osoba v horní části seznamu je pro úkol předem vybrána."
            },
            "marketplace_change_dialog": {
                "title": "Objednávka bude zrušena",
                "info": "Byla zjištěna změna společnosti. Na tržišti {marketplace_name} však existuje objednávka, která není spojena s novou společností {client_name}. Pokud budete pokračovat, tato objednávka bude zrušena.",
                "btn_confirm": "Zrušit objednávku"
            },
            "dialog_assignment": {
                "department_form": "Oddělení ve formě",
                "department_creator": "Oddělení objednatele",
                "client_form": "Společnost ve formě",
                "client_creator": "Společnost objednané osoby",
                "no_selection": "Dosud nevybráno",
                "no_action": "Nelze použít",
                "configuration": "Výchozí globální role"
            },
            "draft": {
                "title": "Návrh",
                "save": "Uložit koncept",
                "delete": "Smazat koncept",
                "confirm_before_delete_msg": "Opravdu chcete tento koncept trvale smazat?",
                "confirm_before_delete_title": "Smazat koncept",
                "confirm_before_delete_btn": "Vymazat"
            },
            "punchout": {
                "pending_msg": "Existují nevyřízené produkty od Punchout.",
                "error_title": "Chyba při vyražení",
                "error_msg": "Vyskytla se chyba. Zkontrolujte prosím nastavení Punch-out nebo kontaktujte osobu s administrátorskými právy.",
                "error_start_url_msg": "Nebyla zadána žádná počáteční adresa URL, nelze zahájit zvýraznění.",
                "error_invalid_domain_msg": "Přihlašovací údaje jsou neplatné. Zkontrolujte konfiguraci punch-out nebo kontaktujte svého administrátora.",
                "error_invalid_credentials_msg": "{provider} odmítl přihlášení pro e-mail \"{email}\", protože doména \"{domain}\" není povolena v účtu {provider}. Punch-out proto nelze spustit.",
                "no_config": "Pro použití Punch-out nejprve nastavte konfiguraci.",
                "no_config_by_client": "Tento dodavatel není povolen pro aktuálně vybranou společnost. <br>Vyberte prosím kompatibilní společnost nebo upravte nastavení.",
                "pending_dialog": {
                    "title": "Nevyřízené produkty od Punchout",
                    "add_products": "Přidat do objednávky",
                    "add_all_products": "Přidat vše do objednávky",
                    "delete_products": "Odebrat produkty"
                },
                "log_dialog": {
                    "title": "{supplier_name} Žádost",
                    "request": "Žádost",
                    "response": "Odpověď",
                    "no_log": "Žádný záznam",
                    "url": "Url",
                    "header": "Header",
                    "method": "Method",
                    "body": "Body"
                },
                "delete_dialog": {
                    "title": "Odebrat produkty od {supplier} #{index}",
                    "info1": "Opravdu chcete odstranit všechny následující produkty z {supplier} #{index}?",
                    "info2": "Tuto akci nelze vrátit zpět.",
                    "delete_btn": "Odstranit"
                },
                "loading": "V otevřeném vyskakovacím okně dokončete výběr produktu. Pokud se nezobrazí žádné vyskakovací okno, musíte jej nejprve povolit.",
                "can_not_edit": "Vyražené produkty nelze upravovat. Proveďte prosím Punch-out znovu nebo smažte celý nákupní košík.",
                "no_provider_found": "Vybraný poskytovatel Punch-out bohužel zatím není podporován."
            },
            "download_pdf": {
                "title": "Stáhnout PDF",
                "confirm_btn": "Potvrdit",
                "title_confirm_save_changes": "Uložit neuložená data",
                "text_confirm_save_changes": "Chcete uložit neuložená data a aplikovat je na objednávkový dokument?",
                "invalid_form": "Prosím, vyplňte všechna povinná pole ve formuláři před pokračováním v akci."
            },
            "lines": {
                "no_line": "Nejsou vybrány žádné produkty, přidejte produkty.",
                "add_lines_from_contract": "Přidat všechny položky ze smlouvy",
                "show_all_info": "Pokročilé zobrazení",
                "invoice": {
                    "title": "Faktura",
                    "created_at": "Zaznamenáno",
                    "date": "Datum faktury",
                    "created_by": "Vytvořil"
                },
                "automatic_order": "Odeslat elektronicky",
                "automatic_ordered": "Elektronicky odesláno",
                "supplier_connect_order": "Odeslat přes SupplierConnect",
                "manual_order_confirmation": "Potvrdit ručně",
                "confirm_order": "Potvrďte objednávku",
                "finish_order": "Dokončit objednávku",
                "order_finished": "Objednávka dokončena",
                "confirm_order_tooltip": "Vezměte prosím na vědomí, že je třeba <b>odeslat objednávku dodavateli e-mail</b>, objednávka nebude <b>přenášena elektronicky.</b>",
                "ordered_at": "Odesláno",
                "ordered_by": "Podle",
                "confirm_receipt": "Potvrdit převzetí zboží",
                "no_cost_center": "Žádné nákladové středisko",
                "include_taxes": "vč. káď",
                "budget": "Rozpočet",
                "no_budget": "Žádný rozpočet",
                "no_product_group": "Žádná skupina produktů",
                "no_ledger_account": "Žádný účet v hlavní knize",
                "select_product": "Výběr produktu",
                "quantity_to_show": "přijato: <b>{quantity_received}/{quantity}</b>",
                "delivery_completed": "Položka dokončena",
                "from": "z",
                "item_number": "Předmět číslo. #",
                "delete_msg": "Opravdu chcete tento produkt odstranit?",
                "delete_title": "Odebrat produkt",
                "delete_btn": "Odstranit",
                "automatic_order_dialog": {
                    "confirm_order": "Odeslat objednávku",
                    "confirm_order_btn": "Poslat",
                    "finish_order": "Dokončit objednávku",
                    "finish_order_btn": "Dokončit",
                    "info1": "Chcete tuto objednávku <span style=\"font-weight: bold\">teď</span> <span style=\"font-weight: bold\">elektronicky odeslat</span> dodavateli?",
                    "info2": "Tuto akci nelze vrátit zpět."
                },
                "order_dialog": {
                    "confirm_order": "Potvrďte objednávku",
                    "confirm_order_btn": "Potvrdit",
                    "finish_order": "Dokončit objednávku",
                    "finish_order_btn": "Dokončit",
                    "info1": "Předali jste objednávku dodavateli? (např. nebo faxem)",
                    "info2": "Tuto akci nelze vrátit zpět."
                },
                "more_actions": {
                    "delete_products": "Odebrat produkty",
                    "add_external_id": "Přidejte externí číslo objednávky",
                    "download_pdf": "Objednávka (PDF)",
                    "download_pdf_with_attachments": "Objednávka včetně přílohy PDF",
                    "write_email": "Napsat e-mail",
                    "email_with_pdf": "E-mail s PDF",
                    "show_cxml": "Zobrazit Punchout CXML"
                },
                "file": {
                    "open_btn": "Otevřete PDF",
                    "add_btn": "Přidat PDF",
                    "upload_info1": "Přetáhněte sem <br>nebo <br> <em>vyberte soubor</em>.",
                    "upload_info2": "Soubory PDF do velikosti 30 MB.",
                    "delete_msg": "Opravdu chcete tento dokument odstranit?",
                    "delete_title": "Odebrat dokument",
                    "delete_btn": "Odstranit",
                    "delete_error_msg": "Dokument se nepodařilo odstranit."
                }
            },
            "validation": {
                "delivery_date_format": "Zadejte prosím datum doručení.",
                "client_id_required": "Vyberte prosím společnost.",
                "department_id_required": "Vyberte prosím oddělení.",
                "department_id_required_client_missing": "Nejprve vyberte společnost.",
                "cost_center_id_required": "Vyberte prosím nákladové středisko.",
                "cost_center_id_required_filters_missing": "Nejprve vyberte společnost a oddělení.",
                "cost_center_id_required_department_missing": "Nejprve vyberte oddělení.",
                "cost_center_id_required_client_missing": "Nejprve vyberte společnost.",
                "ledger_account_id_required": "Vyberte prosím účetní účet.",
                "consignee_id_required": "Vyberte prosím odpovědnou osobu.",
                "delivery_address_id_required": "Vyberte prosím doručovací adresu.",
                "billing_address_text_required": "Ve firemních údajích chybí fakturační adresa.",
                "usage_type_required": "Vyberte rytmus.",
                "payment_timing_required": "Vyberte typ platby."
            },
            "tour": {
                "main": {
                    "description": "V prvních polích zadejte název požadavku na objednávku, svou společnost a oddělení, pro které má být objednávka provedena. Oddělení je filtrováno podle společnosti a nákladové středisko podle oddělení.",
                    "organization": "Zadejte společnost, oddělení a nákladové středisko pro nákupní objednávku. Seznam oddělení je filtrován podle vybrané společnosti a seznam nákladových středisek je filtrován podle vybraného oddělení.",
                    "address": "Doručovací adresa bude sdělena dodavateli. Můžete si vybrat z adres společnosti, osoby odpovědné za příjem zboží a vlastních adres.",
                    "total": "Zde vidíte celkovou hodnotu vaší objednávky, která je součtem vybraných produktů.",
                    "delivery_date": "Termín dodání je možné zaznamenat po převzetí zboží pro účely dokumentace. Nebude odesláno dodavateli.",
                    "product_selector": "To ukazuje, kdo je zodpovědný za výběr produktu v dalším kroku. Záleží na různých výchozích nastaveních rolí, pro více podrobností klikněte na ikonu info.",
                    "order_sender": "To ukazuje, kdo je zodpovědný za zadání objednávky, což závisí na různých výchozích nastaveních rolí. Pro více podrobností klikněte na ikonu info.",
                    "consignee": "Vyberte osobu, která zboží obdrží, a v posledním kroku objednávky potvrďte příjem pro dokončení procesu.",
                    "approvers": "Zde vidíte, zda bylo pro vybrané nákladové středisko nastaveno schválení. Můžete také přidat lidi ke schválení.",
                    "product_search": "Zde můžete vyhledat produkt v interním katalogu produktů a přidat jej do objednávky.",
                    "punchout": "Zde si můžete vybrat produkty z integrovaných tržišť, jako je Amazon nebo Mercateo. Výběr produktu může být po schválení předán elektronicky na tržiště.",
                    "new_product": "Pokud požadovaný produkt není v katalogu produktů, můžete jej přidat do objednávky zde.",
                    "save_btn": "Po zadání všech požadovaných informací můžete zahájit proces objednávky a přejít k dalšímu kroku."
                },
                "product": {
                    "pdf": "Zde můžete přidat dokumenty k produktu.",
                    "remove": "Kliknutím sem můžete také odebrat produkty z výběru.",
                    "more_actions": "Číslo externí objednávky zde můžete doložit po obdržení.",
                    "tabs": "Zde můžete seskupit pohled na své produkty podle dodavatele, nákladového střediska nebo skupiny produktů.",
                    "expand_view": "Zde můžete zobrazit nebo skrýt rozšířená nastavení pro produkty a vybrat nákladové středisko, dodací adresu nebo skupinu produktů."
                },
                "new_product": {
                    "name": "Zadejte smysluplný název produktu.",
                    "number": "Můžete také zadat číslo položky pro produkt.",
                    "supplier": "Vyberte dodavatele, u kterého je produkt nabízen nebo u kterého má být objednán.",
                    "price": "Zadejte sazbu daně a čistou nebo hrubou cenu. Ostatní cena bude vypočtena pomocí daňové sazby.",
                    "unit": "Zadejte měrnou jednotku produktu, například „položky“, „kg“ nebo „litry“.",
                    "url": "Můžete přidat adresu URL obrázku produktu a odkaz na stránku produktu v obchodě, pokud je k dispozici.",
                    "offer": "Pokud existuje nabídka na produkt, můžete zde zadat číslo nabídky a datum, aby se zobrazily v objednávkovém PDF.",
                    "should_save": "Zde zvolíte přidání vytvořeného produktu do katalogu produktů. Tím je zajištěno, že tento konkrétní produkt bude dostupný pro budoucí objednávky.",
                    "save_btn": "Po zadání všech informací přidejte produkt do objednávky."
                },
                "cost_center_view": "Nákladová střediska lze také přiřadit k jednotlivým produktům v objednávce. Poté lze pro produkt vybrat dodací adresy spojené s nákladovým střediskem.",
                "product_group_view": "Každý produkt lze přiřadit do skupiny produktů. Osoba odpovědná za skupinu produktů obdrží na časové ose úkol upravit nebo potvrdit výběr produktu.",
                "send_order": {
                    "send_btn": "V kroku potvrzení objednávky můžete elektronicky odeslat objednávku nebo potvrdit objednávku provedenou prostřednictvím emailu u dodavatele.",
                    "more_actions": "V možnostech pro vybraného dodavatele můžete vygenerovat objednávkové PDF nebo e-mail s nebo bez objednávkového PDF pro dodavatele. Tímto způsobem můžete zadat objednávku společnosti nebo zadat dotaz prostřednictvím e-mailu."
                },
                "delivery_btn": "Pokud jste obdrželi část dodávky nebo celou objednávku, můžete to uvést zde. Položky zde můžete také označit jako dokončené. Potvrzené převzetí zboží bude rovněž uvedeno v časové ose."
            }
        }
    },
    "quantity": "Množství",
    "price_netto": "Čistá cena",
    "price_brutto": "Hrubá cena",
    "unit": "Jednotka",
    "default_unit": "Položka",
    "tenant": {
        "tab_general": "Obecné",
        "description": "Nájemce",
        "main_language": "Jazyk náhrady",
        "show_invoices": "Zobrazit nabídku faktur",
        "monthly_document_limit": "Dokumenty za měsíc",
        "base_price": "Základní cena",
        "price_extra_document": "Cena každého dalšího dokumentu",
        "monthly_procurement_limit": "Objednávky za měsíc v základní ceně",
        "monthly_invoice_limit": "Faktury za měsíc v základní ceně",
        "base_price_procurement": "Základní cena nákupních objednávek",
        "base_price_invoice": "Základní cena faktur",
        "price_extra_procurement": "Cena za každou další objednávku",
        "price_extra_invoice": "Cena za každou další fakturu",
        "invoice_recognition_unit_price": "Cena za rozpoznání faktury na dokument",
        "invoice_recognition_custom_field_unit_price": "Cena za doklad s vlastními poli",
        "historical_onboarding_recognition_unit_price": "Cena za rozpoznání dokladu při onboardingu",
        "ai_validation_unit_price": "Cena za validaci AI včetně skórování na doklad",
        "easybill_id": "Easybill ID",
        "bank_account": "Číslo účtu",
        "bank_account_owner": "Majitel účtu",
        "bank_bic": "BIC",
        "bank_country": "Země banky",
        "bank_code": "Bankovní kód",
        "bank_iban": "IBAN",
        "bank_name": "Jméno banky",
        "address": "fakturační adresa",
        "sepa_agreement": "Smlouva o SEPA inkasu",
        "sepa_agreement_date": "SEPA – datum vstupu mandátu",
        "sepa_mandate_reference": "Odkaz na mandát",
        "automatic_billing": "Automaticky generovat fakturaci",
        "automatic_billing_mail": "Automaticky odeslat fakturaci e-mail",
        "bank": "Bankovní spojení",
        "datev": "DATEV",
        "billing_address_name": "Společnost",
        "billing_address_consignee_name": "Jméno příjemce",
        "billing_address_street": "Ulice a č.",
        "billing_address_zipcode": "poštovní směrovací číslo",
        "billing_address_city": "Město",
        "billing_address_state": "Stát",
        "billing_address_country": "Země",
        "billing_address_phone": "Telefonní číslo",
        "contact_email": "Kontaktní e-mail",
        "billing_email": "Fakturační email",
        "contact": "Kontaktní informace",
        "sepa": "SEPA inkaso",
        "add_sepa": "Přidejte SEPA inkaso",
        "remove_sepa": "Zrušit SEPA inkaso",
        "import_invoice_email": "Automaticky importovat faktury prostřednictvím e-mailu",
        "send_email_notifications": "Odesílat e-mailová upozornění",
        "storage_usage": "Využití úložiště",
        "storage_current": "Aktuální využití",
        "storage_included_gb": "Zahrnuté úložiště (GB)",
        "storage_price_per_gb": "Cena za každý další GB",
        "storage_free_included": "Zahrnutý bezplatný objem",
        "storage_billable": "Fakturovatelné GB",
        "storage_billable_price": "Měsíční dodatečné náklady",
        "storage_billing_hint": "Prvních {included} GB je zdarma. Každý další započatý GB se účtuje částkou {price}.",
        "tab_mailbox": "Poštovní schránky",
        "debit_credit_reverse": "Vyměnit účet/protiúčet",
        "default_decimal_places": "Výchozí desetinná místa",
        "tab_sso": "Single Sign-On (SAML)",
        "sso_saml_enabled": "Povolit SAML přihlášení",
        "sso_saml_provider_label": "Text tlačítka přihlášení",
        "sso_saml_entity_id": "Entity ID identity providera",
        "sso_saml_sso_url": "SSO URL identity providera",
        "sso_saml_x509_cert": "X509 certifikát identity providera (PEM)",
        "sso_saml_sp_entity_id": "Entity ID service providera (volitelné)",
        "sso_saml_attr_email": "Název e-mailového atributu (volitelné)",
        "sso_saml_help": "Aktivujte až po zadání hodnot od identity providera.",
        "sso_saml_validation_required": "Vyplňte všechna povinná SAML pole."
    },
    "datev_access": {
        "description": "Integrace DATEV",
        "label_log": "Společnost DATEV (datev_client_id)",
        "label_log_fields": "datev_client_id",
        "connected_info": "Připojení k DATEV bylo navázáno.",
        "disconnected_info": "Připojení k DATEV bylo odstraněno.",
        "connected_client_info": "Připojení ke společnosti DATEV {datev_client_id} bylo navázáno.",
        "disconnected_client_info": "Připojení ke společnosti DATEV {datev_client_id} bylo deaktivováno."
    },
    "ms365_access": {
        "description": "Integrace D365",
        "connected_info": "Připojení k D365 bylo navázáno.",
        "disconnected_info": "Připojení k D365 bylo odstraněno.",
        "data_loaded_info": "Data z D365 byla ručně načtena.",
        "journal_created_info": "D365 deník byl přidán.<br>Název deníku: {journal_name} <br>URL organizace: {org_url}.",
        "journal_edited_info": "Název D365 deníku byl upraven: {journal_name}."
    },
    "client": {
        "description": "Společnost",
        "alias": "Alias společnosti",
        "tab_invoice_recognition_prompt": "Vlastní prompt",
        "min_approval": "Minimální počet schvalovatelů",
        "branch_required": "Pobočka je vyžadována pro formulář faktury.",
        "department_required": "Oddělení je vyžadováno pro formulář faktury.",
        "cost_center_required": "Nákladové středisko je povinné pro objednávkový formulář.",
        "client_number": "Číslo",
        "consultant_number": "Číslo poradce",
        "ledger_account_length": "Délka účetního účtu",
        "vat_number": "DIČ",
        "address_name": "Jméno",
        "consignee": "Jméno příjemce – fakturační adresa",
        "dropoff_location": "Místo převzetí – fakturační adresa",
        "address": "Ulice a č. - Fakturační adresa",
        "address_complement": "Ulice 2 – Fakturační adresa",
        "country": "Země – fakturační adresa",
        "zipcode": "PSČ – fakturační adresa",
        "city": "Město – fakturační adresa",
        "phone_country_code": "Telefonní kód země – fakturační adresa",
        "phone_number": "Telefonní číslo – fakturační adresa",
        "can_delete_document_directly": "Dokumenty lze smazat bez vymazání.",
        "default_product_tax": "Standardní daňová sazba (%)",
        "default_product_currency": "Výchozí měna",
        "default_product_unit": "Výchozí jednotka",
        "invoice_recognition_prompt": "Vlastní prompt pro rozpoznání faktur",
        "form_sequence": "name,email,client_number,currency,min_approval,user_select_product_id,user_send_order_id,user_clearing_id,user_consignee_id,user_invoice_manual_check_id,user_invoice_clearing_id",
        "page": {
            "tab_general": "Obecné",
            "tab_bank_data": "Bankovní údaje",
            "tab_billing_address": "fakturační adresa",
            "tab_shipping_address": "Dodací adresy",
            "tab_default_roles": "Výchozí role",
            "tab_communication_signature": "Podpis komunikace",
            "tab_permissions": "Oprávnění",
            "tab_departments": "Oddělení",
            "tab_cost_centers": "Nákladová místa",
            "tab_ledger_accounts": "Účetní záznamy",
            "tab_required_fields": "Povinná pole",
            "tab_datev_csv": "DATEV CSV Export",
            "new": "Nová společnost",
            "invoice_recognition_prompt_placeholder": "Např. použijte tyto pokyny při rozpoznávání faktur pro tuto společnost.",
            "select_logo": "Vyberte Logo",
            "select_logo_tooltip_content": "Přidejte logo, které bude vytištěno na objednávkových dokumentech vašich schválených objednávek. Nejlepší je použít soubor obrázku s průhledným pozadím.",
            "communication_signature_html": "Podpis komunikace s dodavatelem",
            "communication_signature_html_hint": "Tento HTML podpis se automaticky předvyplní v externí komunikaci s dodavatelem u dokumentu. Podporováno je HTML formátování.",
            "communication_signature_editor_visual": "Vizuální",
            "communication_signature_editor_html": "HTML",
            "communication_signature_editor_visual_disabled_hint": "Vizuální editor je pro tento HTML kód vypnutý, aby zůstalo zachováno jeho formátování.",
            "communication_signature_placeholders": "Zástupné symboly",
            "communication_signature_placeholders_hint": "Kliknutím na zástupný symbol jej vložíte na aktuální pozici kurzoru v HTML editoru.",
            "communication_signature_placeholder_first_name": "Jméno zaměstnance",
            "communication_signature_placeholder_last_name": "Příjmení zaměstnance",
            "communication_signature_placeholder_name": "Celé jméno zaměstnance",
            "communication_signature_placeholder_email": "E-mail zaměstnance",
            "communication_signature_placeholder_company_name": "Název společnosti",
            "communication_signature_placeholder_company_email": "E-mail společnosti",
            "communication_signature_preview": "Náhled podpisu",
            "communication_signature_preview_hint": "Používá ukázková data zaměstnance a aktuální data společnosti, pokud jsou vyplněna.",
            "communication_signature_preview_empty": "Přidejte výše podpis, aby se zde zobrazil náhled.",
            "select_letterhead": "Vyberte hlavičkový papír",
            "select_letterhead_tooltip_content": "Přidejte hlavičkový papír, který bude vytištěn na objednávkový dokument vašich schválených objednávek.",
            "billing_address": "fakturační adresa",
            "state_placeholder": "Select state/region",
            "state_tooltip_content": "Used to calculate holidays.",
            "roles": "Výchozí nastavení obecné role",
            "user_clearing_id_tooltip_content": "Pro objasnění procesů objednávání.",
            "user_invoice_clearing_id_tooltip_content": "Pro upřesnění při vyplňování faktur.",
            "bank_accounts_title": "Bankovní účty",
            "bank_accounts_hint": "Zde můžete spravovat více firemních bankovních účtů. IBAN a BIC se při zadání validují.",
            "bank_accounts_empty": "Zatím nebyly přidány žádné další bankovní účty.",
            "add_bank_account": "Přidat bankovní účet",
            "bank_account_label": "Označení",
            "bank_account_holder": "Majitel účtu",
            "bank_account_bank_name": "Název banky",
            "bank_account_iban": "IBAN",
            "bank_account_bic": "BIC",
            "no_selection": "Nebyla vybrána žádná konkrétní společnost, proto je sdílena mezi všemi.",
            "validation": {
                "name_required": "Zadejte jméno.",
                "name_max_length": "Nesmí přesáhnout 50 znaků.",
                "email_invalid": "Prosím zadejte platnou emailovou adresu.",
                "iban_invalid": "Zadejte prosím platné číslo IBAN.",
                "bic_invalid": "Zadejte platný BIC.",
                "bank_account_iban_required": "Zadejte IBAN pro tento bankovní účet.",
                "bank_account_iban_duplicate": "Tento IBAN již byl přidán.",
                "bank_accounts_invalid": "Zkontrolujte sekci bankovních účtů.",
                "client_number_invalid": "Prosím zadejte platné číslo.",
                "min_approval_invalid": "Prosím zadejte platné číslo.",
                "address_incomplete": "Vyplňte prosím povinné údaje o adrese.",
                "delivery_address_missing": "Přidejte alespoň jednu doručovací adresu.",
                "error_address_incomplete": "Prosím, doplňte povinné údaje pro dodací adresu."
            },
            "tour": {
                "name": "Začněte zadáním názvu vaší společnosti.",
                "email": "Zadejte email Vaší společnosti, na který má být zaslána např. zásilka faktury.",
                "timeline_assignment": "Volitelně můžete předem přiřadit odpovědné osoby pro různé kroky nákupních objednávek pro společnost. Například pokud vždy existuje osoba odpovědná za schvalování objednávek.",
                "billing_address": "Fakturační adresa je vyžadována pro objednávku a může být zaslána dodavateli s objednávkou.",
                "shipping_address": "Zde můžete zadat jednu nebo více dodacích adres, které lze vybrat v objednávce.",
                "btn_save": "Po zadání všech požadovaných informací přidejte firmu."
            }
        }
    },
    "client_form_config": {
        "field": "Pole",
        "form": "Formulář",
        "required": "Povinné",
        "not_available_for_d365": "Konfigurace povinných polí pro faktury není k dispozici, protože při integraci s D365 se používají validační pravidla D365."
    },
    "department": {
        "description": "Oddělení",
        "code": "Číslo",
        "form_sequence": "name,code,client_id,user_select_product_id,user_send_order_id,user_clearing_id,user_consignee_id",
        "page": {
            "new": "Nové oddělení",
            "tab_general": "Obecné",
            "tab_clients": "Klienti",
            "tab_cost_centers": "Nákladová místa",
            "tab_approvers": "Schvalovatelé",
            "tab_permissions": "Skupiny oprávnění",
            "tab_employees": "Zaměstnanci",
            "tab_assignment": "Přiřazení rolí",
            "validation": {
                "name_required": "Zadejte jméno.",
                "email_required": "Prosím zadejte platnou emailovou adresu."
            },
            "tour": {
                "name": "Začněte zadáním názvu oddělení.",
                "client": "Pokud oddělení přiřadíte společnosti, lze oddělení vybrat pouze v rámci této společnosti při vytváření objednávky.",
                "timeline_assignment": "Můžete určit odpovědné osoby pro různé kroky nákupních objednávek pro oddělení. Například pokud za příjem zboží za každé oddělení odpovídá vždy jedna konkrétní osoba.",
                "cost_centers": "Zde můžete k oddělení přiřadit existující nákladová střediska. Pokud nepřiřadíte žádná nákladová střediska, lze při vytváření nákupních objednávek pro oddělení vybrat pouze nákladová střediska, která nejsou přiřazena žádnému oddělení.",
                "employees": "Můžete přidat různé osoby, které jsou součástí tohoto oddělení. Když jednotlivci z tohoto oddělení vytvoří nákupní objednávky, oddělení bude předvyplněno.",
                "btn_save": "Jakmile poskytnete všechny informace, přidejte oddělení."
            }
        }
    },
    "permission": {
        "description": "Skupina oprávnění",
        "name": "Jméno",
        "page": {
            "new": "Nová skupina oprávnění",
            "validation": {
                "name_required": "Zadejte jméno."
            },
            "tour": {
                "name": "Zde můžete vytvořit skupinu oprávnění. Tuto skupinu pak můžete přiřadit k různým entitám (oddělení, produkty z katalogu produktů, skupiny produktů atd.). Jednotlivcům můžete také přiřadit jednu nebo více skupin oprávnění. Pokud by entita neměla mít žádná omezení oprávnění, nepřiřazujte skupinu."
            },
            "no_selection": "Není vybráno žádné oprávnění, proto je viditelné pro všechny."
        }
    },
    "task_group": {
        "description": "Skupina úkolů",
        "name": "Název",
        "priority_approval_limit": "Úroveň priority schvalovacího limitu",
        "page": {
            "new": "Nová skupina úkolů",
            "validation": {
                "name_required": "Prosím, zadejte název."
            },
            "tour": {
                "name": "Zde můžete vytvořit skupinu úkolů. Poté můžete úkoly přiřadit do této skupiny."
            },
            "no_selection": "Není vybrána žádná skupina úkolů"
        }
    },
    "budget": {
        "description": "Rozpočty",
        "label_log": "value€ (start - end)",
        "label_log_fields": "value,start,end",
        "value": "Množství",
        "type_value": "currency",
        "start": "Platnost od",
        "end": "v platnosti, dokud",
        "add_foreach_ledger_account": "Vložit všechny účty v hlavní knize",
        "component": {
            "validation": {
                "end_date_before_start_date": "Datum ukončení nemůže být před datem zahájení.",
                "end_date_required": "Datum ukončení zde nemůže být prázdné.",
                "time_overlap": "Rozpočty se nemohou časově překrývat.",
                "field_missing": "Zadejte prosím všechny informace."
            }
        }
    },
    "address": {
        "description": "Doručovací adresa",
        "description_plural": "Dodací adresy",
        "address_name": "Jméno",
        "consignee": "Jméno příjemce",
        "dropoff_location": "Místo převzetí",
        "address": "Ulice a č.",
        "address_complement": "Ulice č. 2",
        "complement": "Ulice č. 2",
        "country": "Země",
        "zipcode": "PSČ",
        "city": "Město",
        "phone_country_code": "Telefonní předvolba země",
        "phone_number": "Telefonní číslo",
        "component": {
            "new": "Nová dodací adresa",
            "copy_btn": "Zkopírujte fakturační adresu",
            "required_field": "Vyplňte prosím povinná pole adresy.",
            "phone_required": "Zadejte prosím obě informace.",
            "no_address": "Žádná dodací adresa"
        }
    },
    "cost_center": {
        "name": "Jméno",
        "number": "Číslo",
        "free_budget": "Dostupný rozpočet",
        "description": "Nákladové středisko",
        "label_log": "cost_center_name",
        "budgets": "Rozpočty",
        "form_sequence": "name,number",
        "page": {
            "new": "Nové nákladové středisko",
            "department_tooltip_content": "Která oddělení smějí používat tohoto dodavatele.",
            "tab_general": "Obecné",
            "tab_budgets": "Rozpočty",
            "tab_shipping_address": "Dodací adresy",
            "tab_approvers": "Schvalovatelé",
            "tab_permissions": "Skupiny oprávnění",
            "tab_departments": "Oddělení",
            "tab_clients": "Klienti",
            "validation": {
                "name_required": "Zadejte jméno.",
                "number_required": "Zadejte číslo.",
                "number_length": "Musí mít maximálně 36 znaků a může mít pouze mezery uprostřed.",
                "number_exists": "Číslo již existuje."
            },
            "tour": {
                "name_number": "Zadejte název a jedinečné číslo nákladového střediska.",
                "budget": "Ke svému nákladovému středisku můžete přiřadit různé rozpočty a také rozpočty přiřadit k účtu hlavní knihy.",
                "approver": "Zde definujte, kdo by měl schvalovat nákupní objednávky s tímto nákladovým střediskem. Při vytváření nákupních objednávek lze přidat další schvalovatele.",
                "department": "Zde můžete definovat, ve kterých odděleních lze nákladové středisko používat. Pokud zde žádná oddělení nepřidáte, lze nákladové středisko vybrat ve všech odděleních.",
                "btn_save": "Jakmile zadáte všechny potřebné informace, přidejte nákladové středisko do databáze."
            }
        }
    },
    "bank_statement": {
        "abbr": "BS",
        "description": "Nahrát bankovní výpis",
        "transactions_menu": "Transakce z bankovních výpisů",
        "page": {
            "upload": {
                "title": "Nahrát bankovní výpis",
                "info": "Nahrajte strukturovaný bankovní výpis.",
                "client_hint": "Vybraná společnost bude přiřazena k nahranému bankovnímu výpisu a jeho transakcím.",
                "client_required": "Před nahráním prosím vyberte společnost.",
                "supported_hint": "Podporuje XML camt.052/.053/.054 a textové soubory MT940.",
                "error_invalid": "Podporované formáty jsou XML camt.052, camt.053, camt.054 a textové bankovní výpisy MT940.",
                "abort_upload": "Zrušit nahrání",
                "processing_in_background_notice": "Bankovní výpis byl uložen. {count} položek se nyní zpracovává na pozadí.",
                "large_statement_notice": "Bankovní výpis s {count} položkami byl nahrán. Automatické párování bylo u tohoto velkého nahrání přeskočeno, aby se nahrání nezablokovalo.",
                "account_identifier_match_notice": "Nahraný výpis obsahuje pouze identifikátor účtu {identifier}, nikoli platný IBAN. Nebyl vytvořen žádný nový firemní bankovní účet. Tento identifikátor patří k již uloženému IBAN {iban}.",
                "account_identifier_only_notice": "Nahraný výpis obsahuje pouze identifikátor účtu {identifier}, nikoli platný IBAN. Pro toto nahrání nebyl vytvořen žádný nový firemní bankovní účet.",
                "update_client_iban": "Přidat IBAN jako nový účet",
                "continue_without_update": "Pokračovat bez přidání účtu",
                "continue_upload": "Pokračovat v nahrání",
                "statement_account_title": "Účet v nahraném výpisu",
                "statement_account_hint": "Tento IBAN byl rozpoznán v nahraném bankovním výpisu.",
                "client_accounts_title": "Aktivní firemní bankovní účty",
                "client_accounts_count": "{count} aktivní",
                "client_accounts_table_label": "Označení",
                "client_accounts_table_bank": "Banka",
                "client_accounts_table_account_holder": "Majitel účtu",
                "client_accounts_table_bic": "BIC",
                "client_accounts_table_iban": "IBAN",
                "client_iban_missing_title": "Chybí firemní bankovní účet",
                "client_iban_missing_intro": "Pro společnost {clientName} zatím není v kmenových datech uložen žádný odpovídající aktivní firemní bankovní účet.",
                "client_iban_mismatch_title": "Firemní bankovní účet se liší",
                "client_iban_mismatch_intro": "IBAN ve výpisu se liší od aktivních firemních bankovních účtů uložených v kmenových datech společnosti {clientName}.",
                "client_iban_document": "IBAN ve výpisu: {iban}",
                "client_iban_masterdata": "Existující firemní bankovní účet: {iban}",
                "client_iban_masterdata_empty": "V kmenových datech zatím není uložen žádný aktivní firemní bankovní účet.",
                "client_iban_update_question": "Chcete před nahráním přidat tento IBAN jako nový firemní bankovní účet?",
                "client_iban_readonly_hint": "V nahrání můžete pokračovat bez vytvoření nového firemního bankovního účtu."
            },
            "form": {
                "title": "Bankovní výpis",
                "back_to_upload": "Nové nahrání",
                "delete": "Smazat bankovní výpis",
                "delete_confirm_title": "Smazat bankovní výpis",
                "delete_confirm_message": "Opravdu chcete tento bankovní výpis smazat? Existující párování se zruší a příznaky uhrazení z bankovního výpisu se vrátí zpět, pokud pocházejí pouze z tohoto výpisu.",
                "delete_success": "Bankovní výpis byl smazán.",
                "delete_error": "Bankovní výpis se nepodařilo smazat.",
                "download": "Stáhnout soubor",
                "format": "Formát",
                "status": "Stav",
                "account_iban": "Účet",
                "account_owner": "Majitel účtu",
                "period": "Období",
                "matched_entries": "Automaticky přiřazeno",
                "processing_title": "Bankovní výpis se zpracovává",
                "processing_notice": "Nahrání už bylo uloženo. {inserted} z {count} položek už bylo importováno; zbytek se ještě na pozadí importuje a páruje. Stav zkontrolujete tlačítkem pro obnovení, až budete chtít.",
                "processing_matching_title": "Položky jsou importované, párování ještě běží",
                "processing_matching_notice": "Všech {count} položek už bylo importováno a nyní se na pozadí párují. Zatím bylo automaticky přiřazeno {matched} položek. Stav zkontrolujete tlačítkem pro obnovení, až budete chtít.",
                "processing_refresh": "Obnovit stav",
                "processing_finished_notice": "Zpracování bankovního výpisu bylo dokončeno.",
                "entries": "Položky",
                "entry_index": "Poz.",
                "booking_date": "Datum zaúčtování",
                "value_date": "Valuta",
                "amount": "Částka",
                "counterparty": "Protistrana",
                "reference": "Účel platby",
                "match_status": "Přiřazení",
                "matched_invoice": "Přiřazená faktura",
                "status_labels": {
                    "processing": "Zpracovává se",
                    "processed": "Zpracováno",
                    "partial": "Částečně zpracováno",
                    "failed": "Selhalo"
                },
                "match_status_labels": {
                    "unmatched": "Nepřiřazeno",
                    "matched": "Přiřazeno",
                    "ambiguous": "Nejednoznačné",
                    "ignored": "Ignorováno"
                }
            },
            "list": {
                "identifier": "Identifikátor",
                "uploaded_at": "Nahráno dne",
                "empty": "Zatím nejsou nahrané žádné bankovní výpisy."
            },
            "transactions": {
                "title": "Transakce z bankovních výpisů",
                "subtitle": "Centrální přehled všech položek bankovních výpisů. Nejprve vyberte společnost; filtr dodavatele je volitelný.",
                "clear_filters": "Obnovit filtry",
                "client_required_notice": "Pro zobrazení transakcí nejprve vyberte společnost.",
                "empty": "Nebyly nalezeny žádné transakce.",
                "no_permission": "Nemáte oprávnění otevřít tento přehled.",
                "active_filters": "Aktivní filtry",
                "transaction_date": "Datum transakce",
                "direction": "Typ",
                "incoming": "Příjem",
                "outgoing": "Výdaj",
                "client": "Společnost",
                "supplier": "Dodavatel",
                "account_filter": "Účet",
                "statement": "Otevřít bankovní výpis",
                "amount_filter": "Typ částky",
                "transaction_type": "Typ transakce",
                "text_search": "Textový filtr",
                "text_search_placeholder": "Hledat ve vybraných sloupcích",
                "text_search_columns": "Sloupce pro hledání",
                "text_search_columns_placeholder": "Vyberte sloupce",
                "export": "Exportovat XLSX",
                "export_success": "XLSX export byl vytvořen.",
                "export_error": "XLSX export se nepodařilo vytvořit.",
                "export_empty": "Pro aktuální filtry nejsou k dispozici žádné transakce k exportu.",
                "export_end_balance": "Konečný zůstatek",
                "export_adjustment_type": "Vyrovnávací zaúčtování",
                "export_adjustment_description": "Vyrovnávací zaúčtování pro chybějící pokrytí výpisem ({from} - {to})",
                "export_gap_description": "Chybějící pokrytí výpisem ({from} - {to})",
                "transaction_type_labels": {
                    "transfer": "Bankovní převod",
                    "direct_debit": "SEPA inkaso",
                    "card": "Platba kartou",
                    "standing_order": "Trvalý příkaz",
                    "fee": "Poplatek",
                    "cash": "Hotovost",
                    "refund": "Vrácení peněz"
                },
                "description": "Popis",
                "coverage_gap_alert_title": "Zjištěny mezery v pokrytí bankovních výpisů",
                "coverage_gap_alert_summary": "{days} den/dní ve zvoleném období není pokryt žádným nahraným bankovním výpisem.",
                "coverage_gap_row_label": "Chybějící pokrytí: {from} - {to} ({days} den/dní)",
                "coverage_gap_row_context_between": "Mezera mezi {previous} a {next}.",
                "coverage_gap_row_context_before_first": "Ve zvoleném období není žádný dřívější výpis. Další dostupný výpis: {next}.",
                "coverage_gap_row_context_after_last": "Ve zvoleném období není žádný pozdější výpis. Poslední dostupný výpis: {previous}.",
                "coverage_gap_row_context_unknown": "Pro tuto mezeru nebyly nalezeny sousední bankovní výpisy.",
                "coverage_gap_closing_balance_difference": "Rozdíl konečného zůstatku A/B: {previous} -> {next} ({difference}).",
                "coverage_gap_closing_balance_difference_unavailable": "Rozdíl konečného zůstatku A/B není pro jeden nebo oba výpisy dostupný.",
                "manual_match": {
                    "action": "Akce",
                    "assignment": "Přiřazení",
                    "details": "Detaily",
                    "open": "Spárovat",
                    "edit": "Upravit",
                    "dialog_title": "Ruční spárování platby",
                    "dialog_title_single": "Přiřadit transakci",
                    "dialog_title_split": "Rozdělit platbu",
                    "eyebrow": "Ruční párování platby",
                    "single_option": "Přiřadit jednotlivě..",
                    "split_option": "Rozdělit",
    "bulk_actions_select": "Hromadné akce ({count})",
                    "bulk_action": "Přiřadit typ nákladu ({count})",
                    "bulk_dialog_title": "Hromadně přiřadit typ nákladu",
                    "bulk_dialog_text": "Přiřaďte vybraný typ nákladu přímo k {count} vybraným transakcím. Stávající ruční přiřazení budou nahrazena.",
                    "bulk_save": "Přiřadit typ nákladu",
                    "incoming_revenue_bulk_action": "Přiřadit typ příjmu",
                    "revenue_bulk_dialog_title": "Hromadně přiřadit typ příjmu",
                    "revenue_bulk_dialog_text": "Přiřaďte vybraný typ příjmu přímo k {count} vybraným příchozím transakcím. Stávající ruční přiřazení budou nahrazena.",
                    "revenue_bulk_save": "Přiřadit typ příjmu",
                    "filtered_batch_action": "Hromadně přiřadit filtrované ({count})",
                    "filtered_batch_incoming_action": "Hromadně přiřadit filtrované příjmy ({count})",
                    "filtered_batch_outgoing_action": "Hromadně přiřadit filtrované výdaje ({count})",
                    "filtered_batch_empty": "Pro hromadné přiřazení nejsou k dispozici žádné filtrované transakce.",
                    "filtered_batch_direction_warning": "Filtrované výsledky obsahují příjmy i výdaje. Před hromadným přiřazením prosím filtry více upřesněte.",
                    "filtered_batch_load_error": "Filtrované transakce se nepodařilo připravit pro hromadné přiřazení.",
                    "permission_required_title": "Vyžadováno oprávnění",
                    "permission_required": "Pro úpravu transakcí bankovního výpisu potřebujete oprávnění „Zobrazit transakce z bankovních výpisů“ a „Upravit fakturu následně“.",
                    "permission_tooltip": "Deaktivováno: chybí oprávnění „Upravit fakturu následně“.",
                    "transaction_total": "Celkem transakce",
                    "allocated_total": "Celkem přiřazeno",
                    "remaining_difference": "Zbývající rozdíl",
                    "ready_to_save": "Součet sedí.",
                    "remaining_message": "Zbývá: {amount}",
                    "allocations_title": "Rozdělení mezi faktury",
                    "allocations_subtitle": "Vyberte jednu nebo více faktur a u každého řádku zadejte částku, kterou tato transakce pokrývá.",
                    "add_invoice": "Přidat fakturu",
                    "outgoing_invoice": "Odchozí faktura (platba zákazníka)",
                    "cost_type": "Typ nákladů",
                    "cost_type_bulk_action": "Přiřadit typ nákladů",
                    "invoice_gross": "Hrubá částka faktury",
                    "match_amount": "Přiřazená částka",
                    "use_transaction_total": "Použít částku transakce",
                    "use_invoice_gross": "Použít hrubou částku",
                    "use_remaining": "Použít zbytek",
                    "clear_matches": "Odebrat párování",
                    "save": "Uložit párování",
                    "alerts": {
                        "invoice_conflict_title": "Faktura je již propojena s jinou transakcí",
                        "invoice_conflict_message": "Alespoň jedna vybraná faktura je již přiřazena k jiné bankovní transakci.",
                        "invoice_conflict_hint": "Nejprve otevřete existující přiřazení a upravte tam rozdělení nebo jej odeberte, teprve potom uložte tuto transakci."
                    }
                }
            }
        }
    },
    "supplier": {
        "address": "Adresa",
        "alias": "Alias dodavatele",
        "external_id": "DATEV ID",
        "supplier_number": "Číslo dodavatele",
        "client_number": "Číslo zákazníka",
        "delivery_in_days": "Dodací lhůta v pracovních dnech",
        "delivery_terms": "Dodací podmínky",
        "payment_terms": "Platební podmínky",
        "vat_number": "DIČ",
        "city": "Město",
        "iban": "IBAN",
        "bic": "BIC",
        "bank_country": "Země banky",
        "bank_account": "Číslo účtu",
        "bank_code": "Bankovní kód",
        "bank": "Banka",
        "discount_percentage": "Skonto 1 - procenta",
        "discount_days": "Skonto 1 - dny",
        "discount_percentage2": "Skonto 2 - procenta",
        "discount_days2": "Skonto 2 - dny",
        "invoice_recognition_prompt": "Vlastní prompt pro rozpoznání faktury",
        "form_sequence": "name,email,city,address,external_id,delivery_terms,payment_terms,iban,bic,vat_number",
        "payment_method": "Způsob platby",
        "payment_method_info": "Faktury od dodavatelských společností se způsobem platby SEPA inkaso nebo kreditní kartou jsou označeny jako zaplacené přímo",
        "page": {
            "new": "Nový dodavatel",
            "department_tooltip_content": "Která oddělení mohou používat toto nákladové středisko.",
            "delivery_in_days_tooltip_content": "Předpokládaná dodací lhůta slouží k přijetí úkolového emailu zboží.",
            "notes_tooltip_content": "Tato poznámka se zobrazuje pouze interně v liftbase a nevytiskne se na PDF objednávky.",
            "external_id_tooltip_content": "ID dodavatele ze systému třetí strany, který jste integrovali.",
            "client_number_tooltip_content": "Číslo, které vám tento dodavatel přiřadil (volitelné).",
            "supplier_number_tooltip_content": "Číslo, které jste přiřadili tomuto dodavateli.",
            "delivery_terms_tooltip_content": "Platební a dodací podmínky dohodnuté s dodavatelem budou zobrazeny v objednávce ve formátu PDF.",
            "payment_terms_tooltip_content": "Platební a dodací podmínky dohodnuté s dodavatelem budou zobrazeny v objednávce ve formátu PDF.",
            "tab_general": "Obecné",
            "tab_delivery_info": "Informace o dodávce",
            "tab_payment_info": "Informace o platbě",
            "tab_permissions": "Skupiny oprávnění",
            "tab_departments": "Oddělení",
            "tab_approvers": "Schvalovatelé",
            "tab_clients": "Podnikové specifické ID",
            "tab_invoice_recognition": "Výchozí hodnoty pro rozpoznání dokladů",
            "tab_invoice_recognition_prompt": "Vlastní prompt",
            "invoice_recognition_prompt_placeholder": "Např. použijte prosím „kód ticketu“ jako číslo faktury.",
            "default_clients_ids": "Pokud společnost není uvedena v této tabulce s konkrétními ID, <br>budou použita následující výchozí ID: <br>ID DATEV: {external_id} <br>Číslo klienta: {client_number}.",
            "no_default_id": "Žádné výchozí ID není k dispozici.",
            "validation": {
                "name_required": "Zadejte jméno.",
                "name_length": "Musí mít maximálně 50 znaků.",
                "email_invalid": "Prosím zadejte platnou emailovou adresu.",
                "supplier_number_invalid": "Prosím zadejte platné číslo.",
                "vat_number_invalid": "Může obsahovat čísla, velká a malá písmena, tečky, mezery a podtržítka. Musí mít maximálně 15 znaků.",
                "iban_invalid": "Musí mít alespoň 15 a maximálně 34 znaků. Nesmí obsahovat mezery. Začíná dvěma velkými písmeny, následovanými 2 čísly a poté 11 až 30 alfanumerickými znaky.",
                "bic_invalid": "Musí mít alespoň 8 a maximálně 11 znaků a obsahovat pouze velká písmena a čísla. Prvních šest znaků musí být písmena.",
                "external_id_length": "ID DATEV musí obsahovat pouze celá čísla a nesmí být menší než 10000."
            },
            "tour": {
                "name": "Zadejte jméno dodavatele.",
                "email": "Emailová adresa dodavatele slouží např. pro přípravu emailových zpráv pro zadání objednávky.",
                "address": "Zde můžete uvést adresu dodavatele.",
                "external_id": "Externí ID je číslo dodavatele uložené v externím systému. Toto číslo se používá v API.",
                "terms": "Zadejte s dodavatelem dohodnuté platební a dodací podmínky. Tyto informace se zobrazí v PDF nákupní objednávky.",
                "btn_save": "Jakmile zadáte všechny informace, uložte dodavatele zde."
            }
        }
    },
    "business_partner": {
        "address": "Adresa",
        "business_partner_number": "Číslo",
        "delivery_in_days": "Dodací lhůta v pracovních dnech",
        "delivery_terms": "Dodací podmínky",
        "payment_terms": "Platební podmínky",
        "vat_number": "DIČ",
        "city": "Město",
        "iban": "IBAN",
        "bic": "BIC",
        "bank_country": "Země banky",
        "bank_account": "Číslo účtu",
        "bank_code": "Bankovní kód",
        "bank": "Banka",
        "discount_percentage": "Skonto 1 - procenta",
        "discount_days": "Skonto 1 - dny",
        "discount_percentage2": "Skonto 2 - procenta",
        "discount_days2": "Skonto 2 - dny",
        "payment_method": "Způsob platby",
        "payment_method_info": "Doklady se způsobem platby SEPA inkaso nebo kreditní kartou mohou být označeny přímo jako zaplacené.",
        "page": {
            "new": "Přidat obchodního partnera",
            "delivery_in_days_tooltip_content": "Dodací lhůta se ukládá jako kmenový údaj tohoto obchodního partnera.",
            "notes_tooltip_content": "Tato poznámka se zobrazuje pouze interně v liftbase.",
            "business_partner_number_tooltip_content": "Číslo, které jste přiřadili tomuto obchodnímu partnerovi.",
            "delivery_terms_tooltip_content": "Zde můžete uložit dodací podmínky dohodnuté s obchodním partnerem.",
            "payment_terms_tooltip_content": "Zde můžete uložit platební podmínky dohodnuté s obchodním partnerem.",
            "vat_number_tooltip_content": "DIČ pomáhá přiřadit doklady k tomuto obchodnímu partnerovi.",
            "name_tooltip_content": "Zadejte název obchodního partnera přesně tak, jak se má zobrazovat na dokladech.",
            "tab_general": "Obecné",
            "tab_delivery_info": "Dodací údaje",
            "tab_payment_info": "Platební údaje",
            "tab_permissions": "Skupiny oprávnění",
            "tab_clients": "Společnosti",
            "import_legacy_suppliers_button": "Importovat dodavatele jako partnery",
            "import_legacy_suppliers_title": "Importovat dodavatele jako obchodní partnery?",
            "import_legacy_suppliers_confirm": "Pro každého dodavatele ve vašem tenantovi, který ještě nemá obchodního partnera, vytvoří záznam (s odkazem na původního dodavatele), zkopíruje bankovní účty, vazby na klienty a skupiny oprávnění a aktualizuje odchozí faktury. Již importovaní dodavatelé se přeskočí. Akci lze bezpečně spustit znovu.",
            "import_legacy_suppliers_run": "Spustit import",
            "import_legacy_suppliers_loading": "Probíhá import dodavatelů…",
            "import_legacy_suppliers_success": "Import dokončen. Noví partneři: {inserted}. Přeskočeno (už propojeno): {skipped}. Bankovní účty: {bankAccounts}. Odchozí faktury (hlavní / rozpoznané): {invoicesBp} / {invoicesRec}. Vazby klientů: {clients}. Oprávnění: {permissions}.",
            "tab_invoice_recognition": "Výchozí hodnoty pro rozpoznání dokladů",
            "validation": {
                "name_required": "Zadejte jméno.",
                "name_length": "Musí mít maximálně 50 znaků.",
                "email_invalid": "Prosím zadejte platnou emailovou adresu.",
                "vat_number_invalid": "Může obsahovat čísla, velká a malá písmena, tečky, mezery a podtržítka. Musí mít maximálně 15 znaků.",
                "iban_invalid": "Musí mít alespoň 15 a maximálně 34 znaků. Nesmí obsahovat mezery. Začíná dvěma velkými písmeny, následovanými 2 čísly a poté 11 až 30 alfanumerickými znaky.",
                "bic_invalid": "Musí mít alespoň 8 a maximálně 11 znaků a obsahovat pouze velká písmena a čísla. Prvních šest znaků musí být písmena."
            },
            "tour": {
                "name": "Zadejte název obchodního partnera.",
                "email": "E-mailová adresa obchodního partnera může být použita pro komunikaci a práci s doklady.",
                "address": "Zde můžete uložit adresu obchodního partnera.",
                "terms": "Zadejte zde platební a dodací podmínky dohodnuté s obchodním partnerem.",
                "btn_save": "Po zadání všech informací zde obchodního partnera uložte."
            }
        }
    },
    "user": {
        "name": "Jméno",
        "client_id": "Hlavní společnost",
        "approval_limit": "Limit schválení",
        "priority_approval_limit": "Úroveň priority schvalovacího limitu",
        "show_tour": "Zobrazit všechny prohlídky od Liftbase",
        "tooltip_edit_master_data_permission": "S tímto oprávněním lze hlavní data upravovat i mimo administrátorskou oblast pomocí následujících funkcí:<br>" +
            "- Přidání dodavatele přímo při vytváření produktu<br>" +
            "- Úprava/doplnění bankovních údajů, způsobu platby a DIČ při zpracování faktury",
        "roles": {
            "user-admin": "Administrátor",
            "user-price": "Zobrazit ceny",
            "user-dashboard": "Zobrazit všechny dashboardy",
            "user-procurement-dashboard": "Zobrazit procurement dashboard",
            "user-invoice-dashboard": "Zobrazit dashboard příchozích faktur",
            "user-outgoing-invoice-dashboard": "Zobrazit dashboard odchozích faktur",
            "user-einvoice-dashboard": "Zobrazit dashboard elektronických faktur",
            "user-change-order": "Upravit objednávku následně",
            "user-see-orders": "Zobrazit objednávky:",
            "user-see-all-orders": "Všechny společnosti",
            "user-see-all-orders-belonging-to-accessible-companies": "Všechny přístupné společnosti",
            "user-see-all-orders-belonging-to-own-company": "Vlastní společnost",
            "user-see-all-orders-belonging-to-own-department": "Vlastní oddělení",
            "user-see-orders-from-involved-invoices": "Zobrazit objednávky ze zapojených faktur",
            "user-see-own-orders-and-involved": "Vlastní a zapojené",
            "user-see-all-invoices": "Všechny společnosti",
            "user-see-all-invoices-belonging-to-accessible-companies": "Všechny přístupné společnosti",
            "user-see-invoices": "Zobrazit faktury:",
            "user-see-all-invoices-belonging-to-own-company": "Vlastní společnost",
            "user-see-invoices-from-own-orders": "Zobrazit faktury z vlastních objednávek",
            "user-see-own-invoices-and-involved": "Vlastní a zapojené",
            "user-can-change-invoices": "Upravit fakturu následně",
            "user-see-outgoing-invoices": "Zobrazit odchozí faktury:",
            "user-see-all-outgoing-invoices": "Všechny společnosti",
            "user-see-all-outgoing-invoices-belonging-to-accessible-companies": "Všechny přístupné společnosti",
            "user-see-all-outgoing-invoices-belonging-to-own-company": "Vlastní společnost",
            "user-see-own-outgoing-invoices-and-involved": "Vlastní a zapojené",
            "user-can-change-outgoing-invoices": "Upravit odchozí fakturu následně",
            "user-bank-statement-transactions": "Zobrazit transakce z bankovních výpisů",
            "user-liquidity-planning": "Otevřít plánování likvidity",
            "user-supplier-dashboard": "Zobrazit dodavatelský dashboard",
            "user-ai-dashboard": "AI-Stats (pouze operátoři)",
            "user-see-client-addresses": "Zobrazit všechny adresy společnosti",
            "user-export-invoice": "Odeslat faktury do {export_name}",
            "user-can-delete-document-directly": "Stornovat/vyřadit dokumenty bez objasnění",
            "user-can-insert-product": "Uložit do katalogu produktů",
            "user-can-insert-supplier": "Nepřímo upravit hlavní data",
            "user-see-contracts": "Zobrazit smlouvy:",
            "user-see-all-contracts": "Všechny společnosti",
            "user-see-all-contracts-belonging-to-accessible-companies": "Všechny přístupné společnosti",
            "user-see-all-contracts-belonging-to-own-company": "Vlastní společnost",
            "user-see-all-contracts-belonging-to-own-department": "Vlastní oddělení",
            "user-see-own-contracts-and-involved": "Vlastní a zapojené",
            "masterdata-edit-clients": "Upravovat společnosti",
            "masterdata-edit-cost-centers": "Upravovat nákladová střediska",
            "masterdata-edit-posting-keys": "Upravovat účtovací klíče",
            "masterdata-edit-departments": "Upravovat oddělení",
            "masterdata-edit-suppliers": "Upravovat dodavatele",
            "masterdata-edit-business-partners": "Upravovat obchodní partnery",
            "masterdata-edit-products": "Upravovat katalog produktů",
            "masterdata-edit-product-groups": "Upravovat skupiny produktů"
        },
        "blocked": "Přihlášení zablokováno",
        "token_issued_at": "Token API vydán dne",
        "form_sequence": "name,email,client_id,department_id,cost_center_id,location_id,approval_limit,roles,blocked",
        "page": {
            "tab_general": "Obecné",
            "tab_roles": "Oprávnění",
            "tab_roles_general": "Obecná oprávnění",
            "tab_roles_dashboards": "Dashboardy",
            "tab_roles_procurement": "Požadavky na nákup",
            "tab_roles_invoice": "Faktury",
            "tab_roles_outgoing_invoice": "Odchozí faktury",
            "tab_roles_bank_statements": "Bankovní výpisy",
            "bank_statement_permission_dependency_warning": "Úprava transakcí bankovního výpisu vyžaduje také oprávnění „Upravit fakturu následně“. Tuto volbu lze přesto uložit.",
            "tab_roles_masterdata": "Kmenová data",
            "tab_roles_block": "Bloky",
            "tab_permissions": "Skupiny oprávnění",
            "tab_addresses": "Dodací adresy",
            "tab_task_groups": "Skupiny úkolů",
            "tab_communication_contacts": "Kontakty",
            "tab_passkeys": "Přístupové klíče",
            "tab_oauth_permissions": "Přístupy aplikací",
            "oauth_permissions": "Udělené přístupy aplikací",
            "oauth_permissions_description": "Zde uvedené aplikace byly výslovně autorizovány k přístupu do Liftbase jménem této osoby.",
            "oauth_permissions_empty": "Nebyl udělen žádný přístup aplikaci.",
            "oauth_application": "Aplikace",
            "oauth_redirect_uri": "URL přesměrování",
            "oauth_unverified": "Neověřená",
            "oauth_permission": "Oprávnění",
            "oauth_scope_mcp": "Čtení povolených dat Liftbase",
            "oauth_granted_at": "Uděleno",
            "oauth_expires_at": "Vyprší",
            "oauth_status": "Stav",
            "oauth_status_active": "Aktivní",
            "oauth_status_expired": "Vypršelo",
            "oauth_revoke": "Odvolat",
            "oauth_revoke_title": "Odvolat přístup aplikace",
            "oauth_revoke_confirm": "Odvolat přístup pro {application}? Obnovování přístupu se okamžitě zastaví; již vydaný přístupový token může zůstat platný až 15 minut.",
            "oauth_revoked": "Přístup aplikace byl odvolán.",
            "communication_contacts_description": "Zde spravujete e-mailové kontakty navrhované pouze vám pro komunikaci s dodavateli. Uložené kontakty můžete přejmenovat nebo odstranit, aby se již nenabízely.",
            "communication_contacts_empty": "Zatím nejsou uloženy žádné kontakty.",
            "communication_contact_name": "Jméno",
            "communication_contact_name_placeholder": "Volitelný zobrazovaný název",
            "communication_contact_email": "E-mail",
            "communication_contact_last_used": "Naposledy použito",
            "communication_contact_saved": "Kontakt byl aktualizován.",
            "communication_contact_deleted": "Kontakt byl odstraněn.",
            "communication_contact_delete_confirm": "Opravdu chcete odstranit uložený kontakt \"{email}\"?",
            "accessible_companies_title": "Přístupné společnosti pro tohoto uživatele",
            "accessible_companies_empty": "Z aktuálních oprávnění nebyly odvozeny žádné společnosti.",
            "new": "Nový uživatel",
            "block_btn": "Zablokovat uživatele",
            "unblock_btn": "Odblokovat uživatele",
            "login_as_btn": "Přihlásit se jako",
            "no_permission": "Není vybrána žádná skupina oprávnění.",
            "task_group_permissions": "Oprávnění z mých skupin úkolů:",
            "approval_limit_tooltip_content": "Zde definujte konečný limit schválení pro tuto osobu. <br> Vyšší částky mohou být schváleny, ale musí je také definitivně schválit jiná osoba s vyšším limitem schválení.",
            "approval_limit_placeholder": "Neomezený",
            "upload_signature_label": "Podpis (obrázek)",
            "upload_signature_btn": "Vyberte Podpis",
            "upload_signature_tooltip_content": "Přidejte podpis, který bude vytištěn na objednávkovém dokumentu vašich schválených nákupních objednávek. <br/> Doporučujeme použít obrázkový soubor s průhledným pozadím.",
            "email_signature_html": "E-mailový podpis",
            "email_signature_html_hint": "Tento podpis se předvyplní v komunikaci s dodavatelem u první zprávy dokumentu.",
            "api_token_btn": "Vygenerovat token API",
            "api_token_dialog_title": "Vygenerovat token API",
            "api_token_dialog_content": "Tokeny API jsou vyžadovány pro integraci aplikací třetích stran a umožňují přístup k datům jménem příslušného uživatele.",
            "api_token_dialog_date_placeholder": "Datum vypršení platnosti tokenu",
            "api_token_dialog_generate_btn": "generovat",
            "api_token_dialog_copy_btn": "kopírovat",
            "api_token_dialog_copy_info": "Zkopírujte a vložte následující token rozhraní API do aplikace třetí strany:",
            "api_token_dialog_copied": "Zkopírováno!",
            "language": "Jazyk",
            "role_dashboard_tooltip": "Umožňuje přístup ke všem dashboardům.",
            "role_ai_dashboard_tooltip": "AI-Stats je dostupný pouze operátorům.",
            "role_supplier_dashboard_tooltip": "Umožňuje pouze přístup k dodavatelskému dashboardu. Toto oprávnění je nezávislé na oprávnění \"Zobrazit dashboard\".",
            "passkey": "Přístupový klíč",
            "passkeys": "Přístupové klíče",
            "passkey_name": "Jméno",
            "passkey_last_login": "Poslední přihlášení",
            "passkey_dialog": {
                "title": "Přidat přístupový klíč",
                "info1": "<b>Co jsou přístupové klíče?</b><ul><li>Přihlášení bez čekání na e-mail</li><li>Otiskem prstu, obličejem nebo kódem PIN</li><li>Bezpečné a pohodlné</li> li></ul>",
                "info2": "<b>Nastavte nyní ve 3 krocích:</b><ol><li>Zadejte jméno, např. \"Počítač domácí kanceláře\" nebo \"Poznámkový blok\"</li><li>Klikněte na tlačítko \"Další\"</li><li>Postupujte podle pokynů z prohlížeče / operačního systému</li></ol>",
                "info3": "Podrobné pokyny <a href=\"https://liftbase.de/handbuch/anmeldung/passkeys/\" target=\"_blank\">najdete v příručce</a>",
                "name_input_label": "Název přístupového klíče",
                "name_input_placeholder": "např. 'Home Office PC' nebo 'Notebook'",
                "added_msg": "Byl přidán přístupový klíč.",
                "deleted_msg": "Přístupový klíč byl smazán.",
                "exist_msg": "V tomto zařízení již máte přístupový klíč, zkuste to s jiným zařízením."
            },
            "validation": {
                "name_required": "Zadejte jméno.",
                "name_exists": "Název již existuje.",
                "email_required": "Prosím zadejte emailovou adresu.",
                "email_invalid": "Prosím zadejte platnou emailovou adresu.",
                "email_exists": "E-mailová adresa již existuje.",
                "approval_limit_length": "Limit schválení musí být buď větší než 0, nebo prázdný."
            },
            "tour": {
                "name": "Zadejte jméno uživatele, nejlépe jméno a příjmení.",
                "email": "Zadejte e-mailovou adresu, přes kterou se uživatel může přihlásit.",
                "organization": "Přiřaďte uživatele společnosti, oddělení a nákladovému středisku. Tyto údaje budou předvyplněny v objednávkovém formuláři.",
                "approval_limit": "Zde můžete pro uživatele definovat limit schválení. Pokud má objednávka vyšší celkovou částku, musí ji také definitivně schválit osoba s vyšším schvalovacím limitem. Pokud není definován žádný limit, uživatel může nakonec schválit všechny částky.",
                "signature": "Zde můžete přidat podpis uživatele. Když uživatel schválí nákupní objednávku, jeho podpis bude přidán do PDF nákupní objednávky.",
                "roles": "Zde můžete nastavit oprávnění pro osobu, například zda a které procesy nebo informace mohou být zobrazeny nebo upraveny. Je zde také možnost osobu zablokovat, pokud například opustila společnost.",
                "roles_price": "Určete, zda uživatel může zobrazit ceny produktů.",
                "role_change_order": "Důvěryhodnému uživateli můžete udělit oprávnění k úpravě nákupních objednávek po schválení, aniž byste je posílali zpět k vyúčtování, a tím se vyhli opětovnému schválení. To může být užitečné například pro dodatečnou úpravu dodacích adres nebo cen produktů.",
                "admin": "Zvolte, zda má mít tato osoba přístup do administrační oblasti, například pro přidání dalších uživatelů, kmenových dat nebo nastavení.",
                "block": "Tuto možnost vyberte, pokud chcete zabránit uživateli v přihlášení do liftbase, např. když dočasně opustil společnost.",
                "api_token": "Tokeny API jsou vyžadovány pro integraci aplikací třetích stran a umožňují přístup k datům jménem příslušného uživatele.",
                "addresses": "Uživateli můžete přidat osobní dodací adresy, například pokud pracuje z domova a chce, aby mu tam byly doručovány produkty.",
                "btn_save": "Uložte uživatele a související informace.",
                "profile_signature": "Zde můžete nahrát svůj podpis. Když schválíte nákupní objednávky, váš podpis bude přidán do PDF nákupní objednávky.",
                "profile_addresses": "Uživateli můžete přidat osobní dodací adresy, například pokud pracuje z domova a chce, aby mu tam byly doručovány produkty.",
                "profile_btn_save": "Uložte související informace."
            }
        }
    },
    "lb_user": {
        "description": "Uživatel"
    },
    "posting_key": {
        "name": "Jméno",
        "tax": "Sazba daně (%)",
        "number": "Klíč",
        "form_sequence": "name,number,tax",
        "page": {
            "new": "Nový klíč pro zasílání",
            "validation": {
                "name_required": "Zadejte jméno.",
                "number_required": "Prosím zadejte platné číslo.",
                "number_length": "Může obsahovat až 9místná čísla začínající od 1."
            },
            "tour": {
                "name": "Zadejte klíč a související daňovou sazbu."
            }
        }
    },
    "ledger_account": {
        "name": "Jméno",
        "description": "Popis",
        "form_sequence": "name,number,description",
        "page": {
            "new": "Nový účet hlavní knihy",
            "validation": {
                "name_required": "Zadejte název.",
                "number_required": "Prosím zadejte platné číslo.",
                "number_length": "Může obsahovat pouze čísla a nemůže začínat 0.",
                "tax_required": "Zadejte platnou sazbu daně.",
                "tax_length": "Procentuální hodnota může mít pouze dvě číslice s čárkou a nejvýše dvě desetinná místa."
            },
            "tour": {
                "name": "Zadejte číslo a název hlavního účtu."
            }
        }
    },
    "profit_center": {
        "name": "Název",
        "form_sequence": "name,number",
        "page": {
            "new": "Nové ziskové centrum",
            "validation": {
                "name_required": "Zadejte název.",
                "number_required": "Zadejte platné číslo.",
                "number_length": "Smí obsahovat pouze čísla a při více číslicích nesmí začínat nulou.",
            },
            "tour": {
                "name": "Uveďte číslo a název ziskového centra."
            }
        }
    },
    "tax_group": {
        "code": "ID",
        "name": "Název",
        "form_sequence": "name,code,client_id",
        "page": {
            "new": "Nová skupina daně z prodeje",
            "validation": {
                "name_required": "Zadejte název.",
                "code_required": "Zadejte ID.",
                "client_required": "Vyberte prosím klienta.",
            },
            "tour": {
                "name": "Uveďte ID a název skupiny daně z prodeje."
            }
        }
    },
    "financial_dimension": {
        "code": "ID",
        "name": "Název",
        "form_sequence": "name,code",
        "page": {
            "new": "Nový zaměstnanec",
            "validation": {
                "name_required": "Prosím, zadejte jméno.",
                "code_required": "Prosím, zadejte ID.",
                "client_required": "Prosím, vyberte společnost."
            },
            "tour": {
                "name": "Zadejte ID a jméno zaměstnance."
            }
        }
    },
    "tax_item_group": {
        "code": "ID",
        "tax_code": "Daňové ID",
        "name": "Název",
        "form_sequence": "name,code,tax_code,client_id",
        "page": {
            "new": "Nová skupina položek daní",
            "validation": {
                "name_required": "Prosím, zadejte název.",
                "code_required": "Prosím, zadejte ID.",
                "tax_code_required": "Prosím, zadejte Daňové ID.",
                "client_required": "Prosím, vyberte firmu.",
            },
            "tour": {
                "name": "Zadejte ID a název skupiny daně z přidané hodnoty."
            }
        }
    },
    "approver": {
        "description": "Odsouhlasení",
        "label_log": "lb_user_name",
        "table_log": "lb_user",
        "approver_required": "Vyberte prosím schvalovatele.",
        "is_required": "Povinný",
        "is_required_info": "Je třeba schválit, i když předchozí schvalovatelé již měli potřebný limit schválení.",
        "conversion_info": "Částka schválení byla přepočtena na měnu dokumentu podle aktuálního směnného kurzu ECB.",
        "max_approvers": "Max. počet schvalovatelů",
        "max_approvers_placeholder": "volitelné",
        "max_approvers_info": "Volitelné. Pokud je nastaveno, musí schválit pouze N nejvyšších schvalovatelů (podle limitu schválení). Povinní schvalovatelé se započítávají do maxima a mohou jej překročit. Předřazený tvůrce nebo záložní uživatel se do maxima nezapočítává. Prázdné = dosavadní pravidlo (všichni odpovídající schvalovatelé).",
        "add_creator_or_fallback": "Tvůrce schvaluje jako první",
        "add_creator_or_fallback_info": "Nákupní požadavek: tvůrce se přidá jako první schvalovatel. Pokud jeho schvalovací limit nestačí nebo není k dispozici, použije se záložní uživatel. Faktura propojená s objednávkou: tvůrce objednávky se přidá jako první schvalovatel. Záložní uživatel se použije pouze tehdy, když tento tvůrce není k dispozici. Faktura bez propojené objednávky: záložní uživatel se přidá jako první schvalovatel.",
        "procurement": "Nákupní požadavek",
        "invoice": "Faktura/Nákupní požadavek",
        "or": "nebo",
        "creator_placeholder": "Tvůrce (automaticky)",
        "fallback_label": "Záložní uživatel, když tvůrce není k dispozici",
        "fallback_info": "U nákupních požadavků se použije, když tvůrce není k dispozici nebo jeho schvalovací limit nestačí. U faktur se použije, když není propojena objednávka nebo tvůrce objednávky není k dispozici.",
        "fallback_placeholder": "Záložní uživatel",
        "creator_or_fallback_preview": "Tvůrce nebo záložní uživatel",
        "creator_or_fallback_preview_info": "První pozice je rezervována. O tom, zda obsahuje tvůrce nebo záložního uživatele, se rozhodne pro konkrétní doklad.",
        "test_order_value": "Testovací hodnota objednávky",
        "test_order_value_placeholder": "např. 5000",
        "test_order_value_info": "Zadejte fiktivní hodnotu objednávky a zobrazte, kteří schvalovatelé by byli s aktuálním nastavením vyžadováni.",
        "test_preview_section_title": "Test schvalování",
        "test_preview_title": "Požadovaní schvalovatelé",
        "test_preview_empty": "Pro tuto hodnotu nejsou žádní schvalovatelé.",
        "test_preview_required_overflow_short": "{requiredCount} povinných > max. {max}"
    },
    "invoice": {
        "description": "Faktura",
        "name": "Jméno",
        "creator_id": "Nahráno uživatelem",
        "created_at": "Nahráno dne",
        "number": "Číslo faktury",
        "ms365_journal_name": "Účetní deník",
        "invoice_prefix": "Prefix faktury",
        "is_final_invoice": "Označit propojenou objednávku jako dokončenou",
        "is_final_invoice_short": "Uzavřít PO",
        "is_final_invoice_info": "Pokud je tato možnost aktivována, propojená objednávka se automaticky označí jako dokončená. Poté již nelze s touto objednávkou propojit žádné další faktury.",
        "invoice_prefix_options": {
            "RE": "běžná faktura",
            "AZ": "žádost o zálohovou platbu / pro forma faktura",
            "VK": "zálohová faktura",
            "SR": "závěrečná faktura",
            "GS": "dobropis"
        },
        "invoice_number_formatted": "Interní RE číslo",
        "due_date": "Datum splatnosti",
        "delivery_date": "Datum dodání",
        "invoice_date": "Datum faktury",
        "vat_due_date": "Datum zaevidování DPH",
        "tax": "Sazba daně %",
        "total_brutto": "Celkový hrubý",
        "total_netto": "Celková čistá",
        "total_netto_abbr": "-Síť",
        "document_discount_amount": "Částka slevy dokladu",
        "document_discount_base_amount": "Základ slevy dokladu",
        "document_discount_percentage": "Sleva dokladu %",
        "document_discount_tax_percentage": "DPH slevy dokladu %",
        "document_discount_percentage_tooltip": "Procento slevy na úrovni dokladu použité na základ (EN 16931 BT-94).",
        "document_discount_amount_tooltip": "Absolutní částka slevy na úrovni dokladu (EN 16931 BT-92).",
        "document_discount_base_amount_tooltip": "Čistá částka, ze které se sleva dokladu vypočítává (EN 16931 BT-93).",
        "document_discount_tax_percentage_tooltip": "Sazba DPH použitá pro daňové přiřazení slevy dokladu.",
        "supplier_vat_number": "DIČ",
        "supplier_payment_method": "Způsob platby",
        "supplier_iban": "IBAN",
        "supplier_bic": "BIC",
        "supplier_bank_country": "Země banky",
        "supplier_bank_account": "Číslo účtu",
        "supplier_bank_code": "Bankovní kód",
        "payment_reference": "Platební reference",
        "fix_recognition": "Nespokojeni s rozpoznáváním dat",
        "fix_recognition_checkbox": "Jsem nespokojen s rozpoznáváním dat.",
        "paid": "Již zaplaceno",
        "paid_auto_by_bank_statement_hint": "Automaticky označeno jako zaplacené na základě analýzy bankovního výpisu dne {date}.",
        "paid_manual_by_bank_statement_hint": "Označeno jako zaplacené ručním spárováním bankovního výpisu dne {date}.",
        "review_status": "Výsledek kontroly",
        "selected_review_status": "Vybraný důvod",
        "review_status_options": {
            "content_rejection": "Faktura odmítnuta z věcných důvodů",
            "insolvency_rejection": "Faktura odmítnuta z důvodu insolvenčního práva",
            "further_review_required": "Faktura vyžaduje další kontrolu",
            "other_reason_rejection": "Stornováno z jiného důvodu",
            "approved": "Faktura schválena"
        },
        "currency": "Měna",
        "notes": "Poznámky",
        "order_notes": "Poznámky k objednávce",
        "discount_percentage": "Sleva 1 (%)",
        "discount_amount": "Sleva 1 – Částka",
        "discount_days": "Sleva 1 - Dny",
        "discount_payment_date": "Sleva 1 – Datum",
        "discount_percentage2": "Sleva 2 (%)",
        "discount_amount2": "Sleva 2 – Částka",
        "discount_days2": "Sleva 2 - Dny",
        "discount_payment_date2": "Sleva 2 – Datum",
        "type_discount_amount": "currency",
        "type_discount_amount2": "currency",
        "payment_in_advance": "Platba předem",
        "einvoice_status": {
            "is_einvoice": "E‑faktura",
            "not_einvoice": "Žádná e‑faktura",
            "not_relevant_hint": "Žádná e‑faktura, není relevantní pro odpočet DPH",
            "tax_not_refundable_hint": "DPH ve výši {amount} nebude od 01.01.2027 vratná.",
            "zugferd10_hint": "ZUGFeRD 1.0 není platná e‑faktura ve smyslu povinnosti e‑fakturace (EN 16931)."
        },
        "electronic_validation": {
            "blocked_title": "Faktura nesplňuje zákonné požadavky",
            "blocked_message": "Protože faktura nesplňuje zákonné požadavky, další zpracování se nedoporučuje. Ruční zpracování je přesto možné.",
            "blocked_status": "Vyžaduje kontrolu",
            "manual_export_warning_title": "Technické chyby elektronické faktury",
            "manual_export_warning_message": "Technická validace této elektronické faktury obsahuje chyby. Ruční zpracování může pokračovat, ale nedoporučuje se. Chcete v exportu vědomě pokračovat?",
            "manual_export_bulk_warning_message": "Alespoň jedna z vybraných elektronických faktur obsahuje technické chyby. Ruční zpracování může pokračovat, ale nedoporučuje se. Chcete v exportu vědomě pokračovat?",
            "manual_export_warning_confirm": "Pokračovat v exportu",
            "manual_export_warning_cancel": "Zrušit",
            "show_details": "Zobrazit detaily",
            "hide_details": "Skrýt detaily",
            "rule_set": "Balíček pravidel",
            "external_reference_uris": "Externí odkazy",
            "notify_supplier": "Upozornit dodavatele",
            "admin_report_hint": "Úplnou technickou zprávu mohou stáhnout pouze správci.",
            "issue": {
                "malformed_xml": "Soubor XML není správně vytvořen nebo obsahuje nepovolené konstrukce XML.",
                "external_reference_not_resolved": "Elektronická faktura odkazuje na externí zdroj. Z bezpečnostních důvodů a důvodů ochrany soukromí Liftbase externí zdroje automaticky nenačítá ani neotevírá.",
                "unknown_format": "Formát faktury XML není podporován.",
                "unsupported_version": "Pro zjištěnou rodinu verzí není k dispozici aktivní balíček pravidel.",
                "outdated_version": "Faktura používá starší verzi XRechnung {version}. Zobrazuje se jako upozornění a sama o sobě nebrání zákonem povolenému zpracování.",
                "unsupported_profile": "Zjištěný formát a profil nesplňují zákonné požadavky normy EN 16931, a proto nemohou být přijaty jako elektronická faktura v souladu s právními předpisy. Použijte formát nebo profil faktury vyhovující normě EN 16931, například ZUGFeRD s profilem EN 16931 nebo XRechnung v právně platné verzi.",
                "zugferd_10_unsupported": "Byl zjištěn zastaralý formát ZUGFeRD 1.0 (profil: {profile}). Tato verze není podporována. Dodavatel musí fakturu znovu vystavit jako aktuální Factur-X/ZUGFeRD nebo XRechnung.",
                "electronic_invoice_extraction_failed": "Z technicky platné elektronické faktury se nepodařilo převzít data.",
                "kosit_execution_failed": "Technickou validaci elektronické faktury nebylo možné spustit.",
                "kosit_processing_failed": "Při technické validaci elektronické faktury došlo k chybě zpracování.",
                "processing_error": "Technickou validaci elektronické faktury nebylo možné dokončit.",
                "multiple_bodies": "Bylo nalezeno více těl faktury. Podle místních pravidel FatturaPA jsou zpracovatelné pouze dokumenty s jedním tělem.",
                "format_mismatch": "Přenosový formát FatturaPA (versione / FormatoTrasmissione) neodpovídá místním pravidlům FatturaPA.",
                "fatturapa_total_mismatch": "Součty dokladu neodpovídají podle místních pravidel FatturaPA.",
                "unsupported_document_type": "Tento typ dokumentu FatturaPA není podle místních pravidel FatturaPA podporován.",
                "fatturapa_schema_violation": "Dokument neprošel místní XSD validací FatturaPA.",
                "fatturapa_line_total_mismatch": "Součet řádku neodpovídá množství × jednotkové ceně po slevách (místní pravidla FatturaPA).",
                "fatturapa_riepilogo_mismatch": "Součty řádků neodpovídají daňovému shrnutí (místní pravidla FatturaPA).",
                "fatturapa_destinatario_missing": "Kód příjemce (CodiceDestinatario / PEC) chybí nebo je neúplný (místní pravidla FatturaPA).",
                "fatturapa_tax_mismatch": "Částky DPH neodpovídají základu × sazbě (místní pravidla FatturaPA).",
                "fatturapa_business_rule_failed": "Místní obchodní pravidla FatturaPA se nepodařilo vyhodnotit.",
                "fatturapa_iban_format": "IBAN na faktuře neprošel kontrolou formátu (místní pravidla FatturaPA).",
                "fatturapa_vat_id_sanity": "Identifikátor DPH (IdFiscaleIVA) neprošel základní kontrolou délky/znaků (místní pravidla FatturaPA).",
                "fatturapa_destinatario_length": "Délka CodiceDestinatario neodpovídá očekávanému formátu přenosu (místní pravidla FatturaPA)."
            },
            "local_scope_hint": "Pouze místní validace FatturaPA — nejedná se o přijetí SDI ani o právní jistotu odpočtu DPH na vstupu.",
            "local_accepted_title": "Platné podle místních pravidel FatturaPA",
            "warning_title": "Upozornění technické validace",
            "status": {
                "acceptable": "Přijata",
                "rejected": "Odmítnuta",
                "undefined": "Neurčeno",
                "technical_error": "Technická chyba"
            },
            "supplier_template": {
                "subject": "Vaše faktura {number} ze dne {invoiceDate}",
                "unknown_value": "neuvedeno",
                "rule_set_unavailable": "žádný odpovídající balíček pravidel",
                "no_specific_reason": "Validátor nevrátil konkrétní chybové hlášení. Zkontrolujte prosím úplnou technickou validační zprávu.",
                "reasons_heading": "Co je třeba opravit?",
                "body": "<p>Dobrý den,</p><p>Fakturu v její současné podobě nelze přijmout jako elektronickou fakturu v souladu se zákonem, protože zjištěný formát nebo profil nesplňuje zákonné požadavky.</p><p style=\"margin-bottom:-4px\"><strong>Dotčená faktura:</strong></p><ul style=\"margin-bottom:12px\"><li><strong>Číslo faktury:</strong> {number}</li><li><strong>Datum faktury:</strong> {invoiceDate}</li><li><strong>Zjištěný formát:</strong> {standard}</li><li><strong>Zjištěná verze:</strong> {version}</li><li><strong>Zjištěný profil:</strong> {profile}</li></ul>{reasonsSection}<br><p>Použijte prosím formát nebo profil faktury podle EN 16931, např. ZUGFeRD s profilem EN 16931 nebo XRechnung v podporované verzi.</p><p>Vystavte prosím opravenou elektronickou fakturu a znovu nám ji zašlete.</p><p>Děkujeme za spolupráci.</p>",
                "body_fatturapa": "<p>Dobrý den,</p><p>Fakturu v její současné podobě nelze přijmout jako elektronickou fakturu v souladu se zákonem, protože zjištěný formát nebo profil nesplňuje zákonné požadavky.</p><p style=\"margin-bottom:-4px\"><strong>Dotčená faktura:</strong></p><ul style=\"margin-bottom:12px\"><li><strong>Číslo faktury:</strong> {number}</li><li><strong>Datum faktury:</strong> {invoiceDate}</li><li><strong>Zjištěný formát:</strong> {standard}</li><li><strong>Zjištěná verze:</strong> {version}</li><li><strong>Zjištěný profil:</strong> {profile}</li></ul>{reasonsSection}<br><p>Použijte prosím formát nebo profil faktury podle EN 16931, např. ZUGFeRD s profilem EN 16931 nebo XRechnung v podporované verzi.</p><p>Vystavte prosím opravenou elektronickou fakturu a znovu nám ji zašlete.</p><p>Děkujeme za spolupráci.</p>"
            }
        },
        "einvoice": {
            "title": "Dashboard e‑faktur",
            "analysis_period": "Období analýzy",
            "filters": {
                "date_range": "Časové rozmezí",
                "client": "Společnost",
                "supplier": "Dodavatel",
                "select_period": "Vyberte období"
            },
            "placeholders": {
                "all": "Vše"
            },
            "kpis": {
                "percent_einvoices": "Podíl e‑faktur",
                "total_tax_eur": "Celková daň na vstupu",
                "potential_loss": "Riziko daně na vstupu",
                "total_invoices": "Celkem faktur",
                "non_einvoice_quote": "Podíl jiných než e‑faktur",
                "top_10_risk_share": "Podíl Top-10 dodavatelů na riziku daně",
                "total_suppliers": "Celkem dodavatelů",
                "suppliers_with_einvoice": "Dodavatelé s e‑fakturou",
                "suppliers_without_einvoice": "Dodavatelé bez e‑faktury",
                "avg_einvoice_quote": "Průměrná e-kvóta (aktivní dodavatelé)",
                "evaluated_months": "Vyhodnocené měsíce",
                "data_coverage": "Datové krytí",
                "risk_concentration": "Koncentrace rizika",
                "only_suppliers_with_min_1": "pouze dodavatelé s alespoň 1 e‑fakturou"
            },
            "charts": {
                "format_distribution": "Distribuce formátu",
                "format_distribution_subtitle": "Podíl XML, PDF+XML a nestrukturovaných faktur",
                "monthly_trend": "Měsíční trend podle formátu faktury",
                "monthly_trend_subtitle": "Skládaná množství za měsíc",
                "top_suppliers_risk": "Top dodavatelé podle rizika daně",
                "top_suppliers_risk_subtitle": "Vysoká koncentrace rizika na jednotlivé dodavatele"
            },
            "table": {
                "monthly_evolution": "Měsíční vývoj",
                "all_suppliers": "Všichni dodavatelé podle e-kvóty (sestupně)",
                "month": "MĚSÍC",
                "xml": "XML",
                "pdf_xml": "PDF+XML",
                "non_einvoice": "NENÍ E‑FAKTURA",
                "risk": "RIZIKO DANĚ",
                "supplier": "DODAVATEL",
                "quote": "E-KVÓTA",
                "total_tax": "CELKEM DAŇ"
            },
            "banner": {
                "title": "Odhadovaná výše DPH, která od 01.01.2027 nebude finančním úřadem vrácena:",
                "subtitle": "{percent}% odhadované daně z obratu (Model formálního rizika)",
                "description": "Období: {start} až {end}. Povinnost přijetí od 01.01.2025. Regulační tlak se zvyšuje od 01.01.2027. Zvýšené riziko formální platnosti pro nestrukturované tuzemské B2B faktury od 01.01.2028. Model posuzuje pouze shodu formátu."
            },
            "hint": "Upozornění: Stát brzy přestane vracet daně u neelektronických faktur. Kontaktujte své dodavatele co nejdříve, abyste zajistili, že své e‑faktury budete dostávat správně a nepřijdete o peníze.",
            "alert": {
                "title": "Pozor: Vyšší daňové a formální riziko u neelektronických faktur",
                "item_1": "Od 01.01.2027 výrazně roste riziko u nestrukturovaných faktur.",
                "item_2": "U takových faktur může finanční úřad odmítnout vrácení DPH.",
                "item_3": "Od 01.01.2028 to platí pro všechny dodavatele, i pod obrat 800.000 € (přechodné pravidlo jen pro rok 2027).",
                "item_4": "Doporučení: Přepněte všechny své dodavatele včas na e‑faktury a vyžádejte si upravené vystavování faktur."
            },
            "action_button": "Informovat dodavatele",
            "email_dialog": {
                "title": "Informovat dodavatele",
                "to": "E-mail příjemce",
                "subject": "Předmět",
                "message": "Zpráva",
                "download_eml": "Stáhnout .eml",
                "select_supplier_warning": "Nejprve vyberte dodavatele.",
                "default_subject": "Důležité: Přechod na elektronické faktury – {supplier}",
                "default_message": "Vážený týme {supplier},\n\nv současné době prověřujeme naše procesy vracení daní. V období od {startDate} do {endDate} jsme ve vašich fakturách identifikovali celkem {amount} na daních, které nebyly zaslány jako e‑faktury (ZUGFeRD nebo XRechnung).\n\nVezměte prosím na vědomí, že stát brzy přestane vracet daně u neelektronických faktur. Abychom zajistili naši další spolupráci a předešli finančním ztrátám, laskavě vás žádáme, abyste co nejdříve přešli na zasílání elektronických faktur.\n\nDěkujeme za spolupráci.\n\nS pozdravem,\n{userName}\n{tenantName}\nVaše účtárna"
            }
        },
        "export_individual_items": "Exportovat jednotlivé položky",
        "export_individual_items_tooltip": "Pokud je toto políčko zaškrtnuto, přenášejí se pozice místo údajů v záhlaví.",
        "status": "Stav",
        "statuses": {
            "open": "Rozpoznávání faktur",
            "export": "Připraveno k exportu",
            "declined": "Vyřazeno",
            "declined-exported": "Stornováno-Exportováno",
            "completed": "Dokončeno",
            "historical-imported": "Importováno jako historie",
            "approval": "Ruční kontrola",
            "financial-approval": "Schválení",
            "clearing": "Objasnění účetnictví",
            "accounting": "Účetnictví"
        },
        "page": {
            "ai_validation_result": {
                "title": "Výsledek validace KI",
                "result": "Výsledek",
                "green_flags": "Pozitivní signály (Green Flags)",
                "red_flags": "Rizikové signály (Red Flags)",
                "score": "Skóre",
                "check_method": "Metoda kontroly",
                "signals_considered": "Zohledněné signály",
                "signals_missing": "Chybějící signály",
                "system_prompt": "Systémový prompt",
                "user_prompt": "Uživatelský prompt",
                "context": "Kontext",
                "no_data": "Pro tuto fakturu nejsou k dispozici žádná data validace KI.",
                "response": "Odpověď (JSON)",
                "trust_level": "Důvěryhodné",
                "not_trust_level": "Nedůvěryhodné",
                "btn_tooltip": "Zobrazit podrobnosti validace KI",
                                "decision_summary": "Odůvodnění",
                "what_decided": "Co rozhodlo?",
                "positive_contributions": "Pozitivní příspěvky",
                "risk_contributions": "Rizikové příspěvky",
                "scoring_method": "Metoda",
                "scoring_method_linear": "Lineární",
                "scoring_method_multiplicative": "Multiplikativní",
                "scoring_method_confidence": "Konfidence",
                "score_kind_risk": "Rizikové skóre",
                "score_kind_confidence": "Skóre konfidence",
                "score_kind_green_sum": "Součet pozitivních signálů",
                "score_explanation_title": "Jak KI dospěla k rozhodnutí",
                "score_scale_hint_risk": "Orientace: 0 = žádné rozpoznatelné zbytkové riziko, 1 = maximální riziko. Čím nižší hodnota, tím spíše může být faktura automaticky schválena.",
                "score_scale_hint_confidence": "Orientace: 0 = velmi nejisté, 1 = velmi jisté. Čím vyšší hodnota, tím spíše může být faktura automaticky schválena.",
                "score_scale_hint_green_sum": "Orientace: 0 = žádné významné pozitivní signály, 1 = velmi silné pozitivní signály. Čím vyšší hodnota, tím spíše může být faktura automaticky schválena.",
                "decision_reasons_trusted": "Rozhodující byly také: {ai_validation_reason_value}.",
                "decision_reasons_not_trusted": "Rozhodující byly: {ai_validation_reason_value}.",
                "decision_reasons_insufficient_positive": "Pozitivní signály nestačily: {ai_validation_reason_value}.",
                "show_calculation": "Zobrazit výpočet",
                "formula_linear": "Riziko = RedSum − GreenSum = {red_sum} − {green_sum} = {final_score}",
                "formula_multiplicative_risk": "Riziko = (RedSum × Boost) × (1 − GreenSum) = ({red_sum} × {boost}) × (1 − {green_sum}) = {final_score}",
                "formula_multiplicative_green": "GreenSum = {green_sum}",
                "formula_confidence": "Konfidence = GreenSum − RedPenalty = {green_sum} − {red_sum} = {final_score}",
                "decision_passed": "{score_label} {final_score} {comparison} {threshold} → důvěryhodné",
                "decision_failed": "{score_label} {final_score} {comparison} {threshold} → nedůvěryhodné",
                "finding": "Výsledek",
                "detected": "Zjištěno / Ano",
                "not_detected": "Nezjištěno / Ne",
                "certainty_label": "Jistota",
                "tokens_used": "Použité KI tokeny (Vstup: {tokens_in}, Výstup: {tokens_out})",
                "tokens_not_used": "Nebyl použit žádný KI token",
                "ai_checked_flags": "Vyhodnoceno KI",
                "local_checked_flags": "Lokálně ověřeno před KI",
                "parse_error": "Odpověď KI nebylo možné zpracovat jako JSON.",
                "flag_descriptions": {
                    "GREEN_01": "Povinná pole jsou kompletní (číslo faktury, datum, dodavatel, částky, daňové údaje).",
                    "GREEN_02": "Historická plausibilita u dodavatele (podobné částky, struktura, popisy a intervaly).",
                    "GREEN_03": "E‑mail odesílatele je známý (odpovídá kmenovým datům nebo historickým e‑mailům dodavatele).",
                    "GREEN_04": "Částky působí vzhledem ke službě věrohodně (odhadovaná cenová úroveň odpovídá částce).",
                    "GREEN_05": "Faktura se vztahuje k jasnému období plnění (období je uvedeno a nepřekrývá se).",
                    "GREEN_06": "Bankovní údaje odpovídají kmenovým datům (IBAN/příjemce se přesně shoduje).",
                    "RED_01": "E‑mail odesílatele se liší (nová nebo mírně změněná doména).",
                    "RED_02": "Období se překrývá se stávajícími fakturami (období je již pokryto).",
                    "RED_03": "Vysoká částka nebo vysoké inherentní riziko (částka nad limitem nebo riziková kategorie).",
                    "RED_04": "Náhlý nárůst částky u stejného dodavatele (výrazný růst bez zjevného důvodu).",
                    "RED_05": "Objednávka/smlouva chybí nebo se odchyluje (historicky očekáváno, ale chybí, nebo výrazný nesoulad s navázanou objednávkou).",
                    "RED_06": "Odlišné bankovní údaje oproti kmenovým datům (nový/změněný IBAN)."
                }
            },
            "upload": {
                "title": "Nahrajte nové faktury",
                "info": "Přetažením nebo kliknutím sem nahrajte jednu nebo více faktur (*.pdf až 30 MB).",
                "info_attachments": "Přetáhněte soubory nebo klikněte zde pro nahrání jednoho či více příloh (až 30 MB na soubor).",
                "create_btn": "Spusťte rozpoznávání faktur",
                "file_invalid": "Nahrávejte pouze soubory PDF or XML do velikosti 30 MB.",
                "no_preview_available": "Pro tento typ souboru není k dispozici žádný náhled. <br>Stáhněte si soubor a otevřete jej na svém počítači.",
                "settings": "Nastavení",
                "group_by_tax": "Seskupit podle sazby DPH při rozpoznávání",
                "group_by_tax_hint": "Je-li zapnuto, rozpoznané řádky budou při nahrání seskupeny podle sazby DPH (např.: Součet 19 % DPH).",
                "ai_validation": "Aktivovat validaci KI",
                "ai_validation_hint": "Pokud je aktivováno, faktura se po rozpoznání KI přesune přímo do stavu „Připraveno k exportu“, pokud nejsou vyžadovány žádné kroky schvalování.",
                "ai_validation_mode": "Validace KI",
                "ai_validation_mode_none": "Bez validace KI",
                "ai_validation_auto_forward": "Aktivovat a přesunout do stavu „Připraveno k exportu“",
                "ai_validation_auto_forward_hint": "Pokud je aktivováno, faktura se po rozpoznání KI přesune přímo do stavu „Připraveno k exportu“, pokud nejsou vyžadovány žádné kroky schvalování.",
                "ai_validation_advisory": "Aktivovat a ponechat stav beze změny",
                "ai_validation_advisory_forced": "Již aktivní, stav zůstává beze změny",
                "ai_validation_advisory_hint": "Pokud je aktivováno, KI ověří fakturu, zapíše výsledek do časové osy a zobrazí detaily skóre bez přeskočení běžného workflow.",
                "tour": {
                    "before_attach": "Zde můžete nahrát jednu nebo více faktur přetažením nebo kliknutím v této oblasti.",
                    "after_attach_title": "Spusťte rozpoznávání faktur",
                    "after_attach": "Zde můžete spustit automatické rozpoznání všech nahraných faktur. Poté budete přesměrováni na přehled první faktury. Ostatní faktury budou k dispozici v seznamu úkolů."
                }
            },
            "tabs": {
                "lines": "Položky",
                "discount": "Sleva",
                "payment": "Platební údaje",
                "transactions": "Transakce",
                "notes": "Poznámky",
                "recognition": "Surová data rozpoznání dokladu"
            },
            "linked_transactions": {
                "title": "Přiřazené transakce",
                "empty": "Nebyly nalezeny žádné přiřazené transakce.",
                "load_error": "Přiřazené transakce se nepodařilo načíst.",
                "statement": "Výpis",
                "match_type": "Typ přiřazení",
                "allocated_amount": "Přiřazená částka",
                "match_type_direct": "Přímé",
                "match_type_manual": "Rozdělené"
            },
            "new": "Nová faktura",
            "select_contract_or_procurement": "Smlouva / Požadavek na objednávku",
            "payment_conditions": "Platební podmínky",
            "discount1": "Sleva 1",
            "discount2": "Sleva 2",
            "discount_percentage": "Procento",
            "discount_amount": "Množství",
            "discount_days": "Dny",
            "discount_payment_date": "datum",
            "invoice_discount_data": "Údaje o skontu na dokladu",
            "supplier_discount_data": "Údaje o skontu v kmenových údajích",
            "business_partner_discount_data": "Údaje o skontu v kmenových údajích obchodního partnera",
            "copy_discount_data_to_supplier": "Přenést z dokladu do kmenových údajů",
            "copy_discount_data_to_supplier_tooltip": "Po kliknutí se údaje o skontu zadané ve formuláři zkopírují do kmenových údajů dodavatele.",
            "copy_discount_data_to_business_partner_tooltip": "Po kliknutí se údaje o skontu zadané ve formuláři zkopírují do kmenových údajů obchodního partnera.",
            "download_pdf": "Stáhnout PDF",
            "download_pdf_info": "Pokud se PDF nezobrazí, zkontrolujte nastavení prohlížeče a ujistěte se, že je možnost \"Vždy stahovat soubory PDF\" vypnutá.",
            "download_xml": "Stáhnout XML",
            "download_xml_info": "Stáhne původní XML soubor FatturaPA.",
            "visualization_generated_hint": "Toto PDF bylo vygenerováno z XML e-faktury. Právně závazný zůstává XML.",
            "visualization_compare_hint": "PDF z XML ukazuje obsah XML; původní PDF se může lišit. Právně závazný zůstává XML.",
            "visualization_version_hint": "Verze vizualizace: {version}.",
            "visualization_history": "Verze PDF",
            "visualization_history_title": "Verze PDF",
            "visualization_version_label": "Verze PDF {version}",
            "visualization_current_version": "Aktuální",
            "visualization_version_created_at": "Vytvořeno: {date}",
            "visualization_version_renderer": "Verze vykreslování: {renderer}",
            "visualization_version_view": "Zobrazit",
            "visualization_version_download": "Stáhnout",
            "visualization_version_loading": "Načítání PDF ...",
            "visualization_version_load_error": "Verzi PDF se nepodařilo načíst.",
            "regenerate_visualization": "Znovu vygenerovat PDF",
            "regenerate_visualization_title": "Znovu vygenerovat PDF",
            "regenerate_visualization_confirm": "PDF bude znovu vygenerováno pomocí aktuální verze vykreslování. Předchozí verze zůstane zachována. Chcete pokračovat?",
            "regenerate_visualization_confirm_button": "Znovu vygenerovat",
            "regenerate_visualization_success": "Verze PDF {version} byla úspěšně vygenerována.",
            "regenerate_visualization_error": "PDF se nepodařilo znovu vygenerovat.",
            "document_tabs": {
                "xml": "XML",
                "preview": "Náhled",
                "pdf": "PDF",
                "original_pdf": "Původní PDF",
                "visualization": "KoSIT-PDF",
                "fatturapa": "FatturaPA",
                "fatturapa_pdf": "FatturaPA-PDF"
            },
            "fatturapa_preview": {
                "eyebrow": "FatturaPA",
                "invoice": "Faktura",
                "credit_note": "Dobropis",
                "debit_note": "Vrubopis",
                "number": "Číslo",
                "date": "Datum",
                "profile": "Formát",
                "order_data": "Údaje objednávky",
                "order_number": "Číslo",
                "purchase_order_number": "Číslo objednávky",
                "line_reference": "Odkaz na řádek",
                "order_reference": "Odkaz na objednávku",
                "item_number": "Číslo položky",
                "convention_code": "Kód smlouvy",
                "cup": "CUP",
                "cig": "CIG",
                "supplier": "Dodavatel",
                "customer": "Odběratel",
                "vat_id": "DIČ",
                "fiscal_code": "Daňový kód",
                "lines": "Položky",
                "description": "Popis",
                "qty": "Množství",
                "unit_price": "Jedn. cena",
                "discount": "Sleva",
                "document_discount": "Sleva dokladu",
                "line_total": "Celkem položka",
                "vat": "DPH",
                "taxable": "Základ daně",
                "tax": "Daň",
                "total": "Celkem",
                "payment": "Platba",
                "payment_method": "Způsob",
                "show_xml": "Zobrazit XML",
                "hide_xml": "Skrýt XML",
                "footnote": "Lokální náhled FatturaPA — právně závazný zůstává XML. Nejde o výsledek SDI."
            },
            "notes_datev_hint": "Tato poznámka bude prostřednictvím DATEV Unternehmen Online předána daňovému poradci.",
            "recognition_data_title": "Rozpoznávání nezpracovaných dat",
            "no_recognition_data": "Nebyla rozpoznána žádná data.",
            "repeat_recognition_btn": "Zopakovat rozpoznání dokumentu",
            "repeat_recognition_confirm_btn": "Potvrdit",
            "repeat_recognition_confirm_msg": "Existující data ve formuláři budou přepsána. Opravdu chcete pokračovat?",
            "repeat_recognition_confirm_title": "Zopakovat rozpoznání dokumentu",
            "repeat_recognition_feedback_msg": "Rozpoznávání dokumentu probíhá na pozadí a může to trvat několik sekund.",
            "select_columns_btn": "Vybrat sloupce",
            "export_to_datev_btn": "Odeslat do DATEV",
            "export_to_datev_csv_btn": "Exportovat DATEV CSV",
            "export_to_ms365_btn": "Odeslat do D365",
            "export_btn_incomplete_form_tooltip": "Prosím, doplňte údaje faktury.",
            "export_btn_send_to_clearing_tooltip": "Chcete-li znovu přenést do D365, pošlete prosím znovu na účetnictví prostřednictvím kroku 'Vyjasnění'.",
            "export_error": "<b>Faktura nemohla být odeslána</b>.<br>",
            "no_export_config_datev_tooltip": "Nebyla nastavena žádná připojení k <b>{export_name}</b>. <br>V konfiguraci nebyl přiřazen žádný klient DATEV pro vybranou společnost <b>{client_name}</b>. <br>V případě potřeby kontaktujte osobu s administrátorskými právy <br>pro nastavení připojení v administrační oblasti.",
            "no_export_config_tooltip": "Nebylo nastaveno žádné připojení k {export_name}.<br>Obraťte se na osobu s administrátorskými právy, aby nastavila připojení v administrativní oblasti.",
            "confirm_before_leave_msg": "Vaše faktura nebyla uložena. Opravdu chcete stránku opustit?",
            "can_not_edit": "Nemáte oprávnění upravovat data. Chcete-li tak učinit, zašlete fakturu do zúčtování pomocí Akce.",
            "recognized_client_id": "Společnost byla úspěšně identifikována na základě <b>DIČ</b> a <b>názvu</b>.<br> <b>Společnost:</b> {client_name}",
            "user_client_id": "Společnost byla přiřazena na základě <b>uživatelského profilu</b> nahrávajícího.<br><b>Společnost:</b> {client_name}",
            "field_origin": {
                "title": "Původ předvýběru",
                "source_label": "Zdroj",
                "history_title": "Historie rozpoznání",
                "run_title": "{date} · {count} pole{status}{model}",
                "unknown_run": "Neznámé rozpoznání",
                "field_column": "Pole",
                "before_column": "Předtím",
                "after_column": "Poté",
                "reason_column": "Důvod",
                "empty_value": "Prázdné",
                "ai_history_title": "Historie zpracování AI",
                "ai_request_label": "Prompt požadavku",
                "ai_response_label": "Odpověď AI",
                "ai_system_prompt_label": "Systémový prompt",
                "ai_user_prompt_label": "Uživatelský prompt",
                "ai_sources_label": "Zdroje vlastních promptů",
                "ai_tenant_prompt_label": "Prompt tenanta",
                "ai_client_prompt_label": "Prompt klienta",
                "ai_supplier_prompt_label": "Prompt dodavatele",
                "ai_recognition": "Rozpoznání faktury",
                "ai_custom_prompt": "Následné zpracování vlastním promptem",
                "ai_supplier_identification": "Identifikace dodavatele",
                "ai_validation": "Ověření faktury",
                "ai_succeeded": "Úspěšné",
                "ai_failed": "Neúspěšné",
                "ai_model_only": "Model: {model}",
                "ai_model_group_tag": "Skupina modelů: {group}",
                "ai_model_group_and_model": "Skupina modelů: {group} · Model: {model}",
                "source_types": {
                    "recognition": "Rozpoznání dokumentu",
                    "procurement": "Objednávka",
                    "supplier_master_data": "Kmenová data dodavatele",
                    "business_partner_master_data": "Kmenová data obchodního partnera",
                    "creator_default": "Profil nahrávajícího"
                },
                "reasons": {
                    "invoice_number_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "total_netto_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "total_brutto_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "invoice_date_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "due_date_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "delivery_date_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "document_discount_amount_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "document_discount_base_amount_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "document_discount_percentage_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "document_discount_tax_percentage_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "client_matched_by_receiver_name_or_vat": "Vybráno, protože rozpoznaný příjemce faktury odpovídal společnosti podle názvu nebo DIČ.",
                    "client_matched_by_supplier_name_or_vat": "Vybráno, protože rozpoznaný vystavitel faktury odpovídal společnosti podle názvu nebo DIČ.",
                    "client_from_creator_profile": "Převzato ze společnosti přiřazené nahrávajícímu.",
                    "client_from_procurement": "Převzato z přiřazené objednávky.",
                    "supplier_matched_by_name_vat_or_iban": "Vybráno, protože rozpoznaná data dodavatele odpovídala dodavateli podle názvu, DIČ nebo IBAN.",
                    "business_partner_matched_by_name_vat_or_iban": "Vybráno, protože rozpoznaná data protistrany odpovídala obchodnímu partnerovi podle názvu, DIČ nebo IBAN.",
                    "business_partner_matched_by_receiver_name_or_vat": "Vybráno, protože rozpoznaný příjemce faktury odpovídal obchodnímu partnerovi podle názvu nebo DIČ.",
                    "supplier_from_single_procurement_supplier": "Vybráno, protože přiřazená objednávka má právě jednoho dodavatele.",
                    "procurement_matched_by_recognized_reference": "Vybráno, protože rozpoznaná reference objednávky odpovídá této objednávce.",
                    "procurement_matched_by_invoice_similarity": "Vybráno, protože částka, datum a položky odpovídají faktuře.",
                    "procurement_matched_by_invoice_similarity_without_supplier": "Vybráno, protože částka, datum a položky odpovídaly faktuře ještě před výběrem dodavatele.",
                    "ledger_account_from_procurement": "Převzato z přiřazené objednávky.",
                    "cost_center_from_procurement": "Převzato z přiřazené objednávky.",
                    "cost_type_from_procurement": "Převzato z přiřazené objednávky.",
                    "profit_center_from_supplier_master_data": "Převzato z kmenových dat dodavatele.",
                    "profit_center_from_business_partner_master_data": "Převzato z kmenových dat obchodního partnera.",
                    "department_from_procurement": "Převzato z přiřazené objednávky.",
                    "branch_from_procurement": "Převzato z přiřazené objednávky.",
                    "employee_from_procurement": "Převzato z přiřazené objednávky.",
                    "financial_dimension_from_procurement": "Převzato z přiřazené objednávky.",
                    "ledger_account_from_supplier_master_data": "Převzato z kmenových dat dodavatele.",
                    "cost_center_from_supplier_master_data": "Převzato z kmenových dat dodavatele.",
                    "ledger_account_from_business_partner_master_data": "Převzato z kmenových dat obchodního partnera.",
                    "cost_center_from_business_partner_master_data": "Převzato z kmenových dat obchodního partnera.",
                    "posting_key_from_recognized_tax": "Odvozeno z rozpoznané daňové sazby.",
                    "supplier_iban_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "supplier_bic_extracted_from_document": "Přímo extrahováno z rozpoznaného dokladu faktury.",
                    "payment_bank_data_extracted_from_document": "Zdroj bankovních údajů byl nastaven podle rozpoznaných údajů z dokladu."
                }
            },
            "client_address_check": {
                "match": "Byla provedena kontrola podle § 14 odst. 4 UStG a nebyly zjištěny žádné odchylky.",
                "unrecognized": "Adresu nebylo možné ověřit, protože nebyla na faktuře rozpoznána.",
                "mismatch_intro": "Byla provedena kontrola podle § 14 odst. 4 UStG a byla zjištěna odchylka:",
                "invoice_label": "Údaje na faktuře",
                "master_data_label": "Údaje v kmenových datech",
                "supplier_message_button": "Požádat o opravu",
                "supplier_message_greeting": "Vážené dámy a pánové,",
                "supplier_message_intro": "děkujeme za zaslání faktury.",
                "supplier_message_invoice_number_label": "Číslo faktury",
                "supplier_message_body": "Bohužel adresa/název naší společnosti uvedená na faktuře není správná. Podle § 14 odst. 4 UStG musí faktura obsahovat správnou adresu a název příjemce plnění, aby splňovala zákonné požadavky.",
                "supplier_message_outro": "Fakturu proto v její současné podobě nemůžeme akceptovat a žádáme vás o zaslání odpovídajícím způsobem opravené faktury se správnou adresou.",
                "supplier_message_questions": "V případě dotazů jsme vám rádi k dispozici.",
                "address_normalization": {
                    "street_aliases": ["ulice", "ul.", "ul", "třída", "trida", "tř.", "tr.", "náměstí", "namesti", "nám.", "nam.", "silnice", "sídliště", "sidliste"],
                    "number_aliases": ["číslo", "cislo", "č.", "c.", "č", "c", "popisné", "popisne", "orientační", "orientacni", "or.", "or", "ev.", "ev"]
                }
            },
            "no_client_recognized": "Žádná společnost nebyla identifikována na základě <b>DIČ</b> nebo <b>názvu</b>.<br> Zkontrolujte prosím, zda údaje společnosti v liftbase odpovídají údajům na faktuře.",
            "recognized_supplier_id": "Na základě <b>IBAN</b>, <b>DIČ</b> a <b>Jména</b> byl dodavatel úspěšně identifikován.<br> <b>Dodavatel:</b> {supplier_name} <br> <b>DIČ:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "supplier_custom_prompt_title": "Vlastní prompt dodavatele",
            "supplier_custom_prompt_applied": "Během rozpoznání faktury byl použit dodavatelský vlastní prompt.",
            "supplier_custom_prompt_supplier_label": "Dodavatel",
            "supplier_custom_prompt_source_label": "Zdroj",
            "supplier_custom_prompt_confidence_label": "Jistota",
            "supplier_custom_prompt_text_label": "Prompt",
            "supplier_custom_prompt_text_empty": "Pro tohoto dodavatele není aktuálně uložen žádný vlastní prompt.",
            "supplier_custom_prompt_source": {
                "sender_domain": "Doména odesílatele",
                "recognized_supplier_vat_iban": "DIČ/IBAN",
                "recognized_supplier_name": "Název dodavatele",
                "first_page_ai": "AI (1. stránka PDF, text)",
                "first_page_ai_file": "AI (1. stránka PDF, sken)"
            },
            "recognized_business_partner_id": "Na základě <b>IBAN</b>, <b>DIČ</b> a <b>Jména</b> byl obchodní partner úspěšně identifikován.<br> <b>Obchodní partner:</b> {supplier_name} <br> <b>DIČ:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "no_supplier_recognized": "Žádný dodavatel nebyl identifikován na základě <b>DIČ</b> nebo <b>názvu</b>.<br> Zkontrolujte prosím, zda údaje dodavatele v liftbase odpovídají údajům na faktuře.",
            "payment_details_not_equal": "Platební údaje dodavatele se neshodují s rozpoznanými údaji nebo s údaji z formuláře.<br> <b>Dodavatel:</b> {supplier_name} <br> <b>DIČ:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "payment_details_not_equal_business_partner": "Platební údaje obchodního partnera se neshodují s rozpoznanými údaji nebo s údaji z formuláře.<br> <b>Obchodní partner:</b> {supplier_name} <br> <b>DIČ:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "supplier_dialog_info": "\n<div style=\"text-align: justify\">\n    <style>\n        .modal-header {\n            margin-bottom: 0;\n        }\n\n        .modal-p {\n            margin-bottom: 10px !important;\n        }\n    </style>\n\n    <p class=\"modal-p\">\n        Zjistili jsme, že přiřazený dodavatel se změnil.\n    </p>\n\n    <p class=\"modal-p\">\n        <strong>Možný důvod:</strong><br>\n        Rozpoznávání dokladů nedokázalo přiřadit žádného nebo přiřadilo nesprávného dodavatele.\n    </p>\n\n    <b class=\"modal-header\">Optimalizujte automatické přiřazování</b>\n    <p class=\"modal-p\">\n        Věděli jste, že v <strong>liftbase</strong> můžete snadno zlepšit automatické přiřazování pro budoucí doklady?\n        Stačí uložit bankovní spojení (IBAN, BIC) nebo DIČ v kmenových údajích dodavatele.\n        <strong>liftbase</strong> tyto údaje použije k automatickému přiřazení správného dodavatele příště.\n    </p>\n    <p class=\"modal-p\">\n        V části <strong>„Platební údaje“</strong> můžete použít údaje rozpoznané systémem nebo zadat vlastní.\n    </p>\n\n    <img src=\"images/example-payment-data.png\" alt=\"Ukázkový pohled\"\n         style=\"border: 1px solid #9c9c9c; border-radius: 5px; max-width: 100%; margin-bottom: 10px;text-align: center\"><br>\n\n    <b class=\"modal-header\">Automatická kontrola bankovního spojení</b>\n    <p class=\"modal-p\">\n        Bankovní spojení uložené v <strong>liftbase</strong> je automaticky kontrolováno pro každý doklad.\n        Pokud doklad obsahuje jiné bankovní spojení, budete na to upozorněni.\n    </p>\n\n    <p class=\"modal-p\"><strong>Vaše výhody:</strong></p>\n    <ul>\n        <li>Spolehlivé odhalení podvodných faktur s falešnými bankovními údaji</li>\n        <li>Rychlé zjištění, kdy dodavatel změnil banku</li>\n    </ul>\n</div>",
            "supplier_dialog_title": "Automatické rozpoznání dodavatele",
            "total_brutto_missing": "Zadejte celkovou hrubou částku.",
            "total_brutto_zero": "Nesmí mít částku 0 {currency}.",
            "total_brutto_does_not_match_with_positions": "Celková částka musí odpovídat součtu pozic.",
            "total_brutto_difference": "Odchylka celko\u00ADv\u00E9 \u010D\u00E1st\u00ADky vs po\u00ADlo\u017E\u00ADky: {value}",
            "combination_invalid": "Kombinace účtu, nákladového místa a profitového centra není v D365 povolena.",
            "possible_combinations": "Možné kombinace",
            "current_combination": "Aktuální kombinace",
            "combination": "Kombinace",
            "total_invoiced": "Celková fakturovaná částka",
            "total_expected_procurement": "Celková hodnota objednávky",
            "total_expected_contract": "Celková hodnota smlouvy",
            "min_approval_one_person": "1 osoba",
            "min_approval_qty": "{qty} různé osoby",
            "min_approval_error_msg": "Schválení této faktury není dostatečné. Přidejte prosím další osobu ke schválení. Tato faktura musí být schválena <b>alespoň {min_approval_msg}</b>.",
            "min_approval_error_title": "Nedostatečné schválení",
            "no_approval_limit_msg": "Váš schvalovací limit není pro tuto fakturu dostatečný. Přidejte prosím další osobu ke schválení, která má potřebný schvalovací limit.",
            "no_approval_limit_title": "Schvalovací limit",
            "confirm_without_approval_limit_msg": "Žádná z vybraných osob nemá potřebný schvalovací limit pro částku této faktury. Potřebná schválení lze přidat později. Opravdu chcete pokračovat?",
            "confirm_without_approval_limit_title": "Schvalovací limit",
            "invoice_vat_number": "Rozpoznaná DIČ",
            "supplier_vat_number": "DIČ v kmenových údajích",
            "business_partner_vat_number": "DIČ v kmenových údajích obchodního partnera",
            "copy_vat_number_to_supplier": "Přenést do kmenových údajů",
            "supplier_payment_data": "Bankovní spojení v kmenových údajích",
            "business_partner_payment_data": "Bankovní spojení v kmenových údajích obchodního partnera",
            "invoice_payment_data": "Bankovní spojení na dokladu",
            "copy_payment_data_to_supplier": "Přenést z dokladu do kmenových údajů",
            "copy_payment_data_to_supplier_tooltip": "Po kliknutí se platební údaje zadané ve formuláři zkopírují do kmenových údajů dodavatele.",
            "copy_payment_data_to_business_partner_tooltip": "Po kliknutí se platební údaje zadané ve formuláři zkopírují do kmenových údajů obchodního partnera.",
            "magic_suggestions_btn_tooltip": "Návrhy vyplnění na základě předchozích faktur od stejného dodavatele",
            "magic_suggestions_btn_tooltip_business_partner": "Návrhy vyplnění na základě předchozích faktur od stejného obchodního partnera",
            "magic_suggestions_dialog": {
                "title": "Návrhy pro tuto fakturu",
                "message": "Vyberte pole, která chcete vyplnit na základě jiných faktur tohoto dodavatele.",
                "info_based_on_invoices": "Návrhy vycházejí z následujících RE čísel:",
                "select_supplier_msg": "Pro vyhledání návrhů vyberte ve formuláři dodavatele.",
                "no_data": "Pro tohoto dodavatele nebyly nalezeny žádné návrhy.",
                "error_load": "Při načítání návrhů došlo k chybě.",
                "applied_success": "Návrhy byly použity."
            },
            "magic_suggestions_dialog_business_partner": {
                "message": "Vyberte pole, která chcete vyplnit na základě jiných faktur tohoto obchodního partnera.",
                "select_supplier_msg": "Pro načtení návrhů vyberte ve formuláři obchodního partnera.",
                "no_data": "Pro tohoto obchodního partnera nebyly nalezeny žádné návrhy."
            },
            "procurement_summary": {
                "dialog_title": "Obsah požadavku na nákup",
                "open_dialog": "Zobrazit detaily",
                "line_count": "{count} položek v přehledu",
                "empty": "Pro tento požadavek na nákup nejsou k dispozici žádné položky.",
                "empty_filtered": "V požadavku na nákup nebyly pro vybraného dodavatele \"{supplier_name}\" nalezeny žádné položky.",
                "filtered_by_supplier": "Zobrazují se pouze položky dodavatele \"{supplier_name}\".",
                "item": "Položka"
            },
            "lines": {
                "add_tooltip": "Přidat řádek faktury",
                "get_from_recognition": "Převzít z rozpoznávání dokladů",
                "show_mismatch_panel_button": "Zobrazit odchylky",
                "hide_mismatch_panel_button": "Skrýt odchylky",
                "mismatch_warning_title": "Zjištěny rozdíly mezi vypočteným a dokladovým hrubým",
                "match_suggestion": "Návrh",
                "match_confirmed": "Potvrzeno",
                "match_automatic": "Automaticky",
                "match_automatic_suggestion": "Autom. návrh",
                "confirm_match": "Potvrdit shodu",
                "review_match": "Zkontrolovat",
                "match_confirm_dialog": {
                    "title": "Potvrdit přiřazení položky",
                    "message": "Tyto položky mohou odpovídat. Zkontrolujte prosím hodnoty a vyberte, jak má být přiřazení uloženo.",
                    "copied_fields_title": "Další data, která budou převzata",
                    "copy_hint": "Pouze přiřazení potvrdí odkaz na objednávku. Převzetí dat zkopíruje také nákladové středisko, účet a finanční dimenze do položky faktury.",
                    "link_only_btn": "Potvrdit pouze přiřazení",
                    "copy_data_btn": "Potvrdit a převzít data"
                },
                "legend": {
                    "description": "Legenda",
                    "no_order": "Položka není součástí objednávky.",
                    "variance": "Rozptyl ve vyznačených sloupcích.",
                    "not_invoiced": "Objednané zboží nebylo na faktuře nalezeno.",
                    "matched": "Zboží v objednávce a na faktuře je totožné."
                },
                "group_by_tax": "Seskupit podle sazby DPH",
                "group_by_tax_hint": "Seskupit uložené řádky podle sazby DPH (např.: Součet 19 % DPH).",
                "form": {
                    "item": "Položka",
                    "new": "Nová fakturační linka",
                    "validation": {
                        "description_required": "Zadejte jméno.",
                        "item_number_required": "Zadejte číslo položky.",
                        "tax_percentage_required": "Vyberte prosím platnou daň.",
                        "unit_net_price_required": "Prosím zadejte platné číslo.",
                        "quantity_required": "Prosím zadejte platné číslo.",
                        "commercial_discount_invalid": "Sleva a její základ musí mít stejné znaménko, procenta musí být mezi 0 % a 100 % a sleva nesmí být vyšší než její základ."
                    },
                    "tour": {
                        "name": "Zadejte smysluplný název produktu.",
                        "number": "Zde můžete zadat číslo položky produktu.",
                        "price": "Zadejte daňovou sazbu a jednotkovou čistou cenu. Hrubá cena bude vypočtena pomocí daňové sazby."
                    }
                },
                "table": {
                    "source": "Zdroj",
                    "item_number": "Předmět číslo.",
                    "name": "Jméno",
                    "quantity": "množství",
                    "tax": "daň (%)",
                    "netto_price": "Jednotka netto",
                    "brutto_price": "Jednotka hrubá",
                    "line_discount_percentage": "Sleva (%)",
                    "show_discounts": "Zadat slevu",
                    "show_discounts_tooltip": "Zobrazí pole pro slevu z jednotkové ceny a slevu položky. Automaticky se aktivuje, pokud je sleva vyplněna.",
                    "unit_price_base_amount": "Jednotková cena před slevou z ceny",
                    "unit_price_base_amount_tooltip": "Původní cena za jednotku před odečtením slevy z ceny.",
                    "unit_price_discount_amount": "Sleva z ceny za jednotku",
                    "unit_price_discount_amount_tooltip": "Částka slevy za jednotku odečtená z původní jednotkové ceny.",
                    "line_discount_amount": "Celková sleva položky",
                    "line_discount_amount_tooltip": "Částka slevy za celou položku faktury, nikoli za jednotku.",
                    "line_discount_base_amount": "Základ slevy položky",
                    "line_discount_base_amount_tooltip": "Celková částka položky, na kterou se sleva uplatňuje.",
                    "line_discount_percentage_tooltip": "Procento uplatněné na celou položku faktury.",
                    "calc_brutto_from_net": "Vypočítat hrubou z čisté",
                    "calc_net_from_brutto": "Vypočítat čistou z hrubé",
                    "calc_brutto_from_net_tooltip": "Vypočítá pouze jednotkovou hrubou cenu z jednotkové čisté ceny a sazby daně. Sleva položky se nemění.",
                    "calc_net_from_brutto_tooltip": "Vypočítá pouze jednotkovou čistou cenu z jednotkové hrubé ceny a sazby daně. Sleva položky se nemění.",
                    "discount_validation_error": "Zkontrolujte hodnoty označené červeně.",
                    "total_netto_price": "Celková čistá",
                    "tax_amount": "Celková daň",
                    "total_brutto_price": "Celkový hrubý",
                    "cost_center": "Nákladové středisko",
                    "profit_center": "Profit center",
                    "ledger_account": "Sekundární účet",
                    "tax_group": "Daňová skupina",
                    "tax_item_group": "Daňová skupina položek",
                    "open_bcase": "Otevřít dokument",
                    "no_order_position": "Nebyly nalezeny žádné pozice objednávky. K faktuře prosím přiřaďte <b>nákupní objednávku (PO)</b> a <b>dodavatele</b>.",
                    "no_contract_position": "Nebyly nalezeny žádné smluvní položky. Přiřaďte prosím k faktuře <b>smlouvu a dodavatele</b>.",
                    "copy_from_procurement": "Vložte všechny položky z objednávky",
                    "copy_from_contract": "Vložit všechny položky ze smlouvy",
                    "no_order_tooltip": "Zatím není propojena žádná objednávka.",
                    "no_supplier_tooltip": "Zatím není připojen žádný dodavatel.",
                    "validation_error": "Opravte prosím chyby v tabulce."
                }
            },
            "export_dialog": {
                "title": {
                    "D365": "Vytvořit deník",
                    "DATEV": "Odeslat do DATEV",
                    "DATEV CSV": "Export DATEV CSV"
                },
                "description": "Následující doklady budou odeslány na {export_name}.",
                "description_csv": "Následující doklady budou exportovány pro {export_name}.",
                "btn_confirm": "Odeslat",
                "btn_confirm_csv": "Exportovat",
                "btn_finish": "Zavřít",
                "export_feedback_csv": "Exportováno",
                "export_feedback": "Odesláno",
                "exported_csv": "Exportováno",
                "exported": "Odesláno",
                "continue_background": "Pokračovat na pozadí",
                "exported_at": "Naposledy exportováno",
                "is_loading": "Odesílání probíhá",
                "is_loading_csv": "Exportování probíhá",
                "include_exported": "Zahrnout již exportované faktury",
                "export_selected_invoices_btn": "Odeslat výběr ({quantity}) do {export_name}",
                "export_cancelled_invoices_btn": "Odeslat vybrané zrušené ({quantity}) do {export_name}",
                "export_all_cancelled_invoices_btn": "Odeslat všechny zrušené ({quantity}) do {export_name}",
                "export_all_invoices_btn": "Odeslat všechny doklady ({quantity}) do {export_name}"
            },
            "export_menu": {
                "title": "Export",
                "group_ready": {
                    "title": "Export: Dokončené faktury"
                },
                "group_cancelled": {
                    "title": "Export: Zrušené faktury"
                }
            },
            "bulk_cancel_dialog": {
                "selected_btn": {
                    "invoice": "Zrušit vybrané faktury ({quantity})",
                    "outgoing-invoice": "Zrušit vybrané vydané faktury ({quantity})",
                    "procurement": "Zrušit vybrané objednávky ({quantity})",
                    "contract": "Zrušit vybrané smlouvy ({quantity})",
                    "mixed": "Zrušit vybrané doklady ({quantity})"
                },
                "confirm_title": {
                    "invoice": "Zrušit faktury",
                    "outgoing-invoice": "Zrušit vydané faktury",
                    "procurement": "Zrušit objednávky",
                    "contract": "Zrušit smlouvy",
                    "mixed": "Zrušit doklady"
                },
                "confirm_message": {
                    "invoice": "Opravdu chcete zrušit všechny vybrané faktury ({quantity})?",
                    "outgoing-invoice": "Opravdu chcete zrušit všechny vybrané vydané faktury ({quantity})?",
                    "procurement": "Opravdu chcete zrušit všechny vybrané objednávky ({quantity})?",
                    "contract": "Opravdu chcete zrušit všechny vybrané smlouvy ({quantity})?",
                    "mixed": "Opravdu chcete zrušit všechny vybrané doklady ({quantity})?"
                },
                "confirm_btn": {
                    "invoice": "Zrušit faktury",
                    "outgoing-invoice": "Zrušit vydané faktury",
                    "procurement": "Zrušit objednávky",
                    "contract": "Zrušit smlouvy",
                    "mixed": "Zrušit doklady"
                },
                "success": {
                    "invoice": "{quantity} faktur bylo zrušeno.",
                    "outgoing-invoice": "{quantity} vydaných faktur bylo zrušeno.",
                    "procurement": "{quantity} objednávek bylo zrušeno.",
                    "contract": "{quantity} smluv bylo zrušeno.",
                    "mixed": "{quantity} dokladů bylo zrušeno."
                },
                "partial_success": {
                    "invoice": "{successCount} z {quantity} faktur bylo zrušeno.",
                    "outgoing-invoice": "{successCount} z {quantity} vydaných faktur bylo zrušeno.",
                    "procurement": "{successCount} z {quantity} objednávek bylo zrušeno.",
                    "contract": "{successCount} z {quantity} smluv bylo zrušeno.",
                    "mixed": "{successCount} z {quantity} dokladů bylo zrušeno."
                },
                "error": {
                    "invoice": "Vybrané faktury nebylo možné zrušit.",
                    "outgoing-invoice": "Vybrané vydané faktury nebylo možné zrušit.",
                    "procurement": "Vybrané objednávky nebylo možné zrušit.",
                    "contract": "Vybrané smlouvy nebylo možné zrušit.",
                    "mixed": "Vybrané doklady nebylo možné zrušit."
                }
            },
            "bulk_repeat_recognition_dialog": {
                "bulk_repeat_recognition_selected_invoices_btn": "Zopakovat rozpoznání dokumentu ({quantity})",
                "confirm_title": "Zopakovat rozpoznání dokumentu",
                "confirm_message": "Stávající data ve vybraných fakturách ({quantity}) budou přepsána. Opravdu chcete pokračovat?",
                "intro_message": "Rozpoznání dokumentu bude znovu spuštěno pro vybrané faktury ({quantity}). Stávající data ve formuláři mohou být přepsána.",
                "background_notice": "Můžete to spustit hned a počkat na zpětnou vazbu, nebo proces rovnou spustit na pozadí.",
                "run_now_btn": "Spustit nyní",
                "run_background_btn": "Spustit na pozadí",
                "background_started": "Rozpoznání dokumentu bylo spuštěno na pozadí pro {quantity} faktur.",
                "success": "Rozpoznání dokumentu bylo znovu spuštěno pro {quantity} faktur.",
                "partial_success": "Rozpoznání dokumentu bylo znovu spuštěno pro {successCount} z {quantity} faktur.",
                "error": "Rozpoznání dokumentu pro vybrané faktury nebylo možné znovu spustit."
            },
            "select_columns_dialog": {
                "title": "Vybrat sloupce",
                "select_fields": "Následující sloupce budou zobrazeny pod <i>Moje úkoly</i> a <i>Všechny dokumenty</i>.",
                "btn_confirm": "Použít",
                "btn_finish": "Zavřít"
            },
            "copy_procurement_dialog": {
                "title": "Zkopírujte data z objednávky",
                "message": "Přejete si zkopírovat některá data z objednávky do této faktury?",
                "message_contract": "Chcete do této faktury převzít některá data ze smlouvy?",
                "overwrite_checkbox": "Přepsat existující data ve formuláři.",
                "select_supplier_msg": "Vyberte dodavatele, od kterého chcete data zkopírovat:",
                "select_supplier_placeholder": "Vyberte dodavatele",
                "confirm_btn": "Potvrdit"
            },
            "copy_from_recognition_dialog": {
                "title": "Načíst data",
                "message": "Chcete přenést některá data z rozpoznání faktury nebo z formuláře do tohoto dodavatele?",
                "add_payment_method": "Chcete také aktualizovat platební metodu?",
                "select_iban": "Vyberte z nalezených IBANů.",
                "select_vat_number": "Vyberte z nalezených DIČ.",
                "select_bic": "Vyberte z nalezených BIC.",
                "success_msg": "Dodavatel byl aktualizován.",
                "confirm_btn": "Potvrdit"
            },
            "validation": {
                "invoice_date_required": "Zadejte prosím datum faktury.",
                "due_date_required": "Zadejte prosím datum splatnosti.",
                "due_date_invalid1": "Datum splatnosti musí být větší než datum dokumentu.",
                "delivery_date_required": "Zadejte prosím datum doručení.",
                "ledger_account_required": "Vyberte účet hlavní knihy.",
                "branch_required": "Vyberte prosím pobočku.",
                "posting_key_required": "Vyberte klíč pro zaúčtování.",
                "document_discount_tax_required": "Vyberte sazbu DPH slevy dokladu, která je použita alespoň u jedné položky faktury.",
                "supplier_required": "Vyberte dodavatele.",
                "business_partner_required": "Vyberte obchodního partnera.",
                "cost_center_required": "Vyberte prosím nákladové středisko.",
                "profit_center_required": "Prosím, vyberte středisko zisku.",
                "employee_required": "Prosím, vyberte zaměstnance.",
                "d365_branch_id_required": "Vyberte prosím pobočku.",
                "d365_employee_id_required": "Prosím, vyberte zaměstnance.",
                "d365_department_required": "Prosím, vyberte oddělení D365.",
                "financial_dimension_required": "Vyberte prosím finanční dimenzi.",
                "client_required": "Vyberte prosím společnost.",
                "number_required": "Zadejte prosím číslo faktury.",
                "prefix_required": "Zadejte předponu a číslo faktury.",
                "number_invalid_d365": "Může obsahovat maximálně 20 znaků.",
                "number_invalid": "Musí obsahovat až 36 alfanumerických znaků, žádné přehlásky a znaky $ % & * + - /.",
                "notes_length": "Nesmí přesáhnout 120 znaků.",
                "discount_percentage_invalid1": "Procento slevy musí být větší než 0.",
                "discount_percentage_invalid2": "Sleva 1 musí být větší než sleva 2.",
                "discount_amount_invalid1": "Pro kladné fakturované částky jsou přijatelné pouze kladné částky.",
                "discount_amount_invalid2": "Pro záporné fakturované částky jsou přijatelné pouze záporné částky.",
                "discount_amount_invalid3": "Sleva 1 musí být větší než sleva 2.",
                "discount_amount_invalid4": "Sleva musí být nižší než celková částka.",
                "discount_amount_invalid5": "Součet částek slevy musí být menší než částka.",
                "discount_date_invalid1": "Data slevy 1 a 2 musí být mezi fakturou a datem splatnosti.",
                "discount_date_invalid2": "Datum slevy 1 musí být před datem slevy 2.",
                "missing_discount_field": "Je nutné vyplnit všechna pole pro slevy.",
                "procurement_required": "Vyberte prosím požadavek na nákup.",
                "contract_required": "Vyberte prosím smlouvu.",
                "iban_required": "Zadejte IBAN.",
                "bank_country_required": "Zadejte zemi banky.",
                "bank_country_invalid": "Zadejte dvoupísmenný kód země ISO.",
                "bank_account_required": "Zadejte číslo účtu.",
                "bank_code_required": "Zadejte bankovní kód."
            }
        }
    }
    ,
    "outgoing_invoice": {
        "description": "Odchozí faktura",
        "page": {
            "upload": {
                "title": "Nahrát nové odchozí faktury"
            }
        }
    }
    ,
    "invoice_line": {
        "item_number": "Číslo položky",
        "quantity": "Množství",
        "unit_net_price": "Jednotková čistá cena",
        "tax_percentage": "Daň",
        "has_discount": "Položka má slevu",
        "unit_price_base_amount": "Jednotková cena před slevou (BT-148)",
        "unit_price_discount_amount": "Sleva z jednotkové ceny (BT-147)",
        "line_discount_amount": "Sleva položky (BT-136)",
        "line_discount_base_amount": "Základ slevy položky (BT-137)",
        "line_discount_percentage": "Sleva položky % (BT-138)"
    }
    ,
    "location": {
        "name": "Jméno",
        "number": "Číslo",
        "address": "Adresa",
        "form_sequence": "name,number,address"
    }
    ,
    "spreadsheet": {
        "add_row": "Nový řádek",
        "download": "Stáhnout tabulku",
        "save": "Uložit tabulku"
    }
    ,
    "audit_log": {
        "description": "Úpravy",
        "history": "Úpravy",
        "table": "Stůl",
        "lb_user_id": "Uživatel",
        "data_before": "Před",
        "data_after": "Po",
        "created_at": "datum",
        "type": {
            "insert": "Přidal",
            "update": "Upraveno",
            "delete": "Odebráno"
        }
        ,
        "msg": {
            "deleted": "odstraněno",
            "inserted": "přidal",
            "was_deleted": "Byl odstraněn.",
            "was_inserted": "Byl přidán.",
            "created_by_historical_invoice_onboarding": "Vytvořeno během historického onboardingu faktur.",
            "created_by_historical_procurement_onboarding": "Vytvořeno během historického onboardingu objednávek."
        }
        ,
        "none": "žádný",
        "empty": "Nejsou k dispozici žádné úpravy."
    }
    ,
    "txt_before_leave_page": "Vaše změny nemusí být uloženy. Opravdu chcete pokračovat?",
    "easybill_invoice": {
        "from_tenant": "Od nájemce",
        "no_invoice": "Dosud nebyla vytvořena žádná faktura.",
        "number": "Číslo",
        "service_date": "Doba",
        "from": "Z",
        "until": "na",
        "total": "Celkový",
        "due_date": "Datum splatnosti",
        "status": "Stav",
        "paid_at": "Zaplaceno dne",
        "payment_missing": "čekající",
        "sepa": "SEPA",
        "tour": {
            "invoice_table": "Zde naleznete podrobný přehled všech liftbase faktur včetně jejich stavu. Faktury lze stáhnout pomocí tlačítka."
        }
    }
    ,
    "configuration": {
        "description": "Nastavení",
        "sepa_number": "Identifikační číslo věřitele",
        "sepa_mandate_reference": "Odkaz na mandát",
        "remove_sepa_msg": "Opravdu chcete zrušit SEPA inkaso?",
        "remove_sepa_btn": "Zrušit",
        "system-modules-procurement": "Modul - Žádosti o nákup",
        "system-modules-invoice": "Modul - Faktury",
        "system-modules-bank-statements": "Modul - Párování bankovních výpisů",
        "system-modules-permissions": "Modul - Skupiny oprávnění",
        "system-modules-multilingualism": "Modul - Vícejazyčná hlavní data",
        "system-modules-invoice-export": "Modul - Export faktur do",
        "purchaseorder-defaults-selectproduct": "Předvolby role - Osoba „Výběr produktu“",
        "purchaseorder-defaults-sendorder": "Předvolby role - Osoba „Odeslání objednávky“",
        "purchaseorder-defaults-clearing": "Předvolby role - Osoba „Vyrovnání nákupu“",
        "purchaseorder-defaults-consignee": "Předvolby role - Osoba „Příjem zboží“",
        "invoice-defaults-manual_check": "Předvolby role - Osoba „Manuální kontrola (faktura)“",
        "invoice-defaults-clearing": "Předvolby role - Osoba „Účetní vyrovnání“",
        "purchaseorder-defaults-init_seq": "Žádosti o nákup - Číslování objednávek od",
        "purchaseorder-product-require_product_group": "Žádosti o nákup - Všechny produkty musí být přiřazeny ke skupině produktů-",
        "purchaseorder-product-require_product_selection": "Žádosti o nákup - Proces žádosti o nákup",
        "email-send-order": "Objednávky - E-mailová objednávka",
        "purchaseorder-pdf-free-text": "Objednávky - PDF objednávky",
        "type_email-send-order": "html-i18n",
        "type_purchaseorder-pdf-free-text": "html-i18n",
        "invoice-recognition-lines": "Faktury - Automaticky vytvářet fakturační položky na základě rozpoznání dokumentu.",
        "invoice-recognition-timeout": "Faktury - Timeout rozpoznávání Azure",
        "invoice-form-procurement-required": "Faktury - Je požadován odkaz na žádost o nákup.",
        "notifications-mail-interval": "Upozornění - Interval e-mailů v minutách",
        "punchout-amazon-identity": "Integrace - Punch-out Amazon - Identita",
        "punchout-amazon-secret": "Integrace - Punch-out Amazon - Tajný klíč",
        "punchout-amazon-url": "Integrace - Punch-out Amazon - Punch-out URL",
        "punchout-amazon-order-url": "Integrace - Punch-out Amazon - URL objednávky",
        "punchout-amazon-email": "Integrace - Punch-out Amazon - E-mail",
        "punchout-amazon.supplier": "Integrace - Punch-out Amazon - Výchozí dodavatel",
        "punchout-mercateo-identity": "Integrace - Punch-out Mercateo - Identita",
        "punchout-mercateo-secret": "Integrace - Punch-out Mercateo - Tajný klíč",
        "punchout-mercateo-url": "Integrace - Punch-out Mercateo - Punch-out URL",
        "punchout-mercateo-order-url": "Integrace - Punch-out Mercateo - URL objednávky",
        "punchout-mercateo-email": "Integrace - Punch-out Mercateo - E-mail",
        "punchout-mercateo-supplier": "Integrace - Punch-out Mercateo - Výchozí dodavatel",
        "punchout-rajapack-identity": "Integrace - Punch-out RAJA - Identita",
        "punchout-rajapack-secret": "Integrace - Punch-out RAJA - Tajný klíč",
        "punchout-rajapack-url": "Integrace - Punch-out RAJA - Punch-out URL",
        "punchout-rajapack-order-url": "Integrace - Punch-out RAJA - URL objednávky",
        "punchout-rajapack-email": "Integrace - Punch-out RAJA - E-mail",
        "punchout-rajapack-supplier": "Integrace - Punch-out RAJA - Výchozí dodavatel",
        "punchout-conrad-identity": "Integrace - Punch-out Conrad - Identita",
        "punchout-conrad-secret": "Integrace - Punch-out Conrad - Tajný klíč",
        "punchout-conrad-url": "Integrace - Punch-out Conrad - Punch-out URL",
        "punchout-conrad-order-url": "Integrace - Punch-out Conrad - URL objednávky",
        "punchout-conrad-email": "Integrace - Punch-out Conrad - E-mail",
        "punchout-conrad-supplier": "Integrace - Punch-out Conrad - Výchozí dodavatel",
        "punchout-thgeyer-identity": "Integrace - Punch-out TH.GEYER - Identita",
        "punchout-thgeyer-secret": "Integrace - Punch-out TH.GEYER - Tajný klíč",
        "punchout-thgeyer-url": "Integrace - Punch-out TH.GEYER - Punch-out URL",
        "punchout-thgeyer-supplier": "Integrace - Punch-out TH.GEYER - Výchozí dodavatel",
        "punchout-reichelt-identity": "Integrace - Punch-out Reichelt - Identita",
        "punchout-reichelt-secret": "Integrace - Punch-out Reichelt - Tajný klíč",
        "punchout-reichelt-url": "Integrace - Punch-out Reichelt - Punch-out URL",
        "punchout-reichelt-supplier": "Integrace - Punch-out Reichelt - Výchozí dodavatel",
        "validation": {
            "bic_invalid": "Zadejte prosím platný BIC.",
            "iban_invalid": "Zadejte prosím platné číslo IBAN.",
            "default_decimal_places_invalid": "Zadejte 2 až 4 desetinná místa."
        }
        ,
        "datev": {
            "description": "DATEV",
            "connection": "Spojení s DATEV",
            "status_active": "Aktivní",
            "status_inactive": "Neaktivní",
            "from": "Z",
            "until": "Až do",
            "load_clients": "Načtěte klienty DATEV",
            "remove_connection": "Odebrat připojení",
            "deactivate_connection": "Deaktivovat připojení",
            "add_connection": "Nastavení připojení",
            "connected_by": "Spojení navázalo {name}.",
            "apps_manager": "Zde můžete spravovat <a href=\"https://apps.datev.de/tokrevui\" target=\"_blank\">aplikace spojené s DATEV</a>.",
            "msg_no_clients": "Nebyly nalezeny žádné záznamy nebo nemáte potřebná oprávnění nebo je nutné připojení znovu nastavit.",
            "fiscal_year_start": "Začátek fiskálního roku",
            "account_length": "Délka účtu",
            "is_accounts_payable_ledger_available": "Kniha závazků",
            "is_accounts_receivable_ledger_available": "Kniha pohledávek",
            "client_number": "Číslo klienta",
            "consultant_number": "Číslo konzultanta",
            "client_name": "Klient",
            "liftbase_client": "Společnost liftbase",
            "save_client": "Uložit společnost",
            "change_client": "Změnit společnost"
        }
        ,
        "ms365": {
            "description": "D365",
            "connection": "Připojení k D365",
            "status_active": "aktivní",
            "status_inactive": "neaktivní",
            "auth_type": "Autentizace",
            "oauth": "OAuth (souhlas uživatele)",
            "client_secret_auth": "Client Credentials (App Client ID + Secret)",
            "app_client_id": "App Client ID (Aplikace Azure)",
            "app_tenant_id": "Azure Tenant ID",
            "client_secret": "Client Secret",
            "client_credentials_note": "Pokud jsou zadány App Client ID a Client Secret, pro export faktur se použije tok Client Credentials. Import e‑mailů zůstává nezměněn (OAuth).",
            "connect_and_load_data": "Vytvořte spojení a načtěte data",
            "connect": "Vytvořte spojení",
            "load_data": "Načítají se všechna data",
            "remove_connection": "Odstranit připojení",
            "add_connection": "Nastavit připojení",
            "no_client_found": "Nebyli nalezeni žádní klienti D365.",
            "msg_no_clients": "Nebyly nalezeny žádné záznamy nebo vám chybí potřebná oprávnění, nebo je nutné připojení nastavit znovu.",
            "client_number": "Číslo firmy D365",
            "client_name": "Firma D365",
            "liftbase_client": "Firma liftbase",
            "save_client": "Uložit firmu",
            "change_client": "Změnit firmu",
            "sync_running": "Data se načítá. To může trvat několik minut.",
            "last_sync_at": "Naposledy načteno dne {last_sync_at}",
            "journal_name": "Journal Name",
            "org_url": "Org URL",
            "http_read_timeout": {
                "label": "HTTP read timeout for D365",
                "hint": "Defines how long liftbase waits for a D365 response. Leave empty to use the global backend configuration. Examples: <b>420s</b>, <b>5m</b>, <b>1h</b>.",
                "error": "Please enter a positive timeout, e.g. 420s, 5m, or 1h."
            },
        }
        ,
        "datev-csv": {
            "description": "DATEV CSV",
        }
        ,
        "template": {
            "module-procurement": {
                "group": "Moduly",
                "label": "Nákupní objednávka",
                "tour": [
                    {
                        "target": ".krokové moduly",
                        "content": "<p>Vyberte moduly výtahové základny, které chcete aktivovat. Informace o nákladech najdete na <a href=\"liftbase.de/preise\" target=\"_blank\">liftbase.de/preise</a>.</p>"
                    }
                ]
            }
            ,
            "module-invoice": {
                "group": "Moduly",
                "label": "Faktura"
            }
            ,
            "module-outgoing-invoice": {
                "group": "Moduly",
                "label": "Odchozí faktury"
            }
            ,
            "module-bank-statements": {
                "group": "Moduly",
                "label": "Párování bankovních výpisů"
            }
            ,
            "module-permissions": {
                "group": "Moduly",
                "label": "Skupina oprávnění"
            }
            ,
            "module-contract": {
                "group": "Moduly",
                "label": "Smlouvy"
            },
            "module-multilingualism": {
                "group": "Moduly",
                "label": "Vícejazyčná základní data"
            }
            ,
            "module-supplier-communication": {
                "group": "Moduly",
                "label": "Komunikace s dodavateli"
            }
            ,
            "module-liquidity-planning": {
                "group": "Moduly",
                "label": "Plánování likvidity"
            }
            ,
            "insolvency-law-fields": {
                "group": "Moduly",
                "label": "Zobrazit pole insolvenčního práva"
            }
            ,
            "approval-limit-priority": {
                "group": "Moduly",
                "label": "Úroveň priority schvalovacího limitu"
            },
            "custom-fields": {
                "group": "Moduly",
                "label": "Vlastní pole"
            },
            "module-invoice-export": {
                "group": "Moduly",
                "label": "Export faktury na",
                "options": [
                    {
                        "value": "datev",
                        "content": "DATEV"
                    },
                    {
                        "value": "ms365",
                        "content": "D365"
                    },
                    {
                        "value": "datev-csv",
                        "content": "DATEV CSV"
                    }
                ]
            }
            ,
            "procurement-select-product": {
                "group": "Výchozí role",
                "label": "Osoba \"Výběr produktu\"",
                "tour": [
                    {
                        "target": ".krok-přiřazení",
                        "content": "<p>Zde můžete nastavit výchozí globální role. Pokud pro společnost nebo oddělení nejsou definovány žádné výchozí hodnoty rolí, budou zde zadané osoby přiřazeny k příslušným krokům v pracovním postupu nákupních objednávek a faktur.</p>"
                    }
                ]
            }
            ,
            "procurement-send-order": {
                "group": "Výchozí role",
                "label": "Osoba \"Zadání objednávky\""
            }
            ,
            "procurement-clearing": {
                "group": "Výchozí role",
                "label": "Osoba \"Objasněno\"",
                "hint": "Pro objasnění procesů objednávání."
            }
            ,
            "procurement-consignee": {
                "group": "Výchozí role",
                "label": "Osoba \"Převzetí zboží\""
            }
            ,
            "invoice-manual-check": {
                "group": "Výchozí role",
                "label": "Osoba \"Ruční kontrola (faktura)\""
            }
            ,
            "invoice-clearing": {
                "group": "Výchozí role",
                "label": "Osoba \"Objasnění účetnictví\"",
                "hint": "Pro upřesnění při vyplňování faktur."
            }
            ,
            "contract-clearing": {
                "group": "Výchozí role",
                "label": "Osoba \"Objasnění smlouvy\"",
                "hint": "Pro objasnění ve smluvních procesech."
            }
            ,
            "procurement-init-seq": {
                "group": "Nákupní objednávky",
                "label": "Počáteční čísla objednávek",
                "hint": "Zadejte číslo, od kterého mají čísla objednávky začínat.",
                "validation": {
                    "interval": "Musí být mezi 0 a 999999999.",
                    "type": "Měl by obsahovat pouze celá čísla."
                }
                ,
                "tour": [
                    {
                        "target": ".krokové zadávání veřejných zakázek",
                        "content": "Zde najdete nastavení související s nákupními objednávkami. Nakonfigurujte počáteční číslo pro nákupní objednávky a zda musí být všechny produkty v nákupních objednávkách přiřazeny ke skupině produktů."
                    }
                ]
            }
            ,
            "procurement-require-product-group": {
                "group": "Nákupní objednávky",
                "label": "Všechny produkty musí patřit do skupiny produktů."
            },
            "procurement-skip-place-order": {
                "group": "Požadavky na nákup",
                "label": "Automatické odeslání objednávky do online obchodu",
                "hint": "Po PunchOut čeká online obchod na schválení v objednávkovém systému. Bez této možnosti je nutné přenos spustit ručně pomocí tlačítka „Odeslat elektronicky“. S touto možností je objednávka po schválení automaticky elektronicky odeslána. Funguje pouze pro objednávky s jedním dodavatelem."
            },
            "procurement-require-product-selection": {
                "group": "Nákupní objednávky",
                "label": "Nákupní objednávky",
                "options": [
                    {
                        "value": "skutečný",
                        "content": "s výběrem produktu<br><ul><li>Vytvořit objednávku</li><li>Výběr produktu</li><li>Schválení</li><li>Objednávka</li><li>Příjem zboží </li></ul>"
                    },
                    {
                        "value": "Nepravdivé",
                        "content": "bez výběru produktu<br><ul><li>Vytvořit objednávku</li><li>Schválení</li><li>Objednávka</li><li>Příjem zboží</li></ul>"
                    }
                ]
            }
            ,
            "email-send-order": {
                "group": "Objednávky",
                "label": "Objednávka e-mail",
                "hint": "E-mailová zpráva vygenerovaná během kroku zadávání objednávky, včetně PDF objednávky, a odeslaná dodavateli.",
                "default_value": "Vážený pane/paní,<br>Posílám Vám naši objednávku jako přílohu PDF. Zašlete nám prosím potvrzení objednávky.",
                "tour": [
                    {
                        "target": ".step-e-mail-order-free-text",
                        "content": "Zde napište text, který bude zahrnut do e-mailové zprávy vygenerované během kroku zadání objednávky, včetně PDF objednávky, a odeslán dodavateli."
                    },
                    {
                        "target": ".step-pdf-free-text",
                        "content": "Zde vytvořte text, který se v kroku zadání objednávky zobrazí na vygenerovaném objednávkovém PDF, které bude následně odesláno dodavateli."
                    }
                ]
            }
            ,
            "procurement-pdf-free-text": {
                "group": "Objednávky",
                "label": "Objednávka PDF",
                "hint": "Zpráva zobrazená na vygenerovaném PDF nákupní objednávky během kroku zadání objednávky, která bude následně odeslána dodavateli.",
                "default_value": "",
            },
            "procurement-pdf-show-department": {
                "group": "Objednávky",
                "label": "Zobrazit oddělení v PDF objednávky"
            },
            "procurement-pdf-show-cost-center": {
                "group": "Objednávky",
                "label": "Zobrazit nákladové středisko v PDF objednávky"
            },
            "procurement-pdf-show-created-by": {
                "group": "Objednávky",
                "label": "Zobrazit „Vytvořil(a)“ v PDF objednávky"
            },
            "procurement-pdf-show-approver": {
                "group": "Objednávky",
                "label": "Zobrazit schvalovatele v PDF objednávky"
            },
            "procurement-pdf-show-offer": {
                "group": "Objednávky",
                "label": "Zobrazit nabídku v seznamu položek"
            },
            "procurement-pdf-show-vat-number": {
                "group": "Objednávky",
                "label": "Zobrazit DIČ v PDF objednávky"
            }
            ,
            "invoice-recognition-lines": {
                "group": "Faktury",
                "label": "Automaticky převzít položky, které rozpoznávání dokladů identifikovalo."
            }
            ,
            "invoice-recognition-group-by-tax": {
                "group": "Faktury",
                "label": "Seskupit rozpoznané položky faktury podle sazby DPH",
                "hint": "Je-li zapnuto, rozpoznané položky se seskupí podle sazby DPH (např.: Součet 19 % DPH)."
            }
            ,
            "invoice-recognition-ai-validation-mode": {
                "group": "Faktury",
                "label": "Výchozí režim validace AI při nahrávání faktur",
                "hint": "Tento režim je při nahrávání předvolený a před vytvořením faktury jej lze změnit.",
                "options": [
                    {
                        "value": "none",
                        "content": "Bez validace AI"
                    },
                    {
                        "value": "advisory",
                        "content": "Aktivovat a ponechat stav beze změny"
                    },
                    {
                        "value": "ready-for-export",
                        "content": "Aktivovat a přesunout do stavu „Připraveno k exportu“"
                    }
                ]
            },
            "invoice-recognition-custom-fields": {
                "group": "Faktury",
                "label": "Extrahovat vlastní pole během rozpoznávání Azure",
                "hint": "Pokud je povoleno, posíláme do Azure Document Intelligence parametry queryFields (na základě vašich vlastních polí) pro extrakci hodnot. To může zvýšit náklady na zpracování."
            },
            "invoice-recognition-custom-prompt": {
                "group": "Faktury",
                "label": "Globální vlastní prompt pro rozpoznávání faktur",
                "hint": "Tyto pokyny se použijí při rozpoznávání faktur tenanta a zkombinují se s případnými prompty pro společnost nebo dodavatele."
            }
            ,
            "invoice-recognition-model": {
                "group": "Faktury",
                "label": "Azure rozpoznávání dokladů – Model",
                "options": [
                    {
                        "value": "document-intelligence",
                        "content": "Azure Document Intelligence (klasické)"
                    },
                    {
                        "value": "content-understanding",
                        "content": "Azure Content Understanding (GenAI)"
                    },
                    {
                        "value": "azure-open-ai",
                        "content": "Azure OpenAI Responses API"
                    }
                ]
            },
            "invoice-recognition-timeout": {
                "group": "Faktury",
                "label": "Časový limit rozpoznávání Azure pro každou oblast",
                "hint": "Určuje, jak dlouho má liftbase dotazovat jednu oblast Azure, než přepne na další nakonfigurovanou oblast. Výchozí hodnota: <b>150s</b>. Příklady: <b>150s</b>, <b>5m</b>, <b>1h</b>.",
                "validation": {
                    "format": "Zadejte dobu jako 150s, 5m nebo 1h."
                }
            },
            "invoice-procurement-required": {
                "group": "Faktury",
                "label": "Je nutné propojit požadavek na nákup nebo smlouvu."
            }
            ,
            "invoice-approval": {
                "group": "Faktury",
                "label": "Kdy by měla být faktura schválena?",
                "options": [
                    {
                        "value": "always",
                        "content": "<b>Vždy</b><br>Faktury musí být vždy schváleny."
                    },
                    {
                        "value": "if-no-order",
                        "content": "<b>Pouze pokud není přiřazen ani PO, ani CT</b><br>Schválení je vyžadováno pouze tehdy, pokud není přítomen Požadavek na nákup (PO) ani Smlouva (CT)."
                    },
                    {
                        "value": "never",
                        "content": "<b>Nikdy</b><br>Faktury nevyžadují samostatné schválení."
                    }
                ]
            }
            ,
            "notifications-mail-interval": {
                "group": "Upozornění",
                "label": "Interval e-mailu v minutách",
                "tour": [
                    {
                        "target": ".step-notification",
                        "content": "Nastavte globální frekvenci pro e-mailová upozornění na nové úkoly. E-mailová upozornění jsou odesílána pouze tehdy, když osoba obdrží nový úkol."
                    }
                ]
            }
            ,
            "product-default-tax": {
                "group": "Produkt",
                "label": "Standardní daňová sazba (%)"
            }
            ,
            "product-default-currency": {
                "group": "Produkt",
                "label": "Výchozí měna"
            }
            ,
            "product-default-unit": {
                "group": "Produkt",
                "label": "Výchozí jednotka"
            }
            ,
            "punchout-amazon-identity": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Amazon",
                "label": "Přihlašovací jméno",
                "tour": [
                    {
                        "target": ".step-punchout-amazon",
                        "content": "Zde si můžete nastavit svůj přístup k integrovaným trhům, jako je Amazon a Mercateo. Pokyny naleznete <a href=\"https://liftbase.de/handbuch/einrichtung/punch-out\" target=\"_blank\">v naší příručce</a>."
                    }
                ]
            }
            ,
            "punchout-amazon-secret": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Amazon",
                "label": "Heslo"
            }
            ,
            "punchout-amazon-url": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Amazon",
                "label": "URL integrovaného systému"
            }
            ,
            "punchout-amazon-order-url": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Amazon",
                "label": "Adresa URL objednávky"
            }
            ,
            "punchout-amazon-email": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Amazon",
                "label": "E-mail",
                "hint": "E-mailová adresa hlavního účtu Amazon. <br>Chcete-li odeslat e-mailovou adresu přihlášené osoby, ponechte prázdné. <br>Může vyžadovat účet Amazon na osobu."
            }
            ,
            "punchout-amazon-supplier": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Amazon",
                "label": "Dodavatel",
                "hint": "Kterému dodavateli by měly být přiřazeny objednávky od tohoto poskytovatele Punch-out (např. ve zprávách)?"
            }
            ,
            "punchout-mercateo-identity": {
                "group": "Integrované systémy",
                "subgroup": "Punch-out Mercateo",
                "label": "Přihlašovací jméno"
            }
            ,
            "punchout-mercateo-secret": {
                "group": "Integrované systémy",
                "subgroup": "Punch-out Mercateo",
                "label": "Heslo"
            }
            ,
            "punchout-mercateo-url": {
                "group": "Integrované systémy",
                "subgroup": "Punch-out Mercateo",
                "label": "URL integrovaného systému"
            }
            ,
            "punchout-mercateo-order-url": {
                "group": "Integrované systémy",
                "subgroup": "Punch-out Mercateo",
                "label": "Adresa URL objednávky"
            }
            ,
            "punchout-mercateo-email": {
                "group": "Integrované systémy",
                "subgroup": "Punch-out Mercateo",
                "label": "E-mail",
                "hint": "E-mailová adresa hlavního účtu Mercateo. <br>Chcete-li odeslat e-mailovou adresu přihlášené osoby, ponechte prázdné. <br>Může vyžadovat účet Mercateo na osobu."
            }
            ,
            "punchout-mercateo-supplier": {
                "group": "Integrované systémy",
                "subgroup": "Punch-out Mercateo",
                "label": "Dodavatel",
                "hint": "Kterému dodavateli by měly být přiřazeny objednávky od tohoto poskytovatele Punch-out (např. ve zprávách)?"
            }
            ,
            "punchout-rajapack-identity": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážecí RAJA",
                "label": "Přihlašovací jméno"
            }
            ,
            "punchout-rajapack-secret": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážecí RAJA",
                "label": "Heslo"
            }
            ,
            "punchout-rajapack-url": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážecí RAJA",
                "label": "URL integrovaného systému"
            }
            ,
            "punchout-rajapack-order-url": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážecí RAJA",
                "label": "Adresa URL objednávky"
            }
            ,
            "punchout-rajapack-email": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážecí RAJA",
                "label": "E-mail"
            }
            ,
            "punchout-rajapack-supplier": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážecí RAJA",
                "label": "Dodavatel",
                "hint": "Kterému dodavateli by měly být přiřazeny objednávky od tohoto poskytovatele Punch-out (např. ve zprávách)?"
            }
            ,
            "punchout-conrad-identity": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Conrad",
                "label": "Přihlašovací jméno"
            }
            ,
            "punchout-conrad-secret": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Conrad",
                "label": "Heslo"
            }
            ,
            "punchout-conrad-url": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Conrad",
                "label": "URL integrovaného systému"
            }
            ,
            "punchout-conrad-order-url": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Conrad",
                "label": "Adresa URL objednávky"
            }
            ,
            "punchout-conrad-email": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Conrad",
                "label": "E-mail"
            }
            ,
            "punchout-conrad-supplier": {
                "group": "Integrované systémy",
                "subgroup": "Vyražený Conrad",
                "label": "Dodavatel",
                "hint": "Kterému dodavateli by měly být přiřazeny objednávky od tohoto poskytovatele Punch-out (např. ve zprávách)?"
            }
            ,
            "punchout-thgeyer-identity": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážečka TH.GEYER",
                "label": "Přihlašovací jméno"
            }
            ,
            "punchout-thgeyer-secret": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážečka TH.GEYER",
                "label": "Heslo"
            }
            ,
            "punchout-thgeyer-url": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážečka TH.GEYER",
                "label": "URL integrovaného systému"
            }
            ,
            "punchout-thgeyer-supplier": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážečka TH.GEYER",
                "label": "Výchozí dodavatelská společnost",
                "hint": "Kterému dodavateli by měly být přiřazeny objednávky od tohoto poskytovatele Punch-out (např. ve zprávách)?"
            }
            ,
            "punchout-reichelt-identity": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážečka Reichelt",
                "label": "Přihlašovací jméno"
            }
            ,
            "punchout-reichelt-secret": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážečka Reichelt",
                "label": "Heslo"
            }
            ,
            "punchout-reichelt-url": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážečka Reichelt",
                "label": "URL integrovaného systému"
            }
            ,
            "punchout-reichelt-supplier": {
                "group": "Integrované systémy",
                "subgroup": "Vyrážečka Reichelt",
                "label": "Výchozí dodavatelská společnost",
                "hint": "Kterému dodavateli by měly být přiřazeny objednávky od tohoto poskytovatele Punch-out (např. ve zprávách)?"
            }
            ,
            "tour": [
                {
                    "target": "",
                    "content": ""
                }
            ]
        }
        ,
        "tour": {
            "tab_general": "Zde můžete zadat název vaší společnosti pro prostředí výtahové základny.",
            "tab_contact": "Zde zadejte kontaktní údaje vaší společnosti. Tato data budou použita pro zasílání a doručování faktur za použití liftbase.",
            "tab_bank": "Zde můžete nastavit SEPA inkaso pro vyúčtování liftbase nebo jej zrušit.",
            "tab_datev": "Zde můžete nastavit integraci s DATEV. Nejprve se musíte přihlásit do DATEV, abyste načetli všechny dostupné klienty. Poté můžete tyto klienty propojit se společnostmi registrovanými zde v liftbase. Dále musíte každého klienta jednotlivě připojit k DATEV, abyste pro něj mohli přenášet exporty. Toto připojení má dobu platnosti 2 roky a prodlužuje se pokaždé, když je použito pro export.",
            "tab_marketplaces": "Zde můžete nastavit svůj přístup k integrovaným tržištím, jako jsou Amazon a Mercateo. Návod najdete <a href=\"https://liftbase.de/handbuch/einrichtung/punch-out\" target=\"_blank\">v našem manuálu</a>."
        }
    }
    ,
    "error_title": "Chyba",
    "request_error": "Chyba při provádění požadavku. Zkontrolujte prosím své internetové připojení nebo to zkuste znovu později.",
    "saved_success": "Dokument byl úspěšně uložen.",
    "duplicate_exists_check_records": "Identický záznam již existuje. Položka nebyla vytvořena. Zkontrolujte prosím své záznamy.",
    "save_error": "Při ukládání dokumentu došlo k chybě.",
    "help_page": {
        "title": "Pomoc",
        "popup_feedback_msg": "Váš prohlížeč je správně nastaven. Nyní můžete toto okno zavřít.",
        "punchout_error_msg": "Vyskytla se chyba. Zkontrolujte prosím nastavení Punch-out nebo kontaktujte osobu s administrátorskými právy.",
        "popup_did_not_open": "Pokud se neotevře žádné nové okno, vyskakovací okna jsou ve vašem prohlížeči zablokována. Během používání se proto mohou objevit omezení.",
        "test_email_msg": "Měl by se otevřít e-mailový program nebo seznam e-mailových programů. V případě potřeby nastavte e-mailový program ze seznamu.",
        "tour_restart": "Prohlídka byla znovu zahájena.",
        "manual_title": "Manuál",
        "manual_msg": "<p>V příručce najdete různé články a návody o použití a nastavení výtahové základny.</p>",
        "manual_open_btn": "Otevřete manuál",
        "function_title": "Testovací funkce",
        "popup_msg": "<p>Zde si můžete vyzkoušet, zda jsou ve vašem prohlížeči povolena vyskakovací okna, která jsou vyžadována pro váš výběr produktů na externích tržištích, jako je Amazon a Mercateo.</p>",
        "popup_test_btn": "Testování blokování vyskakovacích oken",
        "email_msg": "<p>Zde si můžete vyzkoušet, zda můžete otevřít e-maily pomocí e-mailového programu. Funkce e-mailu se používá například pro odesílání objednávek doručovacím společnostem.</p>",
        "email_test_btn": "Test funkce e-mailu",
        "tour_title": "Prohlídka",
        "tour_msg": "<p>Chcete-li znovu představit výtahovou základnu, můžete prohlídku restartovat zde.</p>",
        "tour_btn": "Restartovat prohlídku"
    }
    ,
    "dashboard_page": {
        "title": "Ukazatele",
        "no_option": "Žádná",
        "date_picker": {
            "start_placeholder": "Datum zahájení",
            "end_placeholder": "Datum zahájení",
            "separator": "na"
        },
        "ai": {
            "title": "Statistiky AI",
            "menu_title": "AI Statistiky",
            "add_widget": "[+] Přidat nový widget",
            "prompt_placeholder": "Popište graf, který chcete (např. Ukaž mi celkové objednávky za den)",
            "empty_state": "Zatím žádné widgety. Přidejte jeden pomocí promptu.",
            "remove": "Odstranit",
            "limits_info": "Můžete žádat pouze souhrny bcase (procurement, invoice, contract) buď jako POČET nebo jako HODNOTU, agregované podle časové jednotky (den, měsíc atd.). AI vrátí generická pole (time a value) a metadata, aby bylo možné graf vykreslit obecně.",
            "edit_label_title": "Upravit popisek widgetu",
            "edit_label_message": "Toto upraví pouze popisek/název zobrazený na kartě. Nezmění to dotaz ani graf.",
            "chart_type": {
                "bar": "sloupcový",
                "line": "čárový",
                "pie": "koláčový"
            },
            "date_picker": {
                "required": "Je vyžadováno časové období"
            },
            "loading": {
                "adding_widget": "Přidávání widgetu…",
                "refresh_widget": "Aktualizace…",
                "refresh_all": "Aktualizace všech widgetů…"
            },
            "errors": {
                "create_failed": "Widget se nepodařilo vytvořit.",
                "render_failed": "Graf se nepodařilo vykreslit."
            }
        },
        "hub": {
            "title": "All dashboards in one place",
            "subtitle": "Use this overview as the central entry point for procurement, incoming invoices, outgoing invoices, e-invoice and AI.",
            "procurement_title": "Procurement Dashboard",
            "procurement_description": "Current purchasing charts, budgets and spending analysis.",
            "einvoice_title": "E-invoice Dashboard",
            "einvoice_description": "Supplier adoption, risk and e-invoice format analysis.",
            "invoice_title": "Incoming Invoice Dashboard",
            "invoice_description": "Analytics for real incoming invoice data based on your current filters.",
            "outgoing_invoice_title": "Outgoing Invoice Dashboard",
            "outgoing_invoice_description": "Analytics for real outgoing invoice data based on your current filters.",
            "supplier_title": "Supplier Dashboard",
            "supplier_description": "Bird's-eye view of suppliers, spending, orders, invoices and communication.",
            "ai_description": "Dynamic AI-generated charts based on prompt-driven widgets.",
            "demo_badge": "Test version"
        },
        "supplier": {
            "menu_title": "Dashboard dodavatelů",
            "eyebrow": "Nákupní asistent",
            "title": "Dashboard dodavatelů",
            "subtitle": "Vyberte dodavatele a zobrazte výdaje, objednávky, faktury, e-maily ze SupplierConnect i importované e-maily a automatické shrnutí AI.",
            "selected_supplier": "Vybraný dodavatel",
            "change_supplier": "Změnit dodavatele",
            "top_suppliers_title": "Top 10 dodavatelů",
            "top_suppliers_subtitle": "Nejpoužívanější dodavatelé ve zvoleném období a viditelném rozsahu oprávnění.",
            "top_supplier_spend": "{amount} netto",
            "empty_top_suppliers": "Ve zvoleném období nebyli nalezeni žádní dodavatelé.",
            "orders": "objednávky",
            "invoices": "Faktury",
            "total_spend": "Výdaje",
            "total_spend_hint": "Součet viditelných příchozích faktur ve zvoleném období",
            "procurement_value": "Hodnota objednávek",
            "procurement_value_hint": "Součet viditelných objednávek ve zvoleném období",
            "order_count": "Objednávky",
            "order_count_hint": "Viditelné objednávky ve zvoleném období",
            "invoice_count": "Faktury",
            "invoice_count_hint": "Viditelné příchozí faktury ve zvoleném období",
            "email_count": "E-maily",
            "email_count_hint": "Komunikace SupplierConnect a importované e-maily ze viditelných dokladů",
            "ai_summary_title": "Shrnutí AI",
            "ai_summary_subtitle": "Automaticky vytvořeno z viditelných objednávek, faktur a e-mailů.",
            "ai_summary_loading": "AI analyzuje",
            "ai_summary_empty": "Není k dispozici spolehlivé shrnutí AI.",
            "ai_section_titles": {
                "highlights": "Hlavní body",
                "disputes": "Spory a rizika",
                "agreements": "Zvláštní dohody",
                "next_steps": "Další kroky",
                "general": "Shrnutí"
            },
            "ai_summary_disabled": "AI je pro vašeho tenanta deaktivována. Aktivujte AI v nastavení tenanta pro automatická shrnutí.",
            "refresh_ai_summary": "Obnovit shrnutí",
            "charts_title": "Výdaje a doklady",
            "charts_subtitle": "Měsíční vývoj výdajů, objednávek a faktur ve zvoleném období.",
            "spend_chart_title": "Výdaje za měsíc",
            "document_chart_title": "Objednávky a faktury za měsíc",
            "spend_mix_chart_title": "Výdaje podle typu dokladu",
            "status_chart_title": "Doklady podle stavu",
            "invoice_spend_chart_title": "Výdaje z faktur za měsíc",
            "procurement_spend_chart_title": "Hodnota objednávek za měsíc",
            "invoice_count_chart_title": "Faktury za měsíc",
            "procurement_count_chart_title": "Objednávky za měsíc",
            "invoice_status_chart_title": "Faktury podle stavu",
            "procurement_status_chart_title": "Objednávky podle stavu",
            "procurements_title": "Objednávky",
            "procurements_subtitle": "Viditelné objednávky tohoto dodavatele.",
            "invoices_title": "Faktury",
            "invoices_subtitle": "Viditelné příchozí faktury tohoto dodavatele.",
            "contracts_title": "Smlouvy",
            "contracts_subtitle": "Viditelné smlouvy a informativní upozornění tohoto dodavatele.",
            "contract_term": "Doba trvání",
            "contract_renewal": "Obnovení",
            "contract_notice": "Výpovědní lhůta",
            "contract_findings": "Upozornění smlouvy",
            "empty_contracts": "Nebyly nalezeny žádné smlouvy.",
            "contracts_disclaimer": "Zobrazené smluvní informace a upozornění jsou pouze informativní a nepředstavují právní poradenství.",
            "contract_finding_severity": {
                "high": "Vysoká",
                "medium": "Střední",
                "low": "Nízká",
                "info": "Informace"
            },
            "unknown": "Neznámé",
            "emails_title": "E-maily",
            "emails_subtitle": "Komunikace SupplierConnect a importované fakturační e-maily ze viditelných dokladů.",
            "email_type_filter": "Typ e-mailu",
            "email_type_all": "Vše",
            "email_type_communication": "Komunikace",
            "email_type_imported_invoice": "Importovaná faktura",
            "expand_email": "Rozbalit e-mail",
            "collapse_email": "Sbalit e-mail",
            "email_source_supplier_connect": "SupplierConnect",
            "email_source_imported": "Importovaný e-mail",
            "email_direction_outgoing": "Odchozí",
            "email_direction_incoming": "Příchozí",
            "imported_email_hint": "Příchozí faktura z importovaného e-mailu.",
            "loading_original_email": "Načítání původního e-mailu…",
            "open_document": "Otevřít doklad",
            "show_more": "Zobrazit více",
            "show_less": "Zobrazit méně",
            "empty_procurements": "Nebyly nalezeny žádné objednávky.",
            "empty_invoices": "Nebyly nalezeny žádné faktury.",
            "empty_emails": "Nebyly nalezeny žádné e-maily.",
            "empty_filtered_emails": "Pro tento filtr nebyly nalezeny žádné e-maily.",
            "net_value": "Netto",
            "no_subject": "Bez předmětu",
            "last_three_months": "Poslední 3 měsíce",
            "last_six_months": "Posledních 6 měsíců",
            "nav": {
                "summary": "Přehled",
                "charts": "Grafy",
                "emails": "E-maily",
                "procurements": "Objednávky",
                "invoices": "Faktury",
                "contracts": "Smlouvy"
            }
        },
        "invoice": {
            "title": "Incoming Invoice Dashboard",
            "incoming_subtitle": "This dashboard uses real incoming invoice data and shows status and distributions based on your current filters.",
            "outgoing_subtitle": "This dashboard uses real outgoing invoice data and shows status and distributions based on your current filters.",
            "sample_data": "Sample data",
            "accordions": {
                "summary": "Summary",
                "status": "Status"
            },
            "hero": {
                "data_label": "Data source",
                "live_value": "Real invoice data",
                "period_label": "Period",
                "documents_label": "Documents in view",
                "filters_label": "Active filters"
            },
            "filters": {
                "title": "Filter context",
                "subtitle": "Choose period, organization and supplier details to sharpen every section of the dashboard at once.",
                "active_filters_label": "Active filters",
                "active_filters_suffix": "active filters",
                "period_label": "Period"
            },
            "summary": {
                "incoming_count_label": "Invoices",
                "outgoing_count_label": "Outgoing invoices",
                "gross_total_label": "Gross volume",
                "gross_total_hint": "Gross total in the selected period",
                "suppliers_label": "Suppliers in filter",
                "suppliers_kicker": "Suppliers",
                "business_partners_label": "Business partners in filter",
                "business_partners_kicker": "Partners",
                "value_kicker": "Value",
                "departments_kicker": "Departments",
                "departments_label": "Departments in filter",
                "clients_kicker": "Clients",
                "clients_label": "Clients in filter",
                "incoming_count_hint": "Document count in the selected period",
                "outgoing_count_hint": "Document count in the selected period",
                "incoming_suppliers_hint": "Unique suppliers in the filtered invoice set",
                "outgoing_business_partners_hint": "Unique business partners in the filtered outgoing invoice set",
                "outgoing_suppliers_hint": "Unique suppliers in the filtered outgoing invoice set",
                "incoming_departments_hint": "Unique departments in the filtered invoice set",
                "outgoing_clients_hint": "Unique clients in the filtered outgoing invoice set"
            },
            "status_sections": {
                "incoming_title": "Invoices by status",
                "incoming_subtitle": "Status cards based on the same filters as the procurement dashboard.",
                "outgoing_title": "Outgoing invoices by status",
                "outgoing_subtitle": "Status cards for outgoing invoices in the same compact overview."
            },
            "datasets": {
                "incoming": "Invoices",
                "outgoing": "Outgoing invoices"
            },
            "sections": {
                "incoming_subtitle": "Charts for incoming invoices using the same core filters as the procurement dashboard.",
                "outgoing_subtitle": "Charts for outgoing invoices with focus on clients, suppliers, status and organization data."
            },
            "empty_state": "No invoice data found for the current filter combination.",
            "presets": {
                "this_month": "This month",
                "last_3_months": "Last 3 months",
                "year_to_date": "Year to date"
            },
            "status": {
                "approved": "Approved",
                "pending": "Pending review",
                "blocked": "Blocked"
            },
            "kpis": {
                "total_invoices": "Total invoices",
                "approved_rate": "Approved rate",
                "pending_review": "Pending review",
                "avg_gross": "Average gross value"
            },
            "charts": {
                "status_distribution": "Invoice status distribution",
                "status_distribution_subtitle": "Quick overview of how invoices are currently moving through the process.",
                "volume_trend": "Invoice volume trend",
                "volume_trend_subtitle": "Approved versus pending documents across the selected test period.",
                "count_by_status_subtitle": "Document count by status.",
                "value_by_status_subtitle": "Gross total by status.",
                "department_count_subtitle": "Distribution by department.",
                "department_value_subtitle": "Gross total by department.",
                "cost_center_count_subtitle": "Document count by cost center.",
                "cost_center_value_subtitle": "Gross total by cost center.",
                "ledger_count_subtitle": "Top ledger accounts by document count.",
                "incoming_status_count_title": "Invoices by status",
                "incoming_status_value_title": "Invoice value by status",
                "incoming_supplier_count_title": "Invoices by supplier",
                "incoming_supplier_count_subtitle": "Top suppliers by document count.",
                "incoming_supplier_value_title": "Invoice value by supplier",
                "incoming_supplier_value_subtitle": "Top suppliers by gross total.",
                "incoming_department_count_title": "Invoices by department",
                "incoming_department_value_title": "Invoice value by department",
                "incoming_cost_center_count_title": "Invoices by cost center",
                "incoming_cost_center_value_title": "Invoice value by cost center",
                "incoming_ledger_count_title": "Invoices by ledger account",
                "incoming_monthly_title": "Invoice trend by month",
                "incoming_monthly_subtitle": "Time series for incoming invoices.",
                "outgoing_status_count_title": "Outgoing invoices by status",
                "outgoing_status_value_title": "Outgoing invoice value by status",
                "outgoing_client_count_title": "Outgoing invoices by client",
                "outgoing_client_count_subtitle": "Top clients by document count.",
                "outgoing_client_value_title": "Outgoing invoice value by client",
                "outgoing_client_value_subtitle": "Top clients by gross total.",
                "outgoing_business_partner_count_title": "Outgoing invoices by business partner",
                "outgoing_business_partner_count_subtitle": "Top business partners by document count.",
                "outgoing_business_partner_value_title": "Outgoing invoice value by business partner",
                "outgoing_business_partner_value_subtitle": "Gross total by business partner.",
                "outgoing_department_count_title": "Outgoing invoices by department",
                "outgoing_cost_center_value_title": "Outgoing invoice value by cost center",
                "outgoing_ledger_count_title": "Outgoing invoices by ledger account",
                "outgoing_monthly_title": "Outgoing invoice trend by month",
                "outgoing_monthly_subtitle": "Time series for outgoing invoices."
            },
            "table": {
                "title": "Period breakdown",
                "subtitle": "Supporting sample table for the charts above.",
                "period": "Period",
                "total": "Total",
                "approved": "Approved",
                "pending": "Pending",
                "gross_value": "Gross value"
            }
        },
        "ordered_by": "Objednal",
        "count_by_status": "Počet podle stavu",
        "diagrams": {
            "title": "Grafy",
            "count_by_status": "Počet podle stavu",
            "value_by_status": "Hodnoty podle stavu (netto v EUR)",
            "count_by_department": "Počet za oddělení",
            "value_by_department": "Hodnoty na oddělení (netto v EUR)",
            "count_by_cost_center": "Počítat na nákladové středisko",
            "value_by_cost_center": "Hodnoty na nákladové středisko (netto v EUR)",
            "count_by_ledger_account": "Počet za hlavní účet",
            "value_by_ledger_account": "Částky podle hlavního účtu (netto v EUR)"
        }
        ,
        "budgets": {
            "title": "Rozpočty a výdaje",
            "approved_status": "Schváleno",
            "in_approval_status": "Schvaluje se",
            "open_status": "Otevřené",
            "no_budget": "Bez rozpočtu",
            "from": "Z",
            "no_name": "Bez jména"
        }
        ,
        "products": {
            "title": "produkty",
            "approved_status": "Schváleno",
            "in_approval_status": "Schvaluje se"
        }
        ,
        "no_data": "Nebyly nalezeny žádné nákupní objednávky.",
        "no_permission": "Nemáte oprávnění pro řídicí panel.",
        "from_budget": "z rozpočtu",
        "data": "Výdaje",
        "shortcuts": {
            "this_week": "Tento týden",
            "last_week": "Minulý týden",
            "this_month": "Tento měsíc",
            "last_month": "Minulý měsíc",
            "last_30_days": "Last 30 days",
            "last_3_months": "Poslední 3 měsíce",
            "last_6_months": "Posledních 6 měsíců",
            "this_year": "Tento rok",
            "last_year": "Minulý rok"
        }
        ,
        "tour": {
            "title": "Řídicí panel vám nabízí statistiky a funkce hodnocení pro vaše nákupní objednávky.",
            "filters_title": "Filtr",
            "filters": "Nejprve vyberte požadované období a poté filtrujte nákupní objednávky podle společnosti, objednávky, nákladového střediska nebo oddělení.",
            "count_by_status_title": "Počet podle stavu",
            "count_by_status": "Ukazuje, kolik z předfiltrovaných nákupních objednávek je aktuálně v příslušných stavech.",
            "graphic_title": "Grafy",
            "graphic": "Toto je grafické znázornění počtu nebo množství nákupních objednávek, seskupených podle stavu, oddělení nebo nákladových středisek.",
            "budget_title": "Rozpočty a výdaje",
            "budget": "Tato oblast vám poskytuje přehled o rozpočtech a výdajích vašich nákladových středisek. Barevné pruhy ukazují využití rozpočtů a kolik výdajů je ještě ve schválení.",
            "progress_bar_cost_center_title": "Ukazatele pokroku podle nákladového střediska",
            "progress_bar_cost_center": "Zde můžete rozvinout podrobnější přehled různých rozpočtů nákladového střediska. U jednotlivých rozpočtů lze také uvést zadané objednávky. Výdaje bez rozpočtu jsou uvedeny pod samostatnou lištou."
        },
        "einvoice": {
            "title": "E‑Rechnung Dashboard",
            "filters": {
                "date_range": "Časové období",
                "client": "Společnost",
                "supplier": "Dodavatel"
            },
            "placeholders": {
                "all": "Vše"
            },
            "kpis": {
                "percent_einvoices": "% e‑faktur",
                "total_tax_eur": "Celková daň (vratná)",
                "potential_loss": "Riziko nevrácení"
            },
            "hint": "Pozor: Vláda brzy ukončí vracení daní za neelektronické faktury. Kontaktujte své dodavatele co nejdříve, abyste zajistili, že budete správně přijímat e‑faktury a nepřijdete o peníze.",
            "action_button": "Kontaktovat příjemce",
            "email_dialog": {
                "title": "Kontaktovat příjemce",
                "to": "E-mail příjemce",
                "to_placeholder": "email1@firma.cz; email2@firma.cz",
                "subject": "Předmět",
                "message": "Zpráva",
                "download_eml": "Stáhnout .eml",
                "send_email": "Odeslat e-mail",
                "recipient_type": "Typ příjemce",
                "recipient_type_supplier": "Dodavatel",
                "recipient_type_client": "Společnost",
                "invalid_recipients": "Zadejte alespoň jednu platnou e-mailovou adresu.",
                "send_success": "E-mail byl úspěšně odeslán ({count}).",
                "send_error": "E-mail se nepodařilo odeslat.",
                "select_supplier_warning": "Nejprve vyberte dodavatele.",
                "default_subject": "Důležité: Přechod na elektronické faktury - {supplier}",
                "default_message": "Vážený týme {supplier},\n\nv současné době přezkoumáváme naše procesy vracení daní. V období od {startDate} do {endDate} jsme ve vašich fakturách identifikovali celkem {amount} na daních, které nebyly zaslány jako e-faktury (ZUGFeRD oder XRechnung).\n\nVezměte prosím na vědomie, že vláda brzy ukončí vracení daní za neelektronické faktury. Abychom zajistili naši další spolupráci a předešli finančním ztrátám, zdvořile vás žádáme, abyste co nejdříve přešli na zasílání elektronických faktur.\n\nDěkujeme za spolupráci.\n\nS pozdravem,\n{userName}\n{tenantName}\nVaše účtárna",
                "client_default_subject": "Stav e-faktur a potřebné kroky - {client}",
                "client_default_message": "Vážený týme {client},\n\nv období od {startDate} do {endDate} bylo ve vašich dokladech identifikováno potenciální formální riziko ve výši {amount}.\nDoporučujeme přejít na strukturované formáty e-faktur, aby se snížila compliance rizika.\n\nS pozdravem,\n{userName}\n{tenantName}"
            }
        }
    }
    ,
    "exceptions_center": {
        "menu_title": "Pending items",
        "title": "Pending items & exceptions",
        "subtitle": "This view brings together the most urgent invoices, procurements and contracts that need human action now.",
        "total_items": "Open items",
        "total_items_hint": "Filtered items currently visible in the central queue.",
        "filters_title": "Filter queue",
        "filters_subtitle": "Focus the list by document type, severity or a free-text search.",
        "clear_filters": "Clear filters",
        "search_placeholder": "Search by reference, client, supplier or reason",
        "type_filter": "Document types",
        "severity_filter": "Severity",
        "quick_filters_title": "Quick filters",
        "focus_areas_title": "Focus areas",
        "analysis_title": "Analysis",
        "document_mix_title": "Document mix",
        "amount_at_risk": "Amount at risk",
        "active_filters_title": "Active filters",
        "filtered_total_hint": "{filtered} of {total} items visible",
        "total_reference": "of {count} total",
        "active_state": "Filter active",
        "list_title": "Operational queue",
        "list_subtitle": "{count} items currently match the selected filters.",
        "empty_state": "No pending items were found for the current filter combination.",
        "open_case": "Open case",
        "updated_label": "Last update",
        "reasons_count": "{count} flags",
        "filter_groups": {
            "severity": "Severity",
            "type": "Type",
            "focus": "Focus",
            "search": "Search"
        },
        "summary": {
            "severity_kicker": "Severity",
            "document_kicker": "Document type",
            "severity_title": "By severity",
            "document_title": "By document type"
        },
        "signals": {
            "critical": "Critical now",
            "unassigned": "Without owner",
            "stale": "Stale items"
        },
        "focus_areas": {
            "payments": "Payments",
            "approvals": "Approvals",
            "master-data": "Master data",
            "ownership": "Ownership",
            "export": "Export",
            "deadlines": "Deadlines"
        },
        "severity": {
            "critical": "Critical",
            "high": "High",
            "medium": "Medium"
        },
        "document_types": {
            "invoice": "Invoice",
            "outgoing_invoice": "Outgoing invoice",
            "procurement": "Procurement",
            "contract": "Contract",
            "bank_statement": "Bank statement"
        },
        "reasons": {
            "invoice_duplicate": "Possible duplicate invoice detected.",
            "invoice_ai_validation_failed": "AI validation did not trust this invoice and routed it to manual review.",
            "invoice_overdue": "Invoice due date is overdue by {days} day(s).",
            "invoice_missing_due_date": "Invoice has no due date.",
            "invoice_waiting_approval": "Invoice is waiting in an approval step.",
            "invoice_missing_link": "Invoice has no linked procurement or contract.",
            "invoice_missing_supplier": "Invoice has no supplier assigned.",
            "invoice_missing_accounting_data": "Invoice is missing accounting dimensions such as cost center or ledger account.",
            "invoice_ready_for_export": "Invoice is ready for export but has not been exported yet.",
            "outgoing_invoice_duplicate": "Possible duplicate outgoing invoice detected.",
            "outgoing_invoice_overdue": "Outgoing invoice due date is overdue by {days} day(s).",
            "outgoing_invoice_missing_due_date": "Outgoing invoice has no due date.",
            "outgoing_invoice_waiting_processing": "Outgoing invoice is waiting in approval or accounting.",
            "outgoing_invoice_missing_client": "Outgoing invoice has no client assigned.",
            "outgoing_invoice_missing_accounting_data": "Outgoing invoice is missing accounting dimensions such as cost center or ledger account.",
            "outgoing_invoice_not_exported": "Outgoing invoice is completed but has not been exported yet.",
            "procurement_waiting_approval": "Procurement is waiting for approval.",
            "procurement_ordered_without_invoice": "Ordered procurement has no invoice after its delivery date.",
            "procurement_approved_without_invoice": "Approved procurement still has no invoice after one week.",
            "procurement_missing_delivery_date": "Procurement has no delivery date planned.",
            "procurement_not_allocated": "Procurement is not fully allocated.",
            "procurement_open_value_remaining": "Procurement still has open value after invoicing started.",
            "procurement_missing_supplier": "Procurement has no supplier assigned.",
            "procurement_missing_accounting_data": "Procurement is missing accounting dimensions such as cost center or ledger account.",
            "contract_termination_deadline_passed": "Termination deadline has already passed.",
            "contract_termination_deadline_soon": "Termination deadline is within the next {days} day(s).",
            "contract_termination_deadline_near": "Termination deadline is within the next 30 days.",
            "contract_end_date_passed": "Contract end date has already passed.",
            "contract_end_date_soon": "Contract end date is within the next {days} day(s).",
            "contract_end_date_near": "Contract end date is within the next 30 days.",
            "contract_missing_owner": "Contract has no responsible owner assigned.",
            "contract_missing_supplier": "Contract has no supplier assigned.",
            "bank_statement_failed": "Bank statement processing failed.",
            "bank_statement_partial": "Bank statement processing completed only partially.",
            "bank_statement_unmatched_entries": "Bank statement still has {count} unmatched entrie(s).",
            "bank_statement_processing_too_long": "Bank statement has been processing for more than one day.",
            "bank_statement_empty": "Bank statement was processed without entries.",
            "bank_statement_missing_owner": "Bank statement has no account owner filled in.",
            "item_unassigned": "Current workflow step has no responsible user assigned.",
            "item_stale": "Item has had no relevant update for {days} day(s)."
        }
    },
    "overview_page": {
        "title": "Přehled",
        "procurement_abbr": "PO",
        "invoice_abbr": "IN",
        "outgoing_invoice_abbr": "OF",
        "draft_abbr": "DR",
        "contract_abbr": "SM",
        "delivery_note_abbr": "DN",
        "all_docs": "Všechny dokumenty",
        "all_docs_tree": "Všechny dokumenty (strom)",
        "all_docs_list": "Všechny dokumenty (seznam)",
        "search_all_documents": "Hledat ve všech dokumentech",
        "export_ready_docs": "Připraveno k exportu",
        "my_tasks": "Moje úkoly",
        "my_orders": "Moje objednávky",
        "my_bank_statements": "Mé bankovní výpisy",
        "previous_document": "Předchozí dokument",
        "next_document": "Další dokument",
        "collapse_sidebar": "Sbalit postranní panel",
        "expand_sidebar": "Rozbalit postranní panel",
        "collapse_properties_sidebar": "Sbalit panel akcí",
        "expand_properties_sidebar": "Rozbalit panel akcí",
        "properties_sidebar": {
            "no_step": "Žádný aktivní krok",
            "completed": "Dokončeno"
        },
        "saved_searches": "Uložená vyhledávání",
        "my_orders_no_invoices": "K této objednávce zatím není přiřazena žádná faktura.",
        "my_orders_goods_receipt": "Příjem zboží",
        "procurements": "Nákupní objednávky",
        "invoices": "Faktury",
        "outgoing_invoices": "Odchozí faktury",
        "list_column_incoming_invoice": "Příchozí",
        "list_column_outgoing_invoice": "Odchozí",
        "drafts": "Pracovní verze",
        "contracts": "Smlouvy",
        "no_selection": "Není vybrán žádný dokument.",
        "common_fields": "Společná pole",
        "comment_box_placeholder": "Tvůj komentář...",
        "comment_box_btn": "Komentář",
        "comment_box_mentions_loading": "Načítání uživatelů...",
        "comment_box_mentions_empty": "Nebyli nalezeni žádní uživatelé.",
        "communication": {
            "tooltip": "Kontaktovat dodavatele",
            "tooltip_business_partner": "Kontaktovat obchodního partnera",
            "disabled_hint": "Prosím nastavte v konfiguraci aktivní schránku s povolenou komunikací s dodavateli pro tento typ dokumentu.",
            "dialog_title": "Kontaktovat dodavatele",
            "dialog_title_business_partner": "Kontaktovat obchodního partnera",
            "send_order_dialog_title": "Odeslat objednávku přes SupplierConnect",
            "from_mailbox": "Odesílací schránka",
            "from_mailbox_placeholder": "Vyberte schránku",
            "supplier": "Dodavatel",
            "to": "Komu",
            "visibility": "Viditelnost",
            "internal_note": "Interní zpráva",
            "internal_tag": "Interní",
            "external_tag": "Externí",
            "external_hint": "Externí: dodavatel a všichni vybraní příjemci obdrží tuto zprávu.",
            "internal_hint": "Interní: oznámení obdrží pouze označení uživatelé liftbase. Dodavatel nebude kontaktován.",
            "cc_mentions": "Kopie uživatelům (@mention)",
            "cc_mentions_placeholder": "Použijte @ pro označení uživatelů ze systému",
            "internal_recipients": "Interní příjemci",
            "cc_emails": "Kopie e-maily",
            "cc_emails_placeholder": "Přidejte e-mail a stiskněte Enter",
            "subject": "Předmět",
            "body": "Zpráva",
            "body_placeholder": "Napište zprávu...",
            "attach_order_pdf": "Přiložit PDF objednávky",
            "attach_invoice_document": "Přiložit dokument faktury",
            "attach_order_pdf_mode_plain": "Bez nabídky",
            "attach_order_pdf_mode_with_line_attachments": "S nabídkou",
            "reply_info": "Odpovědi budou doručeny pouze do nakonfigurované komunikační schránky. Uživatel, který komunikaci zahájil, bude následně upozorněn.",
            "internal_reply_info": "Interní zprávy se odesílají pouze označeným uživatelům liftbase.",
            "send": "Odeslat e-mail",
            "dialog_options_action": "Další možnosti e-mailu",
            "validation": "Vyplňte prosím všechna povinná pole.",
            "sent_success": "Komunikace byla úspěšně odeslána.",
            "sent_error": "Komunikaci se nepodařilo odeslat.",
            "sent_error_mailbox_reconnect": "Komunikaci se nepodařilo odeslat, protože mailbox Microsoft {mailbox} již není připojen.\nPřipojte mailbox znovu v nastavení a zkuste to ještě jednou.",
            "sent_error_mailbox_incomplete": "Komunikaci se nepodařilo odeslat, protože u mailboxu {mailbox} chybí SMTP host, uživatelské jméno nebo heslo.\nDoplňte konfiguraci mailboxu v nastavení.",
            "history_title": "Komunikace s dodavatelem",
            "history_title_business_partner": "Komunikace s obchodním partnerem",
            "history_empty": "Pro tento dokument ještě nebyla zahájena žádná komunikace.",
            "recipients": "Příjemci",
            "cc": "Cc",
            "attachments": "Přílohy",
            "attachments_available": "Obsahuje přílohy",
            "statuses": {
                "pending": "Čeká",
                "sent": "Odesláno",
                "failed": "Neúspěšné",
                "received": "Přijato"
            },
            "reply_action": "Odpovědět",
            "forward_action": "Přeposlat",
            "forward_dialog_title": "Přeposlat e-mail",
            "forward_subject_prefix": "Fwd:",
            "forwarded_message_title": "Přeposlaná zpráva",
            "forward_attachments_hint": "Tyto přílohy budou odeslány spolu s přeposlaným e-mailem.",
            "history_quote_title": "Historie komunikace",
            "history_date_label": "Datum",
            "history_from_label": "Od",
            "history_to_label": "Komu",
            "history_subject_label": "Předmět",
            "show_less": "Zobrazit méně",
            "involved_button": "Zapojení",
            "involved_title": "Zapojení uživatelé a e-maily",
            "involved_search_placeholder": "Hledat podle jména nebo e-mailu",
            "involved_copy_email": "Kopírovat e-mail",
            "involved_copied": "E-mail zkopírován",
            "involved_empty": "Nebyli nalezeni žádní účastníci",
            "involved_sections": {
                "suppliers": "Dodavatelé",
                "users": "Interní uživatelé",
                "manual": "Ruční e-maily",
                "mailbox": "Mailbox"
            },
            "address_book_source_supplier": "Adresa dodavatele",
            "address_book_source_saved": "Již použito",
            "address_book_delete": "Odstranit uložený návrh",
            "address_book_delete_success": "Uložený návrh byl odstraněn.",
            "address_book_delete_error": "Uložený návrh se nepodařilo odstranit."
        },
        "edit_filename_title": "Upravit název souboru",
        "edit_filename_msg": "Zadejte nový název souboru. <br> Starý název: {filename}",
        "duplicate_invoice": {
            "message": "Duplicita - Byla nalezena nejméně jedna faktura se stejným číslem faktury:",
            "invoice_number": "Číslo faktury",
            "invoice_date": "Datum"
        }
        ,
        "task_list": {
            "name": "Jméno",
            "status": "Stav",
            "date": "datum",
            "draft": "Návrh"
        }
        ,
        "searchbar": {
            "search": "Hledat",
            "filter_by": "Filtrovat podle",
            "created_at": "Datum vzniku",
            "timeline": "Timeline",
            "last_used": "Naposledy použitý",
            "no_search": "Žádný",
            "save_search": "Uložit vyhledávání",
            "save_search_prompt": "Chcete toto vyhledávání uložit? Zadejte štítek.",
            "label_placeholder": "Štítek",
            "label_required": "Zadejte štítek.",
            "label_exists": "Tento stitek jiz existuje.",
            "saved_success": "Vyhledávání bylo uloženo.",
            "edit_saved_search": "Prejmenovat ulozene vyhledavani",
            "edit_saved_search_title": "Prejmenovat ulozene vyhledavani",
            "edit_saved_search_prompt": "Jak se ma toto ulozene vyhledavani jmenovat?",
            "edited_success": "Ulozene vyhledavani bylo prejmenovano.",
            "delete_saved_search": "Smazat uložené vyhledávání",
            "delete_saved_search_title": "Smazat uložené vyhledávání",
            "delete_saved_search_prompt": "Opravdu chcete smazat uložené vyhledávání \"{label}\"?",
            "deleted_success": "Uložené vyhledávání bylo smazáno.",
            "timeline_props": {
                "editor_name": "Editor",
                "entry_type": "Krok časové osy",
                "current_editor_name": "Aktuální editor",
                "current_entry_type": "Aktuální krok"
            }
            ,
            "common_props": {
                "client_name": "Název společnosti",
                "client_number": "Číslo společnosti",
                "department_name": "Název oddělení",
                "department_number": "Číslo oddělení",
                "cost_center_name": "Název střediska",
                "cost_center_number": "Číslo střediska",
                "ledger_account_name": "Název účtu",
                "ledger_account_number": "Číslo účtu",
                "cost_type_name": "Typ nákladu",
                "product_names": "Produkt",
                "product_numbers": "Kód produktu",
                "status": "Stav",
                "supplier_display_name": "Dodavatel",
                "payment_in_advance": "Platba předem",
            }
            ,
            "procurement_props": {
                "order_number_formatted": "Číslo objednávky",
                "name": "Popis",
                "creator_name": "Vytvořil",
                "consignee_name": "Příjem zboží",
                "supplier_names": "Dodavatel",
                "delivery_date_overdue": "Datum dodání po termínu"
            }
            ,
            "invoice_props": {
                "invoice_number": "Číslo faktury",
                "invoice_number_formatted": "Interní číslo faktury",
                "invoice_prefix": "Prefix faktury",
                "procurement_number": "Číslo objednávky",
                "creator_name": "Nahrál",
                "supplier_name": "Název dodavatele",
                "supplier_number": "Číslo dodavatele",
                "invoice_date": "Datum faktury",
                "due_date": "Datum splatnosti"
            }
            ,
            "time_ranges": {
                "today": "dnes",
                "yesterday": "včera",
                "past_7_days": "posledních 7 dní",
                "past_30_days": "posledních 30 dnů",
                "this_week": "tento týden",
                "last_week": "minulý týden",
                "this_month": "tento měsíc",
                "last_month": "minulý měsíc",
                "this_year": "tento rok",
                "last_year": "minulý rok"
            }
        }
        ,
        "export": {
            "all_information": "Všechny informace",
            "export_procurement": "Export nákupních objednávek",
            "export_documents": "Exportovat dokumenty",
            "registers": "záznamy",
            "export": "Vývozní",
            "to_export": "Exportovat",
            "export_with_products": "Export s produkty",
            "custom_export": "Nakonfigurovaný export",
            "select_fields": "Vyberte pole, která chcete exportovat.",
            "select_all": "Vybrat vše",
            "deselect_all": "Odebrat všechny",
            "general": "Obecné",
            "products": "produkty",
            "include_product": "Vč. produktů",
            "filter": "filtr",
            "no_filter": "žádný filtr",
            "format": "Formát souboru",
            "csv": "CSV",
            "xlsx": "XLSX",
            "loading": "načítání",
            "error": "Export se nezdařil. Zkuste to prosím znovu.",
            "labels": {
                "procurement": {
                    "order_number_formatted": "LB-číslo",
                    "name": "Jméno",
                    "creator_name": "Vytvořeno",
                    "status": "Stav",
                    "total_price_brutto": "Celkem-brutto",
                    "total_price_netto": "Total-Net",
                    "type_total_price_brutto": "currency",
                    "type_total_price_netto": "currency",
                    "created_at": "Datum vzniku",
                    "client_number": "Číslo firmy",
                    "client_name": "Jméno společnosti",
                    "department_name": "Název oddělení",
                    "department_number": "Číslo oddělení",
                    "cost_center_number": "Číslo nákladového střediska",
                    "cost_center_name": "Název nákladového střediska",
                    "consignee_name": "Příjem zboží",
                    "shipping_date": "Datum dodání",
                    "shipping_name": "Název dodací adresy",
                    "shipping_consignee": "Doručovací adresa jméno přijímající osoby",
                    "shipping_dropoff_location": "Název dodací adresy místa výdeje",
                    "shipping_address": "Dodací adresa ulice a č.p.",
                    "shipping_complement": "Dodací adresa ulice 2",
                    "shipping_country": "Země dodací adresy",
                    "shipping_zipcode": "Doručovací adresa PSČ",
                    "shipping_city": "Dodací adresa město",
                    "shipping_phone_country_code": "Tel. předvolba země dodací adresy",
                    "shipping_phone_number": "Telefonní číslo dodací adresy",
                    "billing_name": "Název fakturační adresy",
                    "billing_consignee": "Fakturační adresa jméno příjemce",
                    "billing_dropoff_location": "Název fakturační adresy místa výdeje",
                    "billing_address": "Fakturační adresa ulice a č.p.",
                    "billing_complement": "Ulice fakturační adresy 2",
                    "billing_country": "Země fakturační adresy",
                    "billing_zipcode": "Poštovní směrovací číslo fakturační adresy",
                    "billing_city": "Fakturační adresa město",
                    "billing_phone_country_code": "Tel. předvolba země fakturační adresy",
                    "billing_phone_number": "Telefonní číslo fakturační adresy"
                }
                ,
                "product": {
                    "product_name": "Jméno výrobku",
                    "product_number": "Číslo položky",
                    "product_supplier_name": "Jméno dodavatele",
                    "product_supplier_email": "Email dodavatele",
                    "product_cost_center_name": "Název nákladového střediska (produkt)",
                    "product_cost_center_number": "Číslo nákladového střediska (produkt)",
                    "product_tax": "Daň",
                    "product_quantity": "množství (produkt)",
                    "product_total_netto": "Celková čistá (produkt)",
                    "product_total_brutto": "Celkem brutto (produkt)",
                    "product_netto": "Jednotná cena netto",
                    "product_brutto": "Jednotná cena brutto",
                    "product_unit_price_base_amount": "Jednotková cena před slevou (produkt)",
                    "product_unit_price_discount_amount": "Sleva z jednotkové ceny (produkt)",
                    "product_line_discount_amount": "Sleva položky (produkt)",
                    "product_line_discount_base_amount": "Základ slevy položky (produkt)",
                    "product_line_discount_percentage": "Sleva položky % (produkt)",
                    "product_unit": "Jednotka",
                    "product_img_url": "Adresa URL obrázku",
                    "product_shop_url": "Adresa URL obchodu",
                    "product_shipping_name": "Název dodací adresy (produkt)",
                    "product_shipping_consignee": "Doručovací adresa jméno přijímající osoby (produkt)",
                    "product_shipping_dropoff_location": "Název dodací adresy místa odevzdání (pProdukt)",
                    "product_shipping_address": "Dodací adresa ulice a č.p. (produkt)",
                    "product_shipping_complement": "Dodací adresa ulice 2 (produkt)",
                    "product_shipping_country": "Země dodací adresy (produkt)",
                    "product_shipping_zipcode": "Dodací adresa PSČ (produkt)",
                    "product_shipping_city": "Dodací adresa město (produkt)",
                    "product_shipping_phone_country_code": "Tel. předvolba země dodací adresy (produkt)",
                    "product_shipping_phone_number": "Telefonní číslo dodací adresy (produkt)",
                    "product_received_at": "Poslední příjem zboží (datum)",
                    "product_received_by": "Poslední příjem zboží (osoba)"
                }
                ,
                "invoice": {
                    "invoice_number_formatted": "Číslo interní faktury",
                    "number": "Číslo faktury",
                    "invoice_prefix": "Prefix faktury",
                    "creator_name": "Nahráno uživatelem",
                    "status": "Stav",
                    "procurement_name": "Nákupní objednávka",
                    "procurement_number": "Číslo objednávky",
                    "cost_center_name": "Název nákladového střediska",
                    "cost_center_number": "Číslo nákladového střediska",
                    "total_price_netto": "Celkem netto",
                    "total_price_brutto": "Celkem brutto",
                    "document_discount_amount": "Částka slevy dokladu",
                    "document_discount_base_amount": "Základ slevy dokladu",
                    "document_discount_percentage": "Sleva dokladu %",
                    "document_discount_tax_percentage": "DPH slevy dokladu %",
                    "type_total_price_brutto": "currency",
                    "type_total_price_netto": "currency",
                    "created_at": "Nahráno dne",
                    "client_name": "Společnost",
                    "client_number": "Číslo firmy",
                    "invoice_date": "Datum faktury",
                    "due_date": "Datum splatnosti",
                    "delivery_date": "Datum dodání",
                    "currency": "Měna",
                    "ledger_account_name": "Název účtu hlavní knihy",
                    "ledger_account_number": "Číslo účtu",
                    "posting_key_number": "Číslo účtovacího klíče",
                    "posting_key_tax": "Daň účtovacího klíče",
                    "supplier_name": "Dodavatel",
                    "paid": "Zaplaceno"
                },
                "contract": {
                    "name": "Název",
                    "contract_date": "Datum smlouvy",
                    "contract_number_formatted": "Číslo KT",
                    "contract_number": "Číslo smlouvy",
                    "category": "Kategorie",
                    "status": "Stav",
                    "term_type": "Typ trvání",
                    "payment_method": "Platební metoda",
                    "external_contract_number": "Externí číslo smlouvy",
                    "creator_name": "Vytvořil",
                    "created_at": "Datum vytvoření",
                    "client_number": "Číslo společnosti",
                    "client_name": "Název společnosti",
                    "department_name": "Název oddělení",
                    "department_number": "Číslo oddělení",
                    "cost_center_name": "Název nákladového střediska",
                    "cost_center_number": "Číslo nákladového střediska",
                    "supplier_name": "Název dodavatele",
                    "supplier_number": "Číslo dodavatele",
                    "responsible_name": "Odpovědná osoba",
                    "notes": "Poznámka",
                    "payment_direction": "Vztah",
                    "recurring_invoice": "Opakovaná faktura",
                    "start_date": "Datum začátku",
                    "end_date": "Datum konce",
                    "duration": "Doba trvání smlouvy",
                    "duration_unit_type": "Jednotka doby trvání smlouvy",
                    "renewal_type": "Typ obnovení",
                    "renewal_duration": "Doba obnovení",
                    "renewal_duration_unit_type": "Jednotka doby obnovení",
                    "notice_period": "Výpovědní lhůta",
                    "notice_period_unit_type": "Jednotka výpovědní lhůty",
                    "termination_special_right": "Zvláštní právo na ukončení",
                    "termination_deadline": "Termín ukončení",
                    "next_possible_contract_end": "Nejbližší možné ukončení smlouvy",
                    "terminated_on": "Ukončeno dne",
                    "termination_to": "Ukončení k",
                    "payment_timing": "Typ platby",
                    "usage_type": "Frekvence"
                }
            }
        }
        ,
        "actions": {
            "tour": {
                "procurement_reassignment_title": "Přiřadit/vymazat objednávku",
                "procurement_reassignment_msg": "Tento úkol je momentálně s jinou osobou. Toto tlačítko použijte k odeslání úkolu k vymazání nebo k přidělení tohoto úkolu třetí osobě nebo sobě. Při zúčtování lze také zrušit nákupní objednávky.",
                "invoice_reassignment_title": "Přiřadit/vymazat fakturu",
                "invoice_reassignment_msg": "Tento úkol je momentálně s jinou osobou. Toto tlačítko použijte k odeslání úkolu k vymazání nebo k přidělení tohoto úkolu třetí osobě nebo sobě. Při zúčtování lze zúčtovat i faktury."
            }
            ,
            "skip_confirm_dialog_title": "Zrušit rozpoznávání dokumentů",
            "skip_confirm_dialog_msg": "Chcete-li zkontrolovat, zda již existuje výsledek rozpoznání dokladu, obnovte stránku ve svém prohlížeči. <br>Opravdu chcete zrušit rozpoznávání údajů faktury a zadat údaje ručně?",
            "button_hint": {
                "to_approval": "Ke schválení",
                "to_send_order": "Objednat",
                "to_accounting": "Do účetnictví",
                "approve": "Schvalovat",
                "self_assign": "Přijmout",
                "finish_order": "Dokončete objednávku",
                "finish_delivery": "Dokončit",
                "skip_recognition": "Zrušit rozpoznávání dokumentů",
                "to_export": "Exportovat",
                "default": "Pokračovat",
                "cancel_or_assign_procurement": "Přiřadit/zrušit",
                "cancel_or_assign_invoice": "Přiřadit/zrušit",
                "clearing_or_assign": "Přiřadit/Objasněte"
            }
            ,
            "assignment_tooltip": "Objasnění nebo přiřazení",
            "restart_approval_tooltip": "Restartovat časovou osu",
            "restart_or_clearing_tooltip": "Restartovat časovou osu nebo přiřadit k objasnění",
            "restart_approval_error": "Schvalovací proces se nepodařilo restartovat.",
            "assignment_dialog": {
                "title_procurement_assign_or_cancel": "Přiřazení nebo zrušení",
                "title_invoice_assign_or_cancel": "Přiřazení nebo zrušení",
                "title_assign": "Úkol",
                "title_clearing_or_assign": "Objasnění nebo přiřazení",
                "assign_title": "Přidělte aktuální úkol jiné osobě",
                "assign_msg": "Aktuálně přidělená osoba není k dispozici nebo není za tento úkol odpovědná, takže by tento úkol měla převzít jiná osoba.",
                "clearing_title": "Přiřazení pro objasnění",
                "clearing_msg": "Aktuálně přidělená osoba je k dispozici a odpovídá za tento úkol, ale proces nemůže pokračovat z jiných důvodů. Rádi byste proto zahájili objasňovací proces.",
                "cancel_procurement_title": "Zrušení",
                "cancel_procurement_msg": "Objednávka je nenávratně stornována a nelze ji dále zpracovávat. Zrušené objednávky naleznete v přehledu pod statusem 'Odmítnuto'.",
                "cancel_invoice_title": "Probíhá zrušení",
                "cancel_invoice_msg": "Faktura je nenávratně smazána a nelze ji dále zpracovávat. Vyúčtované faktury naleznete v přehledu všech dokladů pod stavem 'Pročištěno'.",
                "assign_to": "Přiřadit",
                "reason": "Důvod",
                "declined_invoice_alert_title": "Odmítnutou fakturu nelze znovu otevřít",
                "declined_invoice_alert_message": "Tato faktura již byla odmítnuta. Lze ji pouze odeslat do vyjasnění, aby bylo možné v případě potřeby upravit údaje. Poté ji nelze znovu otevřít a musí být odeslána znovu.",
                "clearing_footer_info": "Aktuální úkol je zrušen. Vybraná osoba dostane nový úkol k objasnění.",
                "reassignment_footer_info": "Změní se pouze přiřazená osoba aktuálního úkolu.",
                "restart_approval_title": "Restartovat schvalovací proces",
                "restart_approval_dialog_title": "Restartovat časovou osu",
                "restart_or_clearing_dialog_title": "Restartovat časovou osu nebo přiřadit k objasnění",
                "restart_approval_msg": "Faktura se vrátí k ruční kontrole a projde novým schvalovacím kolem. Předchozí historie časové osy zůstane zachována.",
                "restart_approval_footer_info": "Faktura se vrátí k ruční kontrole. Předchozí historie časové osy zůstane zachována.",
                "cancel_invoice_btn": "Zrušit fakturu",
                "cancel_procurement_btn": "Zrušit objednávku",
                "assign_btn": "Přiřadit",
                "restart_approval_btn": "Restartovat",
                "prevent_approve_group_msg": "Před schválením prosím přiřaďte tento krok osobě.",
                "clearing_dialog": {
                    "title": "Předběžné přidělení objasnění",
                    "procurement_message": "Osoba v kroku „objasnění“ vyplývá z různých výchozích hodnot odpovědných osob podle oddělení, společnosti, výchozí globální role a osoby, která objednávku vytvořila. Osoba, která je na začátku seznamu, je předem přiřazena k úkolu.",
                    "invoice_message": "Osoba v kroku „objasnění“ vyplývá z různých výchozích hodnot odpovědných osob za oddělení, společnost, výchozí globální role a osoby, která nahrála fakturu. Osoba, která je na začátku seznamu, je předem přiřazena k úkolu.",
                    "department_form": "Oddělení ve formě",
                    "department_creator": "Oddělení objednané osoby",
                    "client_form": "Společnost ve formě",
                    "client_creator": "Společnost objednané osoby",
                    "no_selection": "ještě nevybráno",
                    "no_action": "nelze použít"
                }
                ,
                "cancellation_dialog": {
                    "title_procurement": "Zrušení",
                    "btn_procurement": "Zrušit objednávku",
                    "message_procurement": "Opravdu chcete zrušit tuto objednávku?",
                    "title_invoice": "Probíhá zrušení",
                    "btn_invoice": "Zrušit fakturu",
                    "message_invoice": "Opravdu chcete zrušit tuto fakturu?"
                }
            }
        }
        ,
        "tour": {
            "overview": {
                "search_box": "Pomocí vyhledávání můžete filtrovat nákupní objednávky pod \"Moje úkoly\" a \"Všechny dokumenty\" a vyhledávat různé informace pro rychlejší nalezení konkrétních objednávek.",
                "tab_tasks": "Zde můžete vidět nákupní objednávky, za které aktuálně odpovídáte. V pravém sloupci vidíte stav svých úkolů.",
                "tab_all_procurements": "V této stromové struktuře naleznete všechny objednávky seřazené podle aktuálního stavu.",
                "refresh_btn": "Zde si můžete aktualizovat přehled objednávek.",
                "type_filter": "Zde můžete filtrovat podle typu úkolu."
            }
            ,
            "procurement": {
                "form_title": "Formulář nákupní objednávky",
                "form": "Zde můžete vidět informace o objednávce.",
                "approve_btn_title": "Přepošlete objednávku",
                "approve_btn": "Když dokončíte úkol a chcete objednávku předat další odpovědné osobě nebo v dalším kroku, stiskněte modré zaškrtnutí.",
                "reassign_btn": "Pokud nechcete úkol dokončit, protože např. stále přetrvávají nejasnosti nebo by ve zpracování úkolu měla pokračovat jiná osoba, můžete stisknout červené tlačítko. Úkol pak můžete buď předat, nebo jej někomu přidělit k vymazání. Během procesu zúčtování lze také zrušit nákupní objednávky.",
                "add_comment": "Prostřednictvím pole komentáře můžete k objednávce přidat komentář. To se pak zobrazí na časové ose.",
                "timeline_title": "Timeline",
                "timeline": "Časová osa zobrazuje minulý a budoucí průběh objednávky a také aktuální stav (modrá) a komentáře k objednávce. Pořadí řazení lze obrátit pomocí ikony ozubeného kola.",
                "timeline_preferences": "Prostřednictvím tohoto tlačítka lze provést nastavení zobrazení na časové ose. Lze například nastavit, zda se mají události řadit vzestupně nebo sestupně a zda mají být změny v objednávce skryty nebo zobrazeny."
            }
            ,
            "invoice": {
                "form_title": "Formulář faktury",
                "form": "Zde můžete zadat nebo upravit informace pro fakturu.",
                "add_line": "Zde můžete přidat řádkovou položku faktury.",
                "edit_lines": "Zde můžete upravit informace o řádkových položkách faktury.",
                "approve_btn_title": "Přeposlat fakturu",
                "approve_btn": "Jakmile dokončíte úkol a chcete přeposlat fakturu další odpovědné osobě nebo dalšímu kroku, můžete stisknout modré zaškrtnutí.",
                "reassign_btn": "Pokud nechcete úkol dokončit, například proto, že existuje problém k vyřešení nebo pokud by na úkolu měla pokračovat jiná osoba, můžete stisknout červené tlačítko. Poté můžete úkol buď přidělit někomu jinému, nebo jej přidělit někomu k vymazání. Během procesu zúčtování lze také upravovat faktury.",
                "add_comment": "Přes pole komentáře můžete k faktuře přidat komentář. To se pak zobrazí na časové ose.",
                "timeline_title": "Timeline",
                "timeline": "Časová osa zobrazuje minulý a budoucí průběh faktury a také aktuální stav (modrá) a komentáře k faktuře. Pořadí řazení lze obrátit pomocí ikony ozubeného kola.",
                "timeline_preferences": "Prostřednictvím tohoto tlačítka lze provést nastavení zobrazení na časové ose. Zde lze nastavit, zda se mají události řadit vzestupně nebo sestupně a zda se mají úpravy faktury skrýt nebo zobrazit."
            }
            ,
            "welcome": {
                "logo_title": "Vítejte na liftbase!",
                "logo": "<p>Abychom vám usnadnili začátek, vysvětlíme vám nejdůležitější věci na prohlídce základny výtahu.</p> <p>Procházku procházejte pomocí tlačítek níže nebo kláves se šipkami.</p>",
                "menu": "V pravém horním rohu je hlavní menu, přes které najdete všechny důležité oblasti výtahové základny.",
                "menu_help": "Jednotlivé části prohlídky můžete kdykoli ukončit a později v nabídce nápovědy znovu spustit.",
                "menu_admin": "Zde najdete další část prohlídky."
            }
        }
    }
    ,
    "liquidity_planning": {
        "subtitle": "Zkontrolujte aktuální cash flow podle společnosti, plánujte další týdny a porovnávejte alternativní scénáře.",
        "horizon_hint": "Výchozí pohled: aktuální kalendářní týden, 12 následujících týdnů a potom 6 měsíčních bloků. Manuální řádky se vždy vedou po kalendářních týdnech.",
        "scenario_placeholder": "Vybrat scénář",
        "scenario": "Scénář",
        "start_date": "Datum zahájení",
        "start_date_required": "Zadejte prosím datum zahájení.",
        "start_date_min_today": "Datum zahájení musí být dnes nebo později.",
        "active_filters": "Aktivní filtry",
        "default_scenario_name": "Hlavní scénář",
        "no_scenarios_found": "Nebyly nalezeny žádné scénáře.",
        "opening_balance": "Počáteční zůstatek",
        "ending_balance": "Konečný zůstatek",
        "inflow": "Příjmy",
        "outflow": "Výdaje",
        "total_in_period": "Součet ve viditelném horizontu",
        "last_visible_period": "Zůstatek na konci posledního viditelného období",
        "empty_client_description": "Nejprve vyberte společnost, aby se načetlo plánování likvidity.",
        "empty_scenario_description": "Pro tuto společnost zatím neexistuje scénář. Vytvořte nyní první scénář.",
        "table_row_label": "Položka",
        "manual_row_label": "Název řádku",
        "manual_row_label_required": "Zadejte název řádku.",
        "add_manual_row": "Přidat manuální řádek",
        "add_manual_row_individual": "Zadat jednotlivě",
        "add_manual_row_spreadsheet": "Tabulka (Excel)",
        "manual_spreadsheet_hint": "První řádek se zobrazí v plánu. Uloží se celá tabulka.",
        "manual_spreadsheet_unavailable": "Tabulka není k dispozici. Zavřete editor a otevřete ho znovu.",
        "manual_spreadsheet_values_required": "Zadejte alespoň jednu hodnotu nebo vzorec do prvního řádku.",
        "manual_edit": "Upravit ručně",
        "manual_entries": "Manuální položky",
        "manual_entries_hint": "Zde spravujte označení a částku pro kalendářní týden. Měsíční pohled tyto týdny automaticky seskupí.",
        "manual_week": "Kalendářní týden",
        "manual_entry_label": "Označení",
        "manual_entry_amount": "Částka",
        "manual_entries_count": "{count} manuálních položek",
        "documents_count": "{count} záznamů",
        "pending": "Po splatnosti",
        "open_outgoing_invoices": "Otevřené vydané faktury",
        "open_incoming_invoices": "Otevřené přijaté faktury",
        "open_procurements": "Otevřené objednávky",
        "view_records": "Zobrazit záznamy",
        "records_number": "Číslo",
        "records_name": "Název",
        "records_date": "Datum",
        "records_amount": "Částka",
        "unassigned_cost_type": "Bez typu nákladů",
        "unassigned_revenue_type": "Bez typu výnosů",
        "select_cost_type": "Vyberte typ nákladů",
        "select_revenue_type": "Vyberte typ výnosů",
        "manual_row_type_save_error": "Manuální řádek se nepodařilo přiřadit ke zvolenému typu nákladů nebo výnosů. Aktualizujte metadata Hasury (metadata apply) a uložte znovu.",
        "balance_source_statement": "Ukotveno bankovním výpisem do {date}",
        "balance_source_manual": "Aktivní je pouze ruční úprava scénáře",
        "balance_source_none": "Není k dispozici historický bankovní zůstatek",
        "load_error": "Plánování likvidity se nepodařilo načíst.",
        "save_error": "Scénář se nepodařilo uložit.",
        "create_scenario": "Vytvořit scénář",
        "copy_scenario": "Kopírovat scénář",
        "delete_scenario": "Smazat scénář",
        "delete_scenario_confirm": "Opravdu chcete smazat tento scénář? Tento krok je nevratný.",
        "create_scenario_prompt": "Zadejte název nového scénáře.",
        "edit_scenario_prompt": "Zadejte nový název tohoto scénáře.",
        "copy_scenario_prompt": "Zadejte název kopie scénáře.",
        "copy_suffix": "Kopie",
        "name_required": "Zadejte název.",
        "delete_manual_row_confirm": "Opravdu chcete tento manuální řádek smazat?",
        "table_width": "Šířka sloupců",
        "show_chart": "Zobrazit graf",
        "view_standard": "Standard (13 týdnů + 6 měsíců)",
        "view_all_weeks": "Všechny týdny",
        "view_all_months": "Všechny měsíce",
        "add_manual_row_inflow": "Manuální příjem",
        "add_manual_row_outflow": "Manuální výdaj",
        "discard_unsaved_title": "Neuložené změny",
        "discard_unsaved_confirm": "Máte neuložené změny. Pokud přepnete zobrazení, vaše úpravy se ztratí. Chcete pokračovat?",
        "discard_unsaved_confirm_button": "Zahodit změny"
    },
    "operator_area": {
        "title": "Operátor",
        "tenant_menu": "Nájemníci",
        "feature_billing_menu": "Feature Monetization",
        "feature_usage_menu": "Feature Usage",
        "mcp_usage_menu": "MCP Usage",
        "invoice_recognition_menu": "Invoice Recognition",
        "ai_llm_menu": "AI/LLM Monitor",
        "holiday_settings_menu": "Svatky",
        "einvoice_acceptance_menu": "Pravidla přijetí e-faktury",
        "bank_statement_fixtures_menu": "Kontoauszug Test Fixtures",
        "procurement_menu": "Nákupní objednávky",
        "invoice_menu": "Faktury",
        "invoice_export_log_menu": "Export Log",
        "no_permission": "K zobrazení této oblasti nemáte oprávnění.",
        "invoice_export_log": {
            "title": "Export Log",
            "filters": {
                "tenant": "Filter tenant",
                "invoice_id": "Invoice ID",
                "export_group": "Export group",
                "module": "Module",
                "source": "Source",
                "include_exported": "Included exported",
                "clear": "Reset filters"
            },
            "sources": {
                "bulk": "Bulk selection",
                "individual": "Individual export"
            },
            "statuses": {
                "success": "Success",
                "partial": "Partial",
                "failed": "Failed",
                "empty": "No export"
            },
            "columns": {
                "id": "ID",
                "status": "Status",
                "created_at": "Created at",
                "tenant": "Tenant",
                "module": "Module",
                "source": "Source",
                "include_exported": "Included exported",
                "requested_by": "Requested by",
                "export_group": "Export group",
                "requested": "Requested",
                "exported": "Exported",
                "skipped": "Skipped",
                "failed": "Failed",
                "requested_invoice_ids": "Requested invoices",
                "actually_exported_invoice_ids": "Actually exported invoices",
                "skipped_already_exported_invoice_ids": "Skipped already exported",
                "failed_invoice_ids": "Failed invoices",
                "error_details": "Registered error"
            },
            "copy_success": "Export log copied.",
            "copy_failed": "The export log could not be copied.",
            "errors": {
                "load_failed": "The export log could not be loaded."
            }
        },
        "holiday_settings": {
            "title": "Holiday calendar",
            "subtitle": "Maintain holidays by country and state/region. Leave the state list empty to make a holiday apply nationwide.",
            "add": "Add holiday",
            "create_title": "Create holiday",
            "edit_title": "Edit holiday",
            "year_filter": "Filter by year",
            "state_filter": "Filter by state",
            "country_filter": "Filter by country",
            "regions_placeholder": "Select or enter states/regions",
            "nationwide": "Nationwide",
            "empty_regions_hint": "If no state/region is stored, the holiday applies to the entire country.",
            "delete_confirm": "Do you really want to delete this holiday?"
        },
        "einvoice_acceptance": {
            "title": "Pravidla přijetí e-faktury",
            "subtitle": "Nastavte instrukce pro výjimky IA a kritičnost pravidel pro místní validaci e-faktur.",
            "add": "Přidat pravidlo",
            "create_title": "Vytvořit pravidlo přijetí",
            "edit_title": "Upravit pravidlo přijetí",
            "error_code": "Pravidlo / kód chyby",
            "error_code_placeholder": "Hledat pravidlo, např. BR-CL-23 nebo kód jednotky",
            "error_code_description": "Krátký popis",
            "instruction": "Instrukce pro IA",
            "instruction_placeholder": "Pravidlo: BR-CL-23\nZjištění: Nestandardní kód jednotky\nRozhodnutí: ACCEPT, pokud množství, plnění, součty a daňový výpočet zůstanou jednoznačné\nOdůvodnění: Odchylka se týká technického kódu jednotky a fakturu automaticky nezneužitelnou nečiní.",
            "enabled": "Aktivní",
            "delete_confirm": "Opravdu chcete toto pravidlo přijetí smazat?",
            "with_ai": "S IA",
            "without_ai": "Bez IA",
            "edit_lists": "Upravit seznamy pravidel",
            "edit_lists_title": "Upravit seznamy pravidel bez IA",
            "edit_lists_hint": "Přesuňte každé místní validační pravidlo do příslušného seznamu. Změny se použijí až po uložení.",
            "manual_rule": "Ruční pravidlo",
            "manual_rule_placeholder": "Zadejte libovolný kód pravidla nebo chyby",
            "add_manual_rule": "Přidat pravidlo",
            "critical": "Kritická",
            "critical_hint": "Nález z tohoto seznamu ponechá e-fakturu zablokovanou.",
            "non_critical": "Nekritická",
            "non_critical_hint": "E-faktura pouze s nálezy z tohoto seznamu může projít místní validací.",
            "comment": "Komentář",
            "comment_placeholder": "Volitelný komentář k tomuto pravidlu",
            "edit_comment_title": "Upravit komentář pravidla",
            "no_comment": "Bez komentáře"
        },
        "bank_statement_fixtures": {
            "title": "Kontoauszug Test Fixtures",
            "subtitle": "Stažení automaticky generovaných testovacích souborů bankovních výpisů na základě otevřených faktur aktuálního tenanta.",
            "access_notice": "Pouze pro operatora. ZIP obsahuje tenant-specific test cases včetně manifest.json.",
            "format_label": "Výstupní formát",
            "format_placeholder": "Vyberte formát bankovního výpisu",
            "format_hint": "Vyberte jeden cílový formát. Všechny stažené varianty budou vygenerovány v tomto formátu.",
            "format_required": "Nejprve vyberte formát bankovního výpisu.",
            "client_hint": "Vyberte společnost, jejíž otevřené faktury se mají použít pro generování testovacích bankovních výpisů.",
            "client_required": "Nejprve vyberte společnost.",
            "client_placeholder": "Vyberte společnost s otevřenými fakturami",
            "load_clients_error": "Nepodařilo se načíst dostupné společnosti.",
            "setup_title": "Nastavení",
            "setup_hint": "Nejprve vyberte cílový formát a společnost, poté můžete stáhnout jeden nebo více testovacích scénářů.",
            "selection_ready": "Připraveno ke generování testovacích souborů",
            "selection_incomplete": "Pro povolení stahování dokončete výběr",
            "selection_hint": "Vybraná společnost se použije pro otevřené faktury i realistická kmenová data v každé variantě.",
            "selection_format": "Formát",
            "selection_company": "Společnost",
            "variants_title": "Dostupné scénáře",
            "variants_hint": "Níže vyberte konkrétní scénář, nebo po dokončení nastavení stáhněte celý ZIP.",
            "technical_details": "Technický náhled",
            "missing_value": "Není vybráno",
            "download_all": "Stáhnout všechny varianty",
            "download_variant": "Stáhnout variantu",
            "download_ready": "Stahování bylo spuštěno.",
            "download_error": "Testovací soubory se nepodařilo stáhnout.",
            "endpoint_label": "Endpoint",
            "auto_match_title": "Auto-Match",
            "auto_match_description": "Stáhne cílené testovací případy, ve kterých by měly být položky automaticky spárovány s otevřenými fakturami.",
            "mixed_title": "Smíšený scénář",
            "mixed_description": "Obsahuje jeden automatický match, jednu nezařaditelnou debetní položku a jednu ignorovanou kreditní položku.",
            "random_title": "Random Multi-Match",
            "random_description": "Obsahuje více realistických položek s několika matchi, další unmatched položky a jednu ignorovanou kreditní položku.",
            "supplier_iban_mismatch_title": "Odchylka IBAN dodavatele",
            "supplier_iban_mismatch_description": "Stáhne cílený testovací případ, ve kterém je dodavatel rozpoznán, ale IBAN ve výpisu se liší od kmenových dat dodavatele."
        },
        "tenant": {
            "description": "Nájemce",
            "new": "Nový nájemník",
            "edit": "Upravit",
            "archive": "Archiv",
            "delete": "Vymazat",
            "activate": "Obnovit",
            "procurement_count": "OB",
            "user_count": "Uživatel",
            "automatic_billing": "Automatické vyúčtování",
            "automatic_billing_via": "Ano (přes {id})",
            "automatic_billing_missing_easybill_id": "Ano (není propojeno žádné ID)",
            "storage_usage": "Úložiště",
            "tabs": {
                "general": "Obecné",
                "invoice_config": "Fakturace",
                "ai": "AI"
            }
            ,
            "standard_package": "Standardní balíček",
            "invoice": {
                "items": {
                    "label": "Další položky",
                    "description": "Popis",
                    "price": "Čistá částka",
                    "start_date": "Datum zahájení",
                    "end_date": "Datum ukončení"
                }
                ,
                "tiered_price": {
                    "label": "Stupňovité ceny",
                    "unit_price": "Jednotková cena",
                    "base_price": "Základní cena",
                    "doc_amount": "Množství"
                }
            }
            ,
            "contact_email_tooltip": "Nájemce se může zpočátku přihlásit pomocí tohoto e-mailu.",
            "no_bank_info": "Data zatím nejsou k dispozici a může je vytvořit pouze nájemce.",
            "no_connection_with_easybill": "Tento nájemce ještě není spojen s Easybill. Zaregistrujte si ID nájemce v systému Easybill.",
            "sync_with_easybill": "Získejte všechna data z Easybill",
            "update_from_easybill_btn": "Načíst z Easybill",
            "update_from_easybill_tooltip": "Získejte nájemce z Easybill",
            "send_to_easybill_btn": "Vytvořte v Easybill",
            "send_to_easybill_tooltip": "Vytvořte tenanta v Easybill",
            "link_existing_easybill_btn": "Propojit s existujícím Easybill ID",
            "link_existing_easybill_tooltip": "Ručně nastavit existující Easybill ID zákazníka",
            "link_easybill_replace_title": "Nahradit Easybill ID?",
            "link_easybill_replace_message": "Tento tenant je již propojen s Easybill ID {current}. Chcete změnit propojení na {next}?",
            "link_easybill_title": "Propojit Easybill ID",
            "link_easybill_prompt": "Zadejte prosím existující Easybill ID zákazníka.",
            "link_easybill_invalid": "Zadejte prosím číselné ID.",
            "create_and_send_invoice_tooltip": "Vytvořte fakturu v Easybill a odešlete ji zákazníkovi",
            "create_and_send_invoice_btn": "Vytvořit/odeslat fakturu",
            "open_invoices": "Zobrazit faktury",
            "delete_procurements": "Smazat objednávku",
            "delete_invoices": "Smazat faktury",
            "confirm_before_delete_msg": "<p>Opravdu chcete tohoto tenanta a všechna jeho data trvale smazat z databáze?</p><p> <i>Tuto akci nelze vrátit zpět.</i></p><p><b >Zadejte jméno nájemce:</b></p>",
            "confirm_before_delete_error_msg": "Tenant nebyl odstraněn, protože jméno bylo zadáno nesprávně.",
            "deleted_msg": "Nájemník byl trvale smazán.",
            "updated_msg": "Byla aktualizována.",
            "created_msg": "Bylo vytvořeno.",
            "sync_msg_error": "Tento nájemce ještě není spojen s Easybill. Zaregistrujte si ID nájemce v systému Easybill.",
            "create_invoice_dialog": {
                "title": "Vytvořit fakturaci",
                "message": "Vyberte fakturační období.",
                "date_placeholder": "Vyberte měsíc.",
                "create_btn": "Vytvořit"
            }
            ,
            "validation": {
                "name_required": "Zadejte jméno.",
                "name_exists": "Název již existuje.",
                "email_required": "Zadejte prosím kontaktní e-mail.",
                "email_invalid": "Prosím zadejte platný email."
            },
            "ai": {
                "enabled": "Povolit funkce AI",
                "model_name": "Název modelu AI",
                "max_tokens": "Maximální počet tokenů na požadavek (na 1 000 tokenů)",
                "price_input_tokens": "Cena za 1 000 vstupních tokenů (centy)",
                "price_output_tokens": "Cena za 1 000 výstupních tokenů (centy)"
            }
        }
        ,
        "procurement": {
            "title": "Nákupní objednávky od nájemce",
            "delete_title": "Smazat objednávku",
            "result_found": "Hity",
            "delete_result_found": "Smazat hity",
            "start_date": "Datum zahájení",
            "end_date": "Datum ukončení",
            "range_separator": "na",
            "confirm_delete_msg": "Opravdu chcete trvale odstranit vybrané nákupní objednávky z databáze?",
            "confirm_delete_title": "Smazat objednávku",
            "confirm_delete_btn": "Vymazat"
        }
        ,
        "invoice": {
            "title": "Faktury od nájemce",
            "delete_title": "Smazat faktury",
            "result_found": "Hity",
            "delete_result_found": "Smazat hity",
            "start_date": "Datum zahájení",
            "end_date": "Datum ukončení",
            "range_separator": "na",
            "confirm_delete_msg": "Opravdu chcete trvale smazat vybrané faktury z databáze?",
            "confirm_delete_title": "Smazat fakturu",
            "confirm_delete_btn": "Vymazat"
        },
        "feature_usage": {
            "title": "Feature usage by tenant",
            "empty_state": "No tracked feature usage was found for the selected period.",
            "not_available": "n/a",
            "unknown_tenant": "Unknown tenant",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "units": {
                "ms": "ms",
                "seconds": "s"
            },
            "summary": {
                "total_usage": "Tracked usage",
                "active_tenants": "Active tenants",
                "used_features": "Used features",
                "avg_usage_per_tenant": "Avg. usage per tenant",
                "top_feature": "Top feature",
                "of_active_base": "of active base",
                "top_feature_hint": "{usage} tracked uses across {tenants} tenants"
            },
            "charts": {
                "top_features": "Top features",
                "top_features_subtitle": "Most demanded features in the selected period.",
                "daily_trend": "Daily trend",
                "daily_trend_subtitle": "Tracked usage volume per day.",
                "procurement_sources": "Procurement sourcing",
                "procurement_sources_subtitle": "How products enter procurement lines in the selected period.",
                "punchout_providers": "Punchout providers",
                "punchout_providers_subtitle": "Marketplace usage by imported Punchout products.",
                "daily_usage_label": "Usage"
            },
            "procurement_sources": {
                "punchout": "Punchout",
                "catalog": "Product catalog",
                "on_the_fly": "On-the-fly",
                "unknown_punchout": "Unknown punchout"
            },
            "errors": {
                "schema_missing": "Feature usage tracking is not available in this environment yet. Apply the Hasura migration and metadata for tenant_feature_usage and reload the page.",
                "load_failed": "Feature usage could not be loaded."
            },
            "tables": {
                "features": "Feature ranking",
                "features_subtitle": "Demand by feature across the active tenant base.",
                "tenants": "Tenant ranking",
                "tenants_subtitle": "Most active tenants and their dominant features.",
                "modules": "Module overview",
                "modules_subtitle": "Consolidated demand by catalog module."
            },
            "columns": {
                "feature": "Feature",
                "module": "Module",
                "total_usage": "Usage",
                "active_tenants": "Tenants",
                "avg_per_tenant": "Avg./tenant",
                "event_breakdown": "Events",
                "top_tenant": "Top tenant",
                "last_used": "Last usage",
                "tenant": "Tenant",
                "used_features": "Features",
                "top_feature": "Top feature"
            }
        },
        "mcp_usage": {
            "title": "MCP usage",
            "empty_state": "No MCP usage was found for the selected period.",
            "no_errors": "No MCP errors were found for the selected period.",
            "not_available": "n/a",
            "units": {
                "ms": "ms",
                "seconds": "s"
            },
            "unknown_tenant": "Unknown tenant",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "summary": {
                "total_calls": "MCP calls",
                "active_tenants": "Active tenants",
                "active_users": "Active users",
                "success_rate": "Success rate",
                "error_calls_suffix": "calls with errors",
                "quality_score": "Quality score",
                "quality_score_hint": "Inferred from tool outcomes, warnings and result quality.",
                "answer_completion": "Inferred completion",
                "empty_results_suffix": "empty results",
                "avg_duration": "Avg. duration",
                "paginated_calls": "Paginated calls",
                "quality_signals_suffix": "quality signals",
                "session_feedback": "Session feedback",
                "session_feedback_hint": "Anonymized product insights from MCP conversations."
            },
            "charts": {
                "daily_trend": "Daily trend",
                "daily_trend_subtitle": "MCP calls per day in the selected period.",
                "top_tools": "Top tools",
                "top_tools_subtitle": "Most used MCP tools.",
                "outcomes": "Outcomes",
                "outcomes_subtitle": "Successful, blocked and failed calls.",
                "answer_quality": "Answer quality",
                "answer_quality_subtitle": "Inferred completeness of responses without storing prompts or answers.",
                "entities": "Entities",
                "entities_subtitle": "Business objects touched through MCP.",
                "calls_label": "Calls"
            },
            "tables": {
                "tools": "Tool ranking",
                "tools_subtitle": "Usage, success rate and average duration by tool.",
                "tenants": "Tenant ranking",
                "tenants_subtitle": "Tenants with the highest MCP activity.",
                "quality": "Quality focus",
                "quality_subtitle": "Tools with empty results, warnings, ignored filters or low inferred quality.",
                "answer_reasons": "Answer reasons",
                "answer_reasons_subtitle": "Why answers were complete, partial, blocked or unknown.",
                "errors": "Error focus",
                "errors_subtitle": "Sanitized error categories without prompts or payloads.",
                "session_feedback": "Session feedback",
                "session_feedback_subtitle": "Short anonymized AI notes about routing issues, gaps and suspected bugs."
            },
            "columns": {
                "tool": "Tool",
                "category": "Category",
                "answer_outcome": "Answer",
                "reason": "Reason",
                "calls": "Calls",
                "success_rate": "Success",
                "quality_score": "Quality",
                "empty_results": "Empty",
                "warnings": "Warnings",
                "ignored_filters": "Ignored filters",
                "avg_duration": "Avg. duration",
                "tenant": "Tenant",
                "users": "Users",
                "top_tool": "Top tool",
                "last_used": "Last usage",
                "error": "Error",
                "when": "Kdy",
                "feedback_category": "Kategorie",
                "severity": "Závažnost",
                "summary": "Poznámky",
                "related_tools": "Nástroje",
                "related_entities": "Entity"
            },
            "outcomes": {
                "success": "Success",
                "error": "Error",
                "permission_denied": "Permission denied",
                "rate_limited": "Rate limited",
                "validation_error": "Validation error",
                "timeout": "Timeout",
                "authentication_error": "Authentication error",
                "unknown": "Unknown"
            },
            "answer_outcomes": {
                "complete": "Complete",
                "partial": "Partial",
                "blocked": "Blocked",
                "empty_result": "Empty result",
                "low_confidence": "Low confidence",
                "unknown": "Unknown"
            },
            "feedback_reasons": {
                "success": "Successful",
                "no_data": "No data",
                "authentication_error": "Authentication",
                "permission_denied": "Permission denied",
                "rate_limited": "Rate limited",
                "timeout": "Timeout",
                "validation_error": "Validation error",
                "ambiguous_master_data": "Ambiguous master data",
                "paginated_result": "Paginated results",
                "tool_error": "Tool error",
                "low_confidence": "Low confidence",
                "not_supported": "Not supported",
                "filters_ignored": "Ignored filters",
                "warnings": "Warnings",
                "unknown": "Not specified"
            },
            "entities": {
                "none": "General",
                "bcase": "Workflow",
                "invoice": "Incoming invoices",
                "outgoing_invoice": "Outgoing invoices",
                "procurement": "Purchase orders",
                "contract": "Contracts",
                "bank_statement_entry": "Bank statement entries"
            },
            "no_session_feedback": "No session feedback was found for the selected period.",
            "session_feedback_categories": {
                "bug_suspicion": "Bug suspicion",
                "missing_capability": "Missing capability",
                "wrong_routing": "Wrong routing",
                "data_quality": "Data quality",
                "ux_friction": "UX friction",
                "feature_request": "Feature request",
                "positive_signal": "Positive signal",
                "unknown": "Unknown"
            },
            "session_feedback_severities": {
                "low": "Low",
                "medium": "Medium",
                "high": "High",
                "unknown": "Unknown"
            },
            "no_quality_issues": "No MCP quality signals were found for the selected period.",
            "errors": {
                "schema_missing": "MCP usage analytics is not available in this environment yet. Apply the Hasura migration and metadata for mcp_usage_event and reload the page.",
                "load_failed": "MCP usage could not be loaded."
            }
        },
        "ai_llm": {
            "title": "AI/LLM Monitor",
            "empty_state": "No LLM calls available for the selected period.",
            "no_errors": "No LLM failures in the selected period.",
            "unknown_tenant": "Unknown tenant",
            "unknown_region": "Unknown Azure endpoint",
            "unknown_operation": "Unknown operation",
            "unknown_model": "Unknown model",
            "filters": {
                "tenant_placeholder": "Filter by tenant",
                "operation_placeholder": "Filter by operation",
                "model_placeholder": "Filter by model",
                "status_placeholder": "Filter by status"
            },
            "shortcuts": {
                "this_month": "This month",
                "last_month": "Last month",
                "last_7_days": "Last 7 days",
                "last_30_days": "Last 30 days"
            },
            "summary": {
                "total_calls": "LLM calls",
                "total_calls_hint": "Central Azure OpenAI calls recorded by the backend.",
                "success_rate": "Success rate",
                "succeeded_suffix": "successful calls",
                "fallbacks": "Fallbacks used",
                "fallbacks_hint": "Successful calls that reached a secondary region.",
                "failures": "Failures",
                "rejected_suffix": "non-regional rejections",
                "system_status": "System status",
                "tokens": "Tokens",
                "tokens_hint": "{input} input / {output} output",
                "estimated_cost": "Estimated cost",
                "estimated_cost_hint": "Shown when token price configuration is available."
            },
            "health_states": {
                "unknown": "No data",
                "unknown_hint": "No calls were recorded for the selected filters.",
                "normal": "Normal",
                "normal_hint": "LLM calls are succeeding within the selected period.",
                "degraded": "Degraded",
                "degraded_hint": "Failures or fallback usage need attention.",
                "unavailable": "Unavailable",
                "unavailable_hint": "No successful LLM calls were recorded."
            },
            "alerts": {
                "unavailable_title": "LLM appears unavailable",
                "unavailable_description": "All recorded calls failed or were blocked for the selected period.",
                "failure_rate_high_title": "High LLM failure rate",
                "failure_rate_high_description": "The selected scope has a failure rate of {rate}.",
                "failure_rate_warning_title": "Elevated LLM failure rate",
                "failure_rate_warning_description": "The selected scope has a failure rate of {rate}.",
                "fallbacks_title": "Fallbacks were used",
                "fallbacks_description": "{count} successful call(s) required a secondary Azure endpoint."
            },
            "healthcheck": {
                "action": "Run healthcheck",
                "title": "Manual healthcheck",
                "subtitle": "Live Azure OpenAI endpoint test triggered by an operator.",
                "success": "At least one Azure endpoint responded successfully.",
                "warning": "No Azure endpoint responded successfully.",
                "error": "The LLM healthcheck could not be completed.",
                "no_endpoints_title": "No Azure endpoints were tested",
                "no_endpoints_description": "Check that endpoint, api-key and deployment are configured for Azure OpenAI.",
                "all_ok_title": "All Azure endpoints are reachable",
                "all_ok_description": "{count} Azure endpoint(s) responded successfully.",
                "partial_title": "Some Azure endpoints are reachable",
                "partial_description": "{succeeded} of {total} Azure endpoint(s) responded successfully. Check the per-endpoint error details.",
                "none_ok_title": "No Azure endpoint responded successfully",
                "none_ok_description": "The endpoint can be correct while the API key, deployment name or permissions do not match at least one Azure OpenAI resource."
            },
            "charts": {
                "region_health": "Azure endpoint health",
                "region_health_subtitle": "Successful and failed Azure OpenAI calls by endpoint and operation.",
                "daily_failures": "Failures over time",
                "daily_failures_subtitle": "Failed, rejected and circuit-open calls per day.",
                "failures_label": "Failures"
            },
            "tables": {
                "regions": "Azure endpoints and operations",
                "regions_subtitle": "Aggregated health by Azure OpenAI endpoint, operation and model.",
                "latest_errors": "Latest errors",
                "latest_errors_subtitle": "Recent failed or rejected LLM calls for operational triage."
            },
            "columns": {
                "created_at": "Time",
                "tenant": "Tenant",
                "region": "Region",
                "azure_endpoint": "Azure endpoint",
                "operation": "Operation",
                "model": "Model",
                "calls": "Calls",
                "successes": "Successes",
                "failures": "Failures",
                "failure_rate": "Failure rate",
                "avg_duration": "Avg. duration",
                "status": "Status",
                "http_status": "HTTP",
                "retries": "Retries",
                "duration": "Duration",
                "error": "Error"
            },
            "statuses": {
                "succeeded": "Succeeded",
                "failed": "Failed",
                "rejected": "Rejected",
                "circuit_open": "Region blocked"
            },
            "units": {
                "milliseconds": "{value} ms",
                "seconds": "{value} s"
            },
            "errors": {
                "schema_missing": "LLM call logging is not available in this environment yet. Apply the Hasura migration and metadata for ai_llm_call_log and reload the page.",
                "load_failed": "LLM dashboard data could not be loaded."
            }
        },
        "invoice_recognition": {
            "title": "Invoice Recognition – Monitor",
            "empty_state": "No data available for the selected period.",
            "no_switchovers": "No region switchovers were required in the selected period.",
            "no_in_flight": "No recognitions are currently in the queue.",
            "unknown_tenant": "Unknown tenant",
            "processing_active": "Processing",
            "processing_idle": "Waiting",
            "copy_success": "Copied to clipboard.",
            "copy_failed": "Could not copy.",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "shortcuts": {
                "this_month": "This month",
                "last_month": "Last month",
                "last_7_days": "Last 7 days",
                "last_30_days": "Last 30 days"
            },
            "summary": {
                "invoices_processed": "Invoices processed",
                "invoices_processed_hint": "{attempts} attempts in total",
                "successful": "Recognized successfully",
                "switchovers": "Region switchovers",
                "switchovers_hint": "Invoices that needed at least one region switch (relevant for MS refund).",
                "failed": "Finally failed",
                "failed_hint": "Invoices without a successful recognition (handed over to manual review).",
                "in_flight": "Currently in flight",
                "in_flight_hint": "Invoices currently waiting in the recognition queue."
            },
            "charts": {
                "region_status": "Attempts per region",
                "region_status_subtitle": "Distribution of recognition attempts by region and status.",
                "daily_failures": "Failures over time",
                "daily_failures_subtitle": "Failed attempts per day in the selected period.",
                "failures_label": "Failures"
            },
            "tables": {
                "switchovers": "Invoices with region switchover",
                "switchovers_subtitle": "Invoices that switched at least once to another region. Expand a row to see the full attempt trail incl. provider operation IDs (evidence for MS refund cases).",
                "region_health": "Region health",
                "region_health_subtitle": "Current health of each Azure AI region in the selected period.",
                "in_flight": "In-flight recognitions",
                "in_flight_subtitle": "Invoices currently waiting in the queue for a response."
            },
            "columns": {
                "tenant": "Tenant",
                "invoice_id": "Invoice ID",
                "region_path": "Region path",
                "attempt_count": "Attempts",
                "final_status": "Final status",
                "last_attempt": "Last attempt",
                "operation_id": "Operation ID",
                "region": "Region / model",
                "total_attempts": "Attempts",
                "successes": "Successes",
                "failures": "Failures",
                "failure_rate": "Failure rate",
                "last_failure": "Last failure",
                "poll_attempts": "Polls",
                "elapsed": "Elapsed",
                "processing": "Status"
            },
            "statuses": {
                "submitted": "Submitted",
                "succeeded": "Succeeded",
                "failed": "Failed",
                "timed_out": "Timed out",
                "submission_failed": "Submission failed",
                "circuit_open": "Region blocked"
            },
            "models": {
                "document_intelligence": "Document Intelligence",
                "content_understanding": "Content Understanding",
                "azure_open_ai": "Azure OpenAI"
            },
            "errors": {
                "load_failed": "Could not load data."
            },
            "tabs": {
                "operations": "Provoz",
                "quality": "Kvalita",
                "approval_quality": "Kvalita schvalování"
            },
            "approval_quality": {
                "scope_manual": "Ručně zkontrolované",
                "scope_auto": "Automaticky předané",
                "scope_all": "Všechna rozhodnutí",
                "methodology": "Ve výchozím nastavení se porovnávají všechna rozhodnutí AI o schválení — včetně automaticky předaných. Schváleno = účetnictví, export nebo dokončeno; zrušeno = zamítnuto nebo exportováno zrušení. Probíhající a technicky nevyhodnotitelná rozhodnutí se do sazeb kvality nezapočítávají.",
                "invoices_evaluated": "Vyhodnocené doklady",
                "invoices_evaluated_hint": "{decided} rozhodnutí, z toho {pending} probíhá a {unavailable} nelze technicky vyhodnotit",
                "false_approval_rate": "Míra chybných schválení",
                "false_approval_rate_hint": "{falseApprovals} z {aiApprovals} schválení navržených AI bylo později zrušeno.",
                "approval_precision": "Správná schválení AI",
                "approval_precision_hint": "Podíl schválení navržených AI, která zůstala ve finálním výsledku schválená.",
                "missed_automation_rate": "Nevyužitá automatizace",
                "missed_automation_rate_hint": "{missed} z {approved} finálně schválených dokladů AI neschválila.",
                "agreement_rate": "Shoda",
                "agreement_rate_hint": "Podíl uzavřených případů, ve kterých se rozhodnutí AI shoduje s finálním výsledkem.",
                "matrix_title": "Rozhodnutí AI oproti finálnímu výsledku",
                "matrix_subtitle": "Pouze uzavřená a technicky vyhodnotitelná rozhodnutí ve vybraném období.",
                "actual_approved": "Finálně schváleno",
                "actual_cancelled": "Finálně zrušeno",
                "ai_approved": "AI by schválila",
                "ai_rejected": "AI by neschválila",
                "correct": "Správně",
                "false_approval": "Chybné schválení",
                "missed_automation": "Nevyužitá automatizace",
                "false_approvals_title": "Detail chybných schválení",
                "false_approvals_subtitle": "Až 80 dokladů, které by AI schválila, ale které byly nakonec zrušeny.",
                "empty_state": "Ve vybraném období nebyla nalezena žádná chybná schválení.",
                "load_failed": "Data kvality schvalování se nepodařilo načíst.",
                "number": "Číslo faktury",
                "score": "Skóre AI",
                "threshold": "Práh",
                "reasons": "Rozhodující signály",
                "final_status": "Finální stav",
                "auto_forwarded": "Automaticky",
                "decided_at": "Rozhodnutí AI",
                "yes": "Ano",
                "no": "Ne"
            },
            "quality": {
                "scope_all": "Všechny doklady",
                "scope_manual": "Ručně zkontrolováno",
                "scope_auto": "Automaticky předáno KI",
                "methodology": "Porovnání: snímek po rozpoznání dokladu a KI validaci s aktuálním dokladem. Změněné pole = nesprávné rozpoznání.",
                "invoices_evaluated": "Hodnocené doklady",
                "invoices_evaluated_hint": "{manual} ručně zkontrolováno, {auto} automaticky předáno",
                "mean_field_rate": "Aritmetický průměr",
                "mean_field_rate_hint": "Průměrná úspěšnost rozpoznání napříč všemi poli.",
                "median_field_rate": "Medián",
                "median_field_rate_hint": "Úspěšnost prostředního pole, méně ovlivněná odlehlými hodnotami.",
                "mean_receipt_score": "Průměr na doklad",
                "median_receipt_score_hint": "Medián na doklad: {median}",
                "field_chart_title": "Úspěšnost podle pole",
                "field_chart_subtitle": "Podíl dokladů, u kterých pole po rozpoznání zůstalo nezměněné.",
                "groups_title": "Skupiny polí",
                "groups_subtitle": "Vážená úspěšnost podle skupiny (pouze hodnocená pole).",
                "fields_title": "Pole podrobně",
                "fields_subtitle": "Nezměněné = správně rozpoznáno. Prázdná pole na obou stranách se nezapočítávají.",
                "invoices_title": "Doklady s nejnižší úspěšností",
                "invoices_subtitle": "80 dokladů s nejslabší shodou ve zvoleném období. Řádek rozbalte pro změněná pole.",
                "empty_state": "Pro toto období zatím nejsou k dispozici žádné snímky. Měření začíná u nově rozpoznaných dokladů po tomto vydání.",
                "load_failed": "Data o kvalitě se nepodařilo načíst.",
                "field": "Pole",
                "group": "Skupina",
                "evaluated": "Hodnoceno",
                "matched": "Nezměněno",
                "rate": "Úspěšnost",
                "number": "Číslo faktury",
                "receipt_score": "Skóre dokladu",
                "fields_short": "Pole",
                "auto_forwarded": "Automaticky",
                "auto_yes": "Ano",
                "auto_no": "Ne",
                "baseline_at": "Snímek",
                "baseline": "Po rozpoznání",
                "final_value": "Aktuální",
                "no_mismatches": "Žádná změněná pole.",
                "groups": {
                    "document": "Údaje dokladu",
                    "bank": "Bankovní údaje",
                    "matching": "Přiřazení",
                    "organization": "Organizace",
                    "lines": "Položky"
                }
            }
        },
        "feature_billing": {
            "title": "Feature monetization",
            "sync": "Sync catalog",
            "new_package": "New package",
            "create_package": "Create package",
            "edit_package": "Edit package",
            "sync_success": "Feature catalog synchronized.",
            "catalog_hint": "This area monetizes existing modules, features and packages without changing the current runtime behavior of the system.",
            "overview_title": "Overview & metrics",
            "show_overview": "Show metrics",
            "hide_overview": "Hide metrics",
            "edit_feature": "Edit monetization",
            "manage_tenants": "Manage tenants",
            "assign_tenant": "Assign tenant",
            "manage_package_tenants": "Manage package tenants",
            "assign_package": "Assign package",
            "assignment_dialog_title": "Tenant feature assignment",
            "package_assignment_dialog_title": "Tenant package assignment",
            "custom_price_hint": "Leave empty to use the feature default price.",
            "not_configured": "Not configured",
            "no_assignments": "No tenant assignment found.",
            "unassigned_module": "Without module",
            "unassigned_module_description": "Features that are monetized independently from any specific module.",
            "package_features_label": "Included features",
            "package_feature_hint": "Select the features that belong to this package.",
            "package_code_placeholder": "stable-package-code",
            "package_code_hint": "Generated automatically from the package name.",
            "catalog_inactive": "Catalog inactive",
            "billing_enabled": "Monetization enabled",
            "billing_disabled": "Monetization disabled",
            "tabs": {
                "features": "Features",
                "packages": "Packages",
                "tenants": "Tenants",
                "ai_automation": "AI automation"
            },
            "summary": {
                "modules": "Modules",
                "features": "Features",
                "packages": "Packages",
                "direct_assignments": "Direct assignments",
                "package_assignments": "Package assignments",
                "active_assignments": "Active assignments",
                "trial_assignments": "Trial assignments"
            },
            "sections": {
                "package_assignments": "Package assignments",
                "direct_feature_assignments": "Direct feature assignments"
            },
            "columns": {
                "module": "Module",
                "feature": "Feature",
                "package": "Package",
                "code": "Code",
                "description": "Description",
                "catalog_status": "Catalog status",
                "billing_type": "Billing type",
                "default_price": "Default price",
                "default_demo_days": "Demo days",
                "pricing": "Pricing",
                "coverage": "Coverage",
                "composition": "Composition",
                "assignments": "Assignments",
                "direct_assignments": "Direct",
                "covered_tenants": "Covered tenants",
                "packages": "Packages",
                "included_features": "Included features",
                "references": "System reference",
                "tenant": "Tenant",
                "status": "Status",
                "effective_price": "Effective price",
                "custom_price": "Custom price",
                "demo_until": "Demo until",
                "active_features": "Active",
                "active_packages": "Packages",
                "trial_features": "Trial",
                "total_assignments": "Total"
            },
            "ai_automation": {
                "title": "AI automation by client and supplier",
                "description": "Evaluates AI-validated invoices by whether they reached export without relevant manual corrections.",
                "details_title": "Monthly evaluation",
                "empty_title": "No AI automation data yet",
                "empty_text": "After the migration is applied and AI-validated invoices have been exported, the evaluation will be filled.",
                "unknown_tenant": "Unknown tenant",
                "unknown_client": "Unknown client",
                "unknown_supplier": "Unknown supplier",
                "no_client": "No client",
                "no_supplier": "No supplier",
                "detail_title": "Invoice details",
                "actions": {
                    "details": "Details"
                },
                "summary": {
                    "total_invoices": "Invoices",
                    "ai_validated": "AI validated",
                    "one_click_export": "One-click export",
                    "best_case": "Best case",
                    "automation_value": "Automation value",
                    "manual_corrections": "Manual corrections"
                },
                "columns": {
                    "company": "Company",
                    "client_supplier": "Client / supplier",
                    "period": "Period",
                    "supplier": "Supplier",
                    "billing_tier": "Billing tier",
                    "ai_validated": "AI validated",
                    "email_imported": "Email",
                    "auto_export": "Auto export",
                    "exported": "Exported",
                    "one_click": "One-click",
                    "best_case": "Best case",
                    "manual_corrections": "Manual corrections"
                },
                "column_help": {
                    "tenant": "Tenant or customer account to which this monthly KPI row belongs.",
                    "client_supplier": "Combination of client and supplier for the invoices counted in this row.",
                    "period": "Calendar month and year covered by this evaluation row.",
                    "billing_tier": "Derived monetization tier based on the measured automation score for this row.",
                    "ai_validated": "How many invoices were AI-validated out of all invoices in the row. The note shows how many came from email import.",
                    "auto_export": "Invoices automatically forwarded toward export. The note shows how many were ultimately exported successfully.",
                    "one_click": "Invoices that reached export with a one-click confirmation after AI validation.",
                    "best_case": "Invoices with the highest automation level, typically email-imported and exported with one click and no relevant manual correction.",
                    "manual_corrections": "Invoices that still required relevant manual changes after AI processing. The note breaks down the correction types.",
                    "actions": "Opens the invoice-level detail view for the selected monthly row."
                },
                "detail_columns": {
                    "invoice": "Invoice",
                    "automation": "Automation",
                    "ki": "AI",
                    "export": "Export",
                    "corrections": "Corrections",
                    "result": "Result"
                },
                "boolean": {
                    "yes": "Yes",
                    "no": "No"
                },
                "labels": {
                    "email": "Email",
                    "validated": "Validated",
                    "auto_forwarded": "Auto export",
                    "one_click": "One-click",
                    "best_case": "Best case",
                    "not_exported": "Not exported"
                },
                "automation_levels": {
                    "unknown": "Unknown",
                    "no_ai": "No AI",
                    "ai_not_validated": "Not validated",
                    "manual_correction": "Manual correction",
                    "ki_validated_waiting": "AI validated",
                    "ki_autonomous_to_export_ready": "Prepared for export",
                    "one_click_export": "One-click export",
                    "email_import_one_click_export": "Email one-click export"
                },
                "billing_tiers": {
                    "premium": "Premium",
                    "advanced": "Advanced",
                    "automation": "Automation",
                    "assist": "Assist",
                    "base": "Base"
                },
                "billing_tier_legend": {
                    "title": "Billing tier guide",
                    "items": {
                        "base": "Little measurable automation value in this row.",
                        "assist": "AI assists the process, but manual work still dominates.",
                        "automation": "Meaningful automation gains; several invoices are export-ready with limited manual effort.",
                        "advanced": "High automation level with only occasional manual intervention.",
                        "premium": "Very high automation level; most invoices run nearly touchless."
                    }
                },
                "correction_types": {
                    "values": "Values",
                    "bank": "Bank",
                    "organization": "Organization",
                    "other": "Other",
                    "note_only": "Note only",
                    "none": "No relevant correction"
                }
            },
            "billing_types": {
                "monthly": "Monthly",
                "yearly": "Yearly",
                "one_time": "One-time",
                "usage": "Usage-based",
                "included": "Included"
            },
            "assignment_statuses": {
                "active": "Active",
                "trial": "Trial",
                "inactive": "Inactive"
            },
            "validation": {
                "package_name_required": "Please enter a package name.",
                "package_code_required": "Please enter a valid package code.",
                "package_features_required": "Please select at least one feature for the package."
            }
        }
    }
    ,
    "timeline": {
        "title": "Timeline",
        "preferences": {
            "order_asc": "Nejdříve nejstarší",
            "order_desc": "Nejdříve nejnovější",
            "comment_notifications": "E-mailová upozornění na komentáře",
            "comment_notifications_enabled": "Upozornění na komentáře zapnuta.",
            "comment_notifications_disabled": "Upozornění na komentáře vypnuta."
        }
        ,
        "text": {
            "description_assignment": "Úkol byl přijat.",
            "cancellation": {
                "name": "{name}",
                "description_past_successful_invoice": "Faktura byla vyřazena a archivována.",
                "description_past_successful_outgoing-invoice": "Vydaná faktura byla zrušena a archivována.",
                "description_past_successful_procurement": "Objednávka byla zrušena a archivována.",
                "description_past_successful_contract": "Smlouva byla zrušena a archivována.",
                "name_procurement": "Zrušení",
                "name_contract": "Zrušení",
                "name_outgoing-invoice": "Zrušení",
                "name_invoice": "Vyřazení"
            }
            ,
            "start": {
                "name": "Nová objednávka",
                "description_past_successful": "Byla vytvořena nová nákupní objednávka."
            }
            ,
            "select-product": {
                "is_searchable": true,
                "simple_name": "Výběr produktu",
                "name": "Výběr produktu (fáze {index})",
                "description_past_unsuccessful": "Výběr produktu byl zrušen.",
                "description_past_successful": "Produkty pro tuto objednávku byly vybrány.",
                "description_present": "Vyberte prosím produkty pro tuto objednávku.",
                "description_future": "Je třeba vybrat produkty pro tuto objednávku."
            }
            ,
            "approval": {
                "is_searchable": true,
                "simple_name": "Schválení",
                "name": "Schválení (etapa {index})",
                "description_past_unsuccessful": "Schválení objednávky bylo zrušeno.",
                "description_past_successful": "Objednávka byla zkontrolována a schválena.",
                "description_present": "Zkontrolujte a schvalte objednávku.",
                "description_future": "Objednávku je třeba zkontrolovat a schválit."
            }
            ,
            "send-order": {
                "is_searchable": true,
                "name": "Umístění objednávky",
                "description_past_unsuccessful": "Zadání objednávky bylo zrušeno.",
                "description_past_successful": "Objednávka byla podána u dodavatele.",
                "description_present": "Objednávejte prosím u dodavatele.",
                "description_future": "Objednávku je nutné zadat u dodavatele."
            }
            ,
            "delivery": {
                "is_searchable": true,
                "name": "Potvrzení o doručení",
                "description_past_unsuccessful": "Potvrzení o převzetí zboží bylo zrušeno.",
                "description_past_successful": "Zboží bylo doručeno a převzetí potvrzeno.",
                "description_present": "Prosím o potvrzení převzetí zboží.",
                "description_future": "Převzetí zboží je nutné potvrdit."
            }
            ,
            "reassignment": {
                "name": "Úkol",
                "description_past_unsuccessful": "",
                "description_past_successful": "přidělil úkol uživateli {name}.",
                "description_past_successful_from_group": "přijal úkol."
            }
            ,
            "clearing": {
                "is_searchable": true,
                "name": "Objasnění",
                "description_past_unsuccessful": "Objasnění bylo zrušeno.",
                "description_past_successful": "Nejistoty byly odstraněny.",
                "description_present": "Prosím o vyjasnění nejasností ohledně objednávky.",
                "description_finished_unsuccessful": "Objednávka byla zrušena a archivována."
            }
            ,
            "order-sent-internal": {
                "name": "Systémová zpráva",
                "description_past_successful": "Objednávka <b>({first_product_name})</b> u dodavatele <b>{supplier}</b> byla zadána a potvrzena."
            }
            ,
            "order-sent-punchout": {
                "name": "Systémová zpráva",
                "description_past_successful": "Objednávka <b>({first_product_name})</b> byla odeslána elektronicky dodavateli <b>{supplier}</b>."
            }
            ,
            "product-received": {
                "name": "Systémová zpráva",
                "description_past_successful": "<b>{quantity} {unit}</b> přijato:<p>{product}</p><span style=\"color:#9a9898\">{supplier}</span>"
            }
            ,
            "invoice-upload": {
                "name": "Nová faktura",
                "description_past_successful": "Faktura byla nahrána."
            }
            ,
            "invoice-recognition": {
                "is_searchable": true,
                "name": "Rozpoznávání faktur",
                "description_past_unsuccessful": "Uznávání fakturačních údajů bylo zrušeno.",
                "description_past_successful": "Rozpoznávání fakturačních údajů bylo dokončeno.",
                "description_present": "Údaje o faktuře se načítají. Tento proces může trvat až minutu. Obnovte stránku po této době, abyste viděli výsledky."
            }
            ,
            "invoice-historical-import": {
                "name": "Historický import",
                "description_past_successful": "Faktura byla uložena jako historická faktura."
            },
            "procurement-recognition": { "name": "Rozpoznaná data objednávky", "description_past_successful": "Data objednávky byla vytěžena z historického e-mailu." },
            "procurement-counterparty-recognition": { "name": "Rozpoznané protistrany", "description_past_successful": "Společnost a dodavatel byli rozpoznáni." },
            "procurement-master-data-adopted": { "name": "Kmenová data převzata", "description_past_successful": "Rozpoznaná kmenová data byla převzata." },
            "procurement-historical-import": { "name": "Historický import", "description_past_successful": "Objednávka byla uložena jako historický kontext." }
            ,
            "invoice-counterparty-recognition": {
                "name": "Společnost a dodavatel rozpoznáni",
                "description_past_successful": "Společnost a dodavatel byli rozpoznáni z faktury.",
                "description_past_unsuccessful": "Společnost a dodavatele se nepodařilo spolehlivě určit."
            }
            ,
            "invoice-master-data-adopted": {
                "name": "Kmenová data převzata",
                "description_past_successful": "Rozpoznaná data společnosti nebo dodavatele byla převzata do kmenových dat.",
                "description_past_unsuccessful": "Nebyla převzata žádná spolehlivá kmenová data."
            }
            ,
            "invoice-manual-check": {
                "is_searchable": true,
                "name": "Ruční kontrola",
                "description_past_unsuccessful": "Ruční kontrola nebyla dokončena.",
                "description_past_successful": "Faktura byla ručně zkontrolována.",
                "description_present": "Zkontrolujte prosím údaje na faktuře.",
                "description_future": "Faktura musí být ručně zkontrolována."
            }
            ,
            "invoice-financial-approval": {
                "is_searchable": true,
                "simple_name": "Schválení faktury",
                "name": "Schválení faktury (Fáze {index})",
                "description_past_unsuccessful": "Schválení faktury bylo zrušeno.",
                "description_past_successful": "Faktura byla zkontrolována a schválena.",
                "description_present": "Prosím, zkontrolujte a schvalte fakturu.",
                "description_future": "Faktura musí být zkontrolována a schválena."
            }
            ,
            "invoice-clearing": {
                "is_searchable": true,
                "name": "Objasnění účetnictví",
                "description_past_unsuccessful": "Objasnění bylo zrušeno.",
                "description_past_successful": "Nejistoty faktur byly odstraněny.",
                "description_present": "Vyjasněte prosím nejasnosti týkající se faktury.",
                "description_finished_unsuccessful": "Faktura byla stornována a archivována."
            }
            ,
            "invoice-export": {
                "is_searchable": true,
                "name": "Vývozní",
                "description_past_unsuccessful": "Faktura nebyla exportována.",
                "description_past_successful": "Faktura byla odeslána společnosti {export_name}.",
                "description_present": "Faktura je připravena k exportu.",
                "description_future": "Faktura je připravena k exportu."
            }
            ,
            "invoice-accounting": {
                "is_searchable": true,
                "name": "Účetnictví",
                "description_past_unsuccessful": "Účetnictví bylo zastaveno.",
                "description_past_successful": "Účetnictví bylo ověřeno.",
                "description_present": "Prosím zkontrolujte účetnictví.",
                "description_future": "Účetnictví musí být ověřeno."
            }
            ,
            "invoice-verified": {
                "is_searchable": true,
                "name": "Ověřeno",
                "description_past_unsuccessful": "Ověření bylo zrušeno.",
                "description_past_successful": "Faktura byla ověřena.",
                "description_present": "Faktura bude ověřena.",
                "description_future": "Faktura bude ověřena."
            }
            ,
            "skip": {
                "name": "Zrušení",
                "description_past_successful": "zrušil krok."
            },
            "contract-start": {
                "name": "Nová smlouva",
                "description_past_successful": "Smlouva byla vytvořena."
            },
            "contract-recognition": {
                "is_searchable": true,
                "name": "Rozpoznání smlouvy",
                "description_past_successful": "Údaje smlouvy byly rozpoznány.",
                "description_present": "Údaje smlouvy se rozpoznávají."
            },
            "contract-check": {
                "is_searchable": true,
                "name": "Kontrola smlouvy",
                "description_past_unsuccessful": "Kontrola nebyla dokončena.",
                "description_past_successful": "Smlouva byla zkontrolována.",
                "description_present": "Prosím, zkontrolujte údaje smlouvy."
            },
            "contract-signing": {
                "is_searchable": true,
                "name": "Podpis smlouvy",
                "description_past_unsuccessful": "Smlouva nebyla podepsána.",
                "description_past_successful": "Smlouva byla podepsána.",
                "description_present": "Prosím, podepište smlouvu.",
                "description_future": "Smlouva musí být podepsána."
            },
            "contract-clearing": {
                "is_searchable": true,
                "name": "Vyjasnění smlouvy",
                "description_past_unsuccessful": "Vyjasnění bylo zrušeno.",
                "description_past_successful": "Nejasnosti ve smlouvě byly vyřešeny.",
                "description_present": "Prosím, vyjasněte smlouvu.",
                "description_finished_unsuccessful": "Smlouva byla zrušena a archivována."
            }
        }
    }
    ,
    "jexcel": {
        "noRecordsFound": "Nebyly nalezeny žádné záznamy.",
        "showingPage": "Stránka {0} z {1}",
        "show": "Ukázat",
        "entries": "záznamy",
        "insertANewColumnBefore": "Před vložením sloupce",
        "insertANewColumnAfter": "Vložte sloupec za",
        "deleteSelectedColumns": "Smazat vybrané sloupce",
        "renameThisColumn": "Přejmenujte tento sloupec",
        "orderAscending": "Seřadit vzestupně",
        "orderDescending": "Seřadit sestupně",
        "insertANewRowBefore": "Vložit řádek před",
        "insertANewRowAfter": "Vložte řádek za",
        "deleteSelectedRows": "Smazat vybrané řádky",
        "copy": "kopírovat",
        "paste": "Vložit",
        "saveAs": "Uložit jako",
        "about": "O",
        "areYouSureToDeleteTheSelectedRows": "Opravdu chcete smazat vybrané řádky?",
        "areYouSureToDeleteTheSelectedColumns": "Opravdu chcete smazat vybrané sloupce?",
        "thisActionWillDestroyAnyExistingMergedCellsAreYouSure": "Tato akce zničí všechny existující sloučené buňky. Jsi si jistá?",
        "thisActionWillClearYourSearchResultsAreYouSure": "Tato akce vymaže výsledky vyhledávání. Jsi si jistá?",
        "thereIsAConflictWithAnotherMergedCell": "Došlo ke konfliktu s jinou sloučenou buňkou",
        "invalidMergeProperties": "Neplatné sloučené vlastnosti",
        "cellAlreadyMerged": "Buňka již byla sloučena",
        "noCellsSelected": "Není vybrána žádná buňka",
        "save_warning": "Kopírování dat mezi Excelem a webem může vést k chybnému pořadí a ztrátě ID vztahů. <br>Prosím, používejte pouze online úpravy nebo přidávejte data z Excelu pouze jako doplněk."
    }
    ,
    "system_comment": {
        "name": {
            "allocation": "Přidělení",
            "datev_export": "Export DATEV",
            "export_error": "Chyba exportu",
            "export_detail": "Export protokolu",
            "repeat_recognition": "Zopakovat rozpoznání faktury",
            "bank_data_export_summary": "Platební způsob",
            "payment": "Platba podle bankovního výpisu",
            "bank_statement_payment": "Platba podle bankovního výpisu",
            "contract-termination-email": "Připomenutí výpovědi smlouvy",
            "ai_validation": "Ověření AI"
        },
        "contract_termination_email_sent": "E-mail s připomenutím výpovědi byl odeslán příjemci {recipient}.",
        "contract_termination_email_failed": "E-mail s připomenutím výpovědi se nepodařilo odeslat příjemci {recipient}. Chyba: {error}.",
        "ai_validation_trusted": "Faktura byla ověřena umělou inteligencí a považována za důvěryhodnou.",
        "ai_validation_not_trusted": "Faktura byla ověřena umělou inteligencí a předána k ruční kontrole.",
        "invoice_approval_restart": "Schvalovací proces faktury byl restartován. Důvod: {reason}",
        "recognition_was_repeated": "{user_name} zopakoval(a) rozpoznání dokumentu.",
        "attach_new_invoice_to_procurement": "Faktura <b>{link_to_invoice}</b> od <b>{supplier_name}</b> byla přiřazena k této objednávce uživatelem <b>{user_name}</b>.",
        "attach_new_invoice_to_bcase": "Faktura <b>{link_to_invoice}</b> od <b>{supplier_name}</b> byla přiřazena k tomuto dokladu uživatelem <b>{user_name}</b>.",
        "change_bcase_of_invoice": "Přiřazení faktury <b>{link_to_invoice}</b> od <b>{supplier_name}</b> bylo odstraněno. <br>Faktura byla přiřazena k dokladu {link_to_bcase}.",
        "detach_bcase_of_invoice": "Přiřazení faktury <b>{link_to_invoice}</b> od <b>{supplier_name}</b> bylo odstraněno.",
        "attach_new_invoice_to_procurement_without_supplier": "Faktura <b>{link_to_invoice}</b> byla přiřazena k této objednávce uživatelem <b>{user_name}</b>.",
        "change_procurement_of_invoice": "Přidělení faktury <b>{link_to_invoice}</b> od <b>{supplier_name}</b> bylo odstraněno. <br>Faktura byla přiřazena k objednávce {link_to_procurement}.",
        "change_procurement_of_invoice_without_supplier": "Přidělení faktury <b>{link_to_invoice}</b> bylo odstraněno. <br>Faktura byla přiřazena k objednávce {link_to_procurement}.",
        "detach_procurement_of_invoice": "Přidělení faktury <b>{link_to_invoice}</b> od <b>{supplier_name}</b> bylo odstraněno.",
        "detach_procurement_of_invoice_without_supplier": "Přidělení faktury <b>{link_to_invoice}</b> bylo odstraněno.",
        "attach_external_invoice_to_procurement": "Faktura {invoice_number} od <b>{supplier_name}</b> byla přiřazena k této objednávce uživatelem <b>{invoice_by}</b>.",
        "insert_datev_note": "Faktura <b>{link_to_invoice}</b> od <b>{supplier_name}</b> byla odeslána do DATEV.",
        "insert_datev_note_without_supplier": "Faktura <b>{link_to_invoice}</b> byla odeslána DATEV.",
        "on_ms365_export_error_generic": "Chyba při exportu faktury do D365. Kontaktujte prosím podporu.",
        "on_ms365_export_validation_error": "Chyba při exportu faktury do D365. Kontaktujte prosím podporu. Chyba: {error}",
        "on_export_error": "Fakturu nebylo možné odeslat do DATEV. {error}",
        "on_export_error_generic": "Chyba při exportu faktury do DATEV. Kontaktujte prosím podporu.",
        "on_export_error_validation": "{supplier_external_id_export_validation}{supplier_name_export_validation} Obraťte se prosím na někoho s administrátorskými právy, aby zkontroloval nastavení.",
        "on_export_error_datev_access_is_not_active": "Musí být vytvořeno spojení s DATEV. Kontaktujte někoho s právy správce.",
        "on_export_error_client_has_no_datev_access": "Společnost {client_name} neuložila žádná přístupová data DATEV. Kontaktujte někoho s právy správce.",
        "on_export_error_client_has_no_datev_permission": "Při přenosu do DATEV došlo k chybě. Založený účet DATEV nemá oprávnění pro společnost {client_name}. Obraťte se na někoho s administrátorskými právy, aby zkontroloval přístup, firemní údaje nebo oprávnění v rámci DATEV.",
        "on_export_error_no_fiscal_year": "Při přenosu do DATEV došlo k chybě. Datum faktury není ve fiskálním roce DATEV. Chcete-li zkontrolovat fiskální rok v DATEV, kontaktujte někoho s právy správce.",
        "on_export_error_datev_has_protocol_entries": "Chyba při exportu faktury do DATEV. Zkontrolujte exportní protokol nebo kontaktujte podporu.",
        "on_export_error_invoice_not_active_for_fiscal_year": "Při přenosu do DATEV došlo k chybě. Fiskální rok DATEV není uvolněn pro přenos došlých faktur. Chcete-li zkontrolovat fiskální rok v DATEV, kontaktujte někoho s právy správce.",
        "on_export_error_running": "Export zablokován: Jiná instance již tento proces provádí.",
        "on_export_error_outgoing_invoice_not_supported": "Odchozí faktury nelze exportovat. Workflow končí ověřením.",
        "on_export_error_document_discount_tax_required": "Slevu dokladu nelze exportovat, protože chybí sazba DPH nebo neodpovídá žádné položce faktury. Vyberte sazbu DPH slevy.",
        "on_export_error_document_discount_exceeds_base": "Sleva dokladu je vyšší než čistý základ odpovídajících položek a nelze ji exportovat.",
        "on_export_error_document_discount_invalid": "Slevu dokladu nelze exportovat. Zkontrolujte částku, základ a sazbu DPH.",
        "insert_datev_protocol_note": "<b>Stav</b>: {status} <br><br> <b>Položky protokolu</b>: <br> {protocol}",
        "labels": {
            "ai_validation_trusted_label": "Faktura byla ověřena KI a je považována za důvěryhodnou.",
            "ai_validation_not_trusted_label": "Faktura byla ověřena KI a předána k manuální kontrole.",
            "ai_validation_trusted_score_only_label": "Faktura byla KI klasifikována jako důvěryhodná. {score_block}",
            "ai_validation_not_trusted_score_only_label": "Faktura byla předána k manuální kontrole. {score_block}",
            "ai_validation_not_trusted_insufficient_positive_label": "Faktura byla předána k manuální kontrole. {score_block} Pozitivní signály nestačily: {ai_validation_reason_value}.",
            "ai_validation_trusted_reasons_label": "Faktura byla KI klasifikována jako důvěryhodná. {score_block} Rozhodující byly také: {ai_validation_reason_value}.",
            "ai_validation_not_trusted_reasons_label": "Faktura byla předána k manuální kontrole. {score_block} Rozhodující byly: {ai_validation_reason_value}.",
            "ai_validation_score_block_risk_passed": "Z pozitivních a negativních signálů KI vypočítala celkové riziko {score} — to odpovídá {score_level} úrovni rizika. Pro automatické schválení musí být toto riziko pod {threshold}; tato hranice je splněna.",
            "ai_validation_score_block_risk_failed": "Z pozitivních a negativních signálů KI vypočítala celkové riziko {score} — to odpovídá {score_level} úrovni rizika. Pro automatické schválení musí být toto riziko pod {threshold}; tato hodnota je nad hranicí.",
            "ai_validation_score_block_confidence_passed": "Z ověřených signálů KI vypočítala hodnotu jistoty {score} — to odpovídá {score_level} úrovni. Pro automatické schválení musí být tato hodnota alespoň {threshold}; tato podmínka je splněna.",
            "ai_validation_score_block_confidence_failed": "Z ověřených signálů KI vypočítala hodnotu jistoty {score} — to odpovídá {score_level} úrovni. Pro automatické schválení musí být tato hodnota alespoň {threshold}; dosažená hodnota nestačí.",
            "ai_validation_score_block_green_sum_passed": "Z pozitivních signálů KI vypočítala součet {score} — to odpovídá {score_level} úrovni. Pro automatické schválení musí být tato hodnota alespoň {threshold}; tato podmínka je splněna.",
            "ai_validation_score_block_green_sum_failed": "Z pozitivních signálů KI vypočítala součet {score} — to odpovídá {score_level} úrovni. Pro automatické schválení musí být tato hodnota alespoň {threshold}; dosažená hodnota nestačí.",
            "ai_validation_score_level_risk_very_low": "velmi nízké",
            "ai_validation_score_level_risk_low": "nízké",
            "ai_validation_score_level_risk_acceptable": "přijatelné",
            "ai_validation_score_level_risk_elevated": "zvýšené",
            "ai_validation_score_level_risk_high": "vysoké",
            "ai_validation_score_level_confidence_very_low": "velmi nízké",
            "ai_validation_score_level_confidence_low": "nízké",
            "ai_validation_score_level_confidence_moderate": "střední",
            "ai_validation_score_level_confidence_high": "vysoké",
            "ai_validation_score_level_confidence_very_high": "velmi vysoké",
            "ai_validation_score_level_green_sum_very_low": "velmi nízké",
            "ai_validation_score_level_green_sum_low": "nízké",
            "ai_validation_score_level_green_sum_moderate": "střední",
            "ai_validation_score_level_green_sum_high": "vysoké",
            "ai_validation_score_level_green_sum_very_high": "velmi vysoké",
            "ai_validation_risk_compensated_label": "Zjištěná rizika ({ai_validation_secondary_reason_value}) byla vyvážena pozitivními signály.",
            "ai_validation_positive_signals_label": "Pozitivní signály ({ai_validation_secondary_reason_value}) nestačily k vyvážení rizik.",
            "ai_validation_reason_and": "a",
            "ai_validation_reason_GREEN_01": "povinná pole jsou kompletní",
            "ai_validation_reason_GREEN_02": "faktura odpovídá dosavadnímu vzoru tohoto dodavatele",
            "ai_validation_reason_GREEN_03": "e-mail odesílatele je známý a odpovídá kmenovým údajům",
            "ai_validation_reason_GREEN_04": "částky působí vůči plnění věrohodně",
            "ai_validation_reason_GREEN_05": "období plnění je jasné a bez překrytí",
            "ai_validation_reason_GREEN_06": "bankovní údaje odpovídají uloženým kmenovým údajům",
            "ai_validation_reason_RED_01": "e-mail odesílatele se liší od známých adres",
            "ai_validation_reason_RED_02": "období plnění se překrývá s existujícími fakturami",
            "ai_validation_reason_RED_03": "částka nebo inherentní riziko je neobvykle vysoké",
            "ai_validation_reason_RED_04": "částka oproti dřívějším fakturám výrazně vzrostla",
            "ai_validation_reason_RED_05": "objednávka/smlouva chybí nebo se výrazně odchyluje",
            "ai_validation_reason_RED_06": "bankovní údaje se liší od kmenových údajů",
            "ai_validation_failed": "Faktura nebyla ověřena.",
            "ai_validation_duplicate_invoice_label": "Validace AI nepokračovala, protože byla nalezena duplicitní faktura. Faktura byla předána k ruční kontrole.",
            "ai_validation_mandatory_fields_missing_label": "Validace AI selhala: Chybí následující povinná pole",
            "ai_validation_client_address_mismatch_label": "Validace AI nepokračovala, protože rozpoznaná fakturační adresa se liší od firemních kmenových dat. Faktura byla předána k ruční kontrole.",
            "ai_validation_client_address_unrecognized_label": "Validace AI nepokračovala, protože na faktuře nebyla nalezena dostatečně rozpoznatelná fakturační adresa. Faktura byla předána k ruční kontrole.",
            "magic_suggestions_label": "Automaticky vyplněná pole",
            "magic_suggestions_intro_label": "Zde jsou pole, která byla automaticky vyplněna na základě předchozích dokladů od tohoto dodavatele:",
            "ledger_account_label": "Účet hlavní knihy",
            "cost_center_label": "Nákladové středisko",
            "department_label": "Oddělení",
            "cost_type_label": "Typ nákladů",
            "incoming_revenue_type_label": "Typ příjmu",
            "posting_key_label": "Klíč účtování",
            "tax_group_label": "Skupina DPH",
            "tax_item_group_label": "Skupina DPH položky",
            "d365_branch_label": "Pobočka",
            "d365_employee_label": "Zaměstnanec",
            "d365_department_label": "D365 Oddělení",
            "d365_area_label": "D365 Oblast",
            "d365_sales_channel_label": "D365 Prodejní kanál",
            "d365_vehicle_label": "Vozidlo",
            "d365_project_label": "D365 Projekt",
            "supplier_iban_label": "IBAN",
            "supplier_bic_label": "BIC",
            "supplier_bank_country_label": "Země banky",
            "supplier_bank_account_label": "Číslo účtu",
            "supplier_bank_code_label": "Bankovní kód",
            "supplier_payment_method_label": "Způsob platby",
            "invoice_number_label": "Číslo faktury",
            "duplicate_invoice_reference_label": "Duplicitní faktura",
            "procurement_number_label": "Číslo objednávky",
            "invoice_date_label": "Datum faktury",
            "invoice_due_date_label": "Datum splatnosti",
            "supplier_label": "Dodavatel",
            "client_label": "Společnost",
            "business_partner_label": "Obchodní partner",
            "total_netto_label": "Celkem netto",
            "total_brutto_label": "Celkem brutto",
            "tax_label": "Sazba daně",
            "positions_count_label": "pozice",
            "recognition_applied_data_label": "Převzato nebo odvozeno systémem liftbase",
            "contract_recognition_result_label": "Rozpoznaná data smlouvy",
            "contract_name_label": "Název smlouvy",
            "contract_number_label": "Číslo smlouvy",
            "contract_external_number_label": "Externí číslo smlouvy",
            "contract_date_label": "Datum smlouvy",
            "contract_supplier_label": "Dodavatel",
            "contract_client_label": "Společnost",
            "contract_category_label": "Kategorie",
            "contract_payment_method_label": "Způsob platby",
            "contract_payment_direction_label": "Směr",
            "contract_payment_timing_label": "Načasování platby",
            "contract_term_type_label": "Typ doby trvání",
            "contract_start_date_label": "Začátek smlouvy",
            "contract_end_date_label": "Konec smlouvy",
            "contract_duration_label": "Doba trvání smlouvy",
            "contract_renewal_type_label": "Typ prodloužení",
            "contract_renewal_duration_label": "Doba prodloužení",
            "contract_notice_period_label": "Výpovědní lhůta",
            "contract_termination_to_label": "Datum ukončení",
            "contract_total_net_label": "Celkem netto",
            "contract_total_gross_label": "Celkem brutto",
            "contract_currency_label": "Měna",
            "contract_positions_label": "Položky",
            "origin_field_client_id": "Společnost",
            "origin_field_supplier_id": "Dodavatel",
            "origin_field_business_partner_id": "Obchodní partner",
            "origin_field_procurement_id": "Objednávka",
            "origin_field_ledger_account_id": "Účet hlavní knihy",
            "origin_field_cost_center_id": "Nákladové středisko",
            "origin_field_profit_center_id": "Profit centrum",
            "origin_field_department_id": "Oddělení",
            "origin_field_posting_key_id": "Účtovací klíč",
            "origin_field_branch_id": "Pobočka",
            "origin_field_employee_id": "Zaměstnanec",
            "origin_field_d365_area_id": "Oblast",
            "origin_field_d365_department_id": "D365 oddělení",
            "origin_field_d365_labor_wert_id": "Pracovní hodnota",
            "origin_field_d365_project_id": "Projekt",
            "origin_field_d365_sales_channel_id": "Prodejní kanál",
            "origin_field_d365_vehicle_id": "Vozidlo",
            "origin_field_number": "Číslo faktury",
            "origin_field_total_netto": "Celkem netto",
            "origin_field_total_brutto": "Celkem brutto",
            "origin_field_invoice_date": "Datum faktury",
            "origin_field_due_date": "Datum splatnosti",
            "origin_field_delivery_date": "Datum dodání",
            "origin_field_currency": "Měna",
            "origin_field_tax": "Sazba daně",
            "origin_field_contract_id": "Smlouva",
            "origin_field_cost_type_id": "Druh nákladu",
            "origin_field_incoming_revenue_type_id": "Druh výnosu",
            "origin_field_discount_percentage": "Skonto 1 %",
            "origin_field_discount_amount": "Skonto 1 částka",
            "origin_field_discount_days": "Skonto 1 dny",
            "origin_field_discount_payment_date": "Skonto 1 datum",
            "origin_field_discount_percentage2": "Skonto 2 %",
            "origin_field_discount_amount2": "Skonto 2 částka",
            "origin_field_discount_days2": "Skonto 2 dny",
            "origin_field_discount_payment_date2": "Skonto 2 datum",
            "origin_field_lines": "Položky",
            "origin_field_recognized_client_id": "Rozpoznaná společnost",
            "origin_field_recognized_supplier_id": "Rozpoznaný dodavatel",
            "origin_field_recognized_business_partner_id": "Rozpoznaný obchodní partner",
            "origin_field_supplier_iban": "IBAN dodavatele",
            "origin_field_supplier_bic": "BIC dodavatele",
            "origin_field_payment_bank_form_source": "Zdroj bankovních údajů",
            "origin_reason_document_extracted": "extrahováno přímo z dokladu",
            "origin_reason_from_procurement": "převzato z přiřazené objednávky",
            "origin_reason_from_supplier_master_data": "převzato z kmenových dat dodavatele",
            "origin_reason_from_business_partner_master_data": "převzato z kmenových dat obchodního partnera",
            "origin_reason_invoice_number_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_total_netto_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_total_brutto_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_invoice_date_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_due_date_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_delivery_date_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_document_discount_amount_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_document_discount_base_amount_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_document_discount_percentage_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_document_discount_tax_percentage_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_client_matched_by_receiver_name_or_vat": "přiřazeno podle rozpoznaného názvu příjemce nebo DIČ",
            "origin_reason_client_matched_by_supplier_name_or_vat": "přiřazeno podle rozpoznaného názvu vystavitele nebo DIČ",
            "origin_reason_client_from_creator_profile": "převzato z profilu nahrávajícího",
            "origin_reason_client_from_procurement": "převzato z přiřazené objednávky",
            "origin_reason_supplier_matched_by_name_vat_or_iban": "přiřazeno podle rozpoznaného názvu dodavatele, DIČ nebo IBAN",
            "origin_reason_business_partner_matched_by_name_vat_or_iban": "přiřazeno podle rozpoznaného názvu protistrany, DIČ nebo IBAN",
            "origin_reason_business_partner_matched_by_receiver_name_or_vat": "přiřazeno podle rozpoznaného názvu příjemce nebo DIČ",
            "origin_reason_supplier_from_single_procurement_supplier": "převzato z jediného dodavatele přiřazené objednávky",
            "origin_reason_procurement_matched_by_recognized_reference": "přiřazeno podle rozpoznané reference objednávky",
            "origin_reason_procurement_matched_by_invoice_similarity": "přiřazeno podle podobnosti částky, data a položek",
            "origin_reason_procurement_matched_by_invoice_similarity_without_supplier": "přiřazeno podle podobnosti částky, data a položek před výběrem dodavatele",
            "origin_reason_ledger_account_from_procurement": "převzato z přiřazené objednávky",
            "origin_reason_cost_center_from_procurement": "převzato z přiřazené objednávky",
            "origin_reason_cost_type_from_procurement": "převzato z přiřazené objednávky",
            "origin_reason_profit_center_from_supplier_master_data": "převzato z kmenových dat dodavatele",
            "origin_reason_profit_center_from_business_partner_master_data": "převzato z kmenových dat obchodního partnera",
            "origin_reason_department_from_procurement": "převzato z přiřazené objednávky",
            "origin_reason_branch_from_procurement": "převzato z přiřazené objednávky",
            "origin_reason_employee_from_procurement": "převzato z přiřazené objednávky",
            "origin_reason_financial_dimension_from_procurement": "převzato z přiřazené objednávky",
            "origin_reason_ledger_account_from_supplier_master_data": "převzato z kmenových dat dodavatele",
            "origin_reason_cost_center_from_supplier_master_data": "převzato z kmenových dat dodavatele",
            "origin_reason_ledger_account_from_business_partner_master_data": "převzato z kmenových dat obchodního partnera",
            "origin_reason_cost_center_from_business_partner_master_data": "převzato z kmenových dat obchodního partnera",
            "origin_reason_posting_key_from_recognized_tax": "odvozeno z rozpoznané daňové sazby",
            "origin_reason_supplier_iban_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_supplier_bic_extracted_from_document": "extrahováno přímo z dokladu",
            "origin_reason_payment_bank_data_extracted_from_document": "nastaveno podle rozpoznaných bankovních údajů z dokladu",
            "no_data_read_label": "Nebyla rozpoznána žádná data.",
            "supplier_external_id_export_validation": "Externí ID dodavatele musí být uvedeno v oblasti administrace.",
            "supplier_name_export_validation": "Jméno dodavatele musí být uvedeno v oblasti administrace.",
            "recognition_was_repeated": "{user_name} zopakoval(a) rozpoznání dokumentu.",
            "bankdata_recognized_label": "Bankovní spojení rozpoznáno z dokladu",
            "bankdata_form_source_label": "Bankovní spojení ve formuláři – zdroj",
            "bankdata_form_changed_label": "Bankovní spojení ve formuláři – změněno",
            "bankdata_matches_masterdata_label": "Bankovní spojení ve formuláři odpovídá kmenovým údajům",
            "bankdata_written_back_label": "Nové bankovní spojení zapsáno do kmenových údajů",
            "bank_statement_auto_paid_label": "Faktura byla automaticky označena jako zaplacená na základě analýzy bankovního výpisu.",
            "payment_date_label": "Datum platby",
            "payment_amount_label": "Částka",
            "bank_statement_document_label": "Bankovní výpis",
            "bank_statement_reference_label": "Účel platby",
            "bank_statement_match_reason_label": "Důvod přiřazení",
            "bank_statement_match_reason_payment_reference": "Platební reference",
            "bank_statement_match_reason_invoice_number": "Číslo faktury",
            "bank_statement_match_reason_invoice_number_formatted": "Interní číslo faktury",
            "bank_statement_match_reason_procurement_number": "Číslo objednávky",
            "bank_statement_match_reason_supplier_iban": "IBAN dodavatele",
            "bank_statement_match_reason_supplier_name": "Dodavatel",
            "contract_id": "Smlouva",
            "termination_deadline": "Termín výpovědi",
            "recipient": "Příjemce",
            "error": "Chyba"
        }
    }
    ,
    "login": {
        "email": {
            "title": "Prihlaseni",
            "instructions": "Zadejte svou e-mailovou adresu pro prihlaseni.",
            "punchin_instructions": "Pro dokončení procesu je třeba se přihlásit a zahájit proces schvalování objednávky.",
            "tenant": "Nájemce",
            "place_holder": "Emailová adresa",
            "last_used_emails": "Nedávno použité e-mailové adresy",
            "delete_last_used_emails": "Smazat \"Nedávno použité\"",
            "has_no_account": "Ještě nemáte účet?",
            "login_link_via_email": "Obdržet přihlašovací odkaz e-mail",
            "finish_login_title": "Dokončete přihlášení",
            "finish_login_instructions": "Nyní obdržíte e-mail s přihlašovacím odkazem a kódem. Přihlášení dokončíte kliknutím na odkaz nebo zadáním šestimístného kódu. <br><br>Přihlašovací e-mail byl odeslán na adresu <br><b>{email}</b><br> a měl by brzy dorazit. V případě potřeby zkontrolujte složku se spamem.",
            "code_instructions": "Případně zadejte šestimístný kód z e-mailu:",
            "code_label": "Přihlašovací kód",
            "code_digit_label": "Znak {index} kódu",
            "code_invalid": "Kód je nesprávný, vypršel nebo již byl použit. Vyžádejte si nový přihlašovací e-mail.",
            "resend_code": "Odeslat nový přihlašovací e-mail",
            "forgot_passwort": {
                "title": "zapomenuté heslo",
                "login_via_email": "Prihlaseni bez hesla",
                "instructions": "liftbase nepouziva hesla. Pokracujte pres SSO nebo prihlasovaci odkaz e-mailem, nebo pouzijte samostatne tlacitko passkey."
            }
            ,
            "no_email": "Žádný e-mail",
            "no_email_validation": "Pro přihlášení zadejte svou e-mailovou adresu.",
            "check_email_title": "Zkontrolovat email",
            "check_email_message": "Zkontrolujte si nyní svou e-mailovou schránku a klikněte na přihlašovací odkaz nebo zadejte kód."
        }
        ,
        "integration": {
            "title": "Propojovani integrace",
            "instructions": "liftbase dokončuje autorizaci. Za chvíli budete přesměrováni.",
            "retry": "Připojení se nepodařilo pokračovat. Zkuste to znovu.",
            "retry_button": "Připojit znovu"
        }
        ,
        "auto": {
            "login": "Prihlasit se",
            "passkey_retry": "Prihlaseni pomoci passkey se nezdarilo. Muzete znovu pouzit tlacitko passkey nebo pokracovat pres SSO nebo e-mail.",
            "status": {
                "discover": "Kontroluji dostupne metody prihlaseni...",
                "passkey": "Pokousim se o prihlaseni pomoci passkey...",
                "saml": "Pokousim se o prihlaseni pres {provider}...",
                "email": "Odesílám přihlašovací odkaz a kód e-mailem...",
                "code": "Ověřuji přihlašovací kód..."
            }
        }
        ,
        "or": "nebo",
        "saml": {
            "login": "Pokračovat přes {provider}",
            "error": "SSO přihlášení se nezdařilo. Zkuste to prosím znovu.",
            "error_expired": "Relace SSO vypršela. Spusťte přihlášení znovu.",
            "error_mismatch": "SSO účet neodpovídá zadanému e-mailu."
        }
        ,
        "passkey": {
            "title": "Přihlaste se pomocí Passkey",
            "login": "Přihlaste se pomocí přístupového klíče",
            "what_is": {
                "title": "Co jsou přístupové klíče?",
                "first": "Přihlaste se bez čekání na e-mail",
                "second": "Pomocí otisku prstu, obličeje nebo kódu PIN",
                "third": "Nastavte nyní v několika krocích ve svém profilu"
            }
            ,
            "error": "Prihlaseni pomoci passkey se nezdarilo. Zkuste znovu tlacitko passkey nebo pokracujte pres SSO nebo e-mail."
        }
    }
    ,
    "languages": {
        "de": "Němec",
        "en": "Angličtina",
        "it": "italština",
        "cz": "čeština",
        "sk": "Slovák"
    }
    ,
    "translation-component": {
        "repeated": "Nemůžete vybrat stejný jazyk vícekrát.",
        "language_empty": "Musíte vybrat jazyk.",
        "translation_empty": "Musíte zadat text pro tuto vybranou jazykovou verzi.",
        "both_empty": "Musíte zadat jak jazyk, tak text.",
        "language": "Jazyk",
        "no_translation": "Pro tento jazyk není registrován žádný text.",
        "at_least_one_required": "Musíte uvést minimálně jedno jméno.",
        "text_without_translation": "Bez překladu"
    }
    ,
    "mailbox": {
        "invoice_lines_group_by_tax": "Seskupit položky podle sazby DPH",
        "invoice_lines_group_by_tax_hint": "Je-li zapnuto, rozpoznané položky se seskupí podle sazby DPH (např.: Součet 19 % DPH).",
        "ai_validation_mode": "Validace KI",
        "ai_validation_mode_none": "Bez validace KI",
        "ai_skip_to_ready_for_export": "Aktivovat a přesunout do stavu „Připraveno k exportu“",
        "ai_skip_to_ready_for_export_hint": "Pokud je tato funkce aktivována, bude faktura po rozpoznání umělou inteligencí přesunuta přímo do stavu „Připraveno k exportu“, pokud nejsou vyžadovány žádné kroky ke schválení.",
        "ai_validation_advisory": "Aktivovat a ponechat stav beze změny",
        "ai_validation_advisory_hint": "Pokud je aktivováno, importované faktury ověří KI, výsledek se zapíše do časové osy a zobrazí se detaily skóre bez přeskočení běžného workflow.",
        "description": "Poštovní schránka",
        "description_plural": "Poštovní schránky",
        "name": "Jméno",
        "username": "Uživatelské jméno",
        "password": "Heslo",
        "host": "Hostitel",
        "port": "Port",
        "smtp_host": "SMTP host",
        "smtp_port": "SMTP port",
        "smtp_username": "SMTP e-mail / uživatelské jméno",
        "smtp_password": "SMTP heslo",
        "tab_general": "Obecné",
        "tab_import": "Import faktur",
        "tab_supplier_communication": "Komunikace s dodavatelem",
        "tab_historical_import": "Historické e-maily",
        "section_identity": "Schránka a protokol",
        "section_assignment": "Přiřazení",
        "section_incoming": "Přístup ke schránce",
        "section_processing": "Zpracování",
        "section_outgoing": "Odesílání",
        "section_historical_import": "Import historických e-mailů",
        "protocol": "Protokol",
        "ms365": "Microsoft 365",
        "ms365_type": "Typ Microsoft 365",
        "ms365_enterprise_app": "MS365 Enterprise App",
        "app_tenant_id": "Tenant ID",
        "app_client_id": "Client ID",
        "client_secret": "Client Secret",
        "folder": "Složka",
        "mailbox": "Poštovní schránka",
        "period_in_days": "Období ve dnech",
        "period_in_days_column": "Období (dny)",
        "period_in_days_tooltip": "Stáří e-mailů ve dnech",
        "remove_mailbox_msg": "Opravdu chcete odstranit tuto poštovní schránku?",
        "remove_mailbox_btn": "Odstranit",
        "import_invoices_automatically": "Import faktur je aktivní",
        "use_for_supplier_communication": "Komunikace s dodavatelem aktivní",
        "use_for_supplier_communication_hint": "Pokud je zapnuto, tato schránka se použije pro zpracování odpovědí z komunikace s dodavateli.",
        "supplier_communication_bcase_types": "Typy dokumentů pro komunikaci s dodavatelem",
        "supplier_communication_bcase_types_hint": "Vyberte typy dokumentů, pro které lze tuto schránku použít v komunikaci s dodavatelem.",
        "supplier_communication_bcase_types_placeholder": "Vyberte jeden nebo více typů dokumentů",
        "import_mode": "Režim importu",
        "import_mode_per_attachment": "Vytvořit jednu fakturu na každou přílohu e-mailu",
        "import_mode_ai_classified_per_attachment": "Importovat pouze přílohy klasifikované AI jako faktury",
        "import_mode_per_email": "Vytvořit jednu fakturu na každý e-mail",
        "last_import_errors": "Poslední chyby importu",
        "show_import_errors": "Zobrazit {count} chyb",
        "no_import_errors": "Žádné chyby importu",
        "check_connection_btn": "Zkontrolujte připojení",
        "connectivity_success_msg": "Připojení bylo úspěšně navázáno.",
        "connectivity_error_msg": "Spojení se nepodařilo navázat. Zkontrolujte prosím své přihlašovací údaje.",
        "connectivity_graph_client_secret_read_access_denied_msg": "Microsoft Graph odmítl přístup k této poštovní schránce.<br><br>Zkontrolujte prosím v Azure, zda:<ul style='margin:8px 0;padding-left:20px;text-align:left'><li>má Enterprise App potřebná Application Permissions:<br><b>Mail.Read</b>, <b>Mail.ReadBasic.All</b>, <b>Mail.ReadWrite</b></li><li>byl udělen Admin Consent</li><li>má aplikace povolený přístup k této schránce</li></ul>",
        "connectivity_graph_client_secret_access_denied_msg": "Microsoft Graph odmítl přístup k této poštovní schránce.<br><br>Zkontrolujte prosím v Azure, zda:<ul style='margin:8px 0;padding-left:20px;text-align:left'><li>má Enterprise App potřebná Application Permissions:<br><b>Mail.Read</b>, <b>Mail.ReadBasic.All</b>, <b>Mail.ReadWrite</b>, <b>Mail.Send</b></li><li>byl udělen Admin Consent</li><li>má aplikace povolený přístup k této schránce</li></ul>",
        "connectivity_graph_access_denied_msg": "Microsoft Graph odmítl přístup k této poštovní schránce. Připojte prosím schránku znovu a zkontrolujte, zda má uživatel k této schránce přístup.",
        "save_and_connect_btn": "Uložit a připojit",
        "disconnect_btn": "Odpojit",
        "disconnect_success_msg": "Připojení bylo úspěšně odpojeno.",
        "historical_import_info_title": "Import historické komunikace s dodavateli",
        "historical_import_info": "Importujte e-maily jako historii komunikace. Stávající import faktur zůstává oddělený.",
        "historical_import_period": "Období",
        "historical_import_range_separator": "až",
        "historical_import_start": "Počáteční datum",
        "historical_import_end": "Koncové datum",
        "historical_import_invoice_warning_title": "Faktury nebudou vytvořeny",
        "historical_import_invoice_warning": "Historické e-maily se uloží jako komunikace. Přílohy neprojdou rozpoznáním faktur.",
        "historical_import_long_period_confirm": "Vybrali jste {days} dní. Import dlouhého období může chvíli trvat a vytvořit mnoho komunikací. Chcete pokračovat?",
        "historical_import_long_period_title": "Potvrdit dlouhé období",
        "historical_import_include_attachments": "Importovat přílohy komunikace",
        "historical_import_attachment_limit": "Maximální velikost přílohy (MB)",
        "historical_import_attachment_skipped": "Přílohy přeskočené kvůli limitu velikosti: {count}",
        "historical_import_preview_btn": "Náhled importu",
        "historical_import_preview_title": "Náhled importu",
        "historical_import_preview_processing_title": "Připravuje se náhled importu",
        "historical_import_preview_processing_description": "Probíhá kontrola e-mailů a přiřazení dodavatelů. U velkých schránek to může trvat několik minut.",
        "historical_import_preview_processing_elapsed": "Probíhá {seconds} s",
        "historical_import_authentication_error_title": "Přihlášení k poskytovateli e-mailu se nezdařilo",
        "historical_import_authentication_error_description": "Poskytovatel e-mailu odmítl přihlášení k této schránce. Zkontrolujte přihlašovací údaje. Účty Google s dvoufázovým ověřením vyžadují heslo pro aplikaci.",
        "historical_import_edit_connection_btn": "Upravit údaje schránky",
        "historical_import_edit_connection_title": "Zkontrolovat připojení schránky",
        "historical_import_edit_connection_description": "Opravte údaje připojení a znovu je otestujte. Heslo se z bezpečnostních důvodů nezobrazuje.",
        "historical_import_password_placeholder": "Ponechte prázdné pro zachování stávající hodnoty",
        "historical_import_save_connection_to_master_data": "Uložit změny do kmenových dat",
        "historical_import_test_and_retry_btn": "Otestovat a zkusit znovu",
        "historical_import_connection_settings_error": "Údaje schránky se nepodařilo načíst.",
        "historical_import_connection_test_failed": "Připojení se nepodařilo navázat. Zkontrolujte údaje.",
        "historical_import_folder_error_title": "Nakonfigurovaná e-mailová složka nebyla nalezena",
        "historical_import_folder_error_description": "Složka nakonfigurovaná pro tuto schránku není u poskytovatele e-mailu dostupná. Zkontrolujte název složky v konfiguraci schránky.",
        "historical_import_client_missing_error_title": "Nejprve přiřaďte k této poštovní schránce společnost",
        "historical_import_client_missing_error_description": "Onboarding faktur potřebuje společnost poštovní schránky, aby bylo možné importované faktury správně přiřadit.",
        "historical_import_client_required_error_title": "Vyberte společnost pro tento import",
        "historical_import_client_required_error_description": "Tato schránka není přiřazena ke společnosti. Před spuštěním náhledu nebo importu vyberte společnost.",
        "historical_import_client_invalid_error_title": "Společnost nelze použít",
        "historical_import_client_invalid_error_description": "Vybraná společnost není dostupná. Vyberte platnou společnost.",
        "historical_invoice_onboarding_client_missing_title": "Tato schránka nemá přiřazenou společnost",
        "historical_invoice_onboarding_client_missing_description": "Můžete vybrat pevnou společnost nebo nechat rozpoznání určit společnost pro každou fakturu.",
        "historical_invoice_onboarding_client_selection_title": "Společnost pro import",
        "historical_invoice_onboarding_client_selection_description": "Vyberte, ke které společnosti se mají importované faktury přiřadit.",
        "historical_invoice_onboarding_settings_title": "Nastavení importu",
        "historical_invoice_onboarding_settings_description": "Vyberte období a maximální velikost příloh.",
        "historical_invoice_onboarding_full_recognition": "Ověřit vhodné přílohy pomocí AI a plně rozpoznat faktury",
        "historical_invoice_onboarding_full_recognition_cost_title": "Úplné rozpoznání faktur vytváří náklady",
        "historical_invoice_onboarding_full_recognition_cost_description": "Vhodné přílohy jsou nejprve ověřeny pomocí AI. Plně se zpracují jen dokumenty rozpoznané jako faktury; za dokumenty ověřené AI vznikají náklady.",
        "historical_invoice_onboarding_full_recognition_gift_title": "Úplné rozpoznání faktur jako uvítací dárek",
        "historical_invoice_onboarding_full_recognition_gift_description": "Vhodné přílohy jsou ověřeny pomocí AI a úplně rozpoznány. Pro začátek se zpracuje nejvýše 30 faktur.",
        "historical_invoice_onboarding_economic_recognition_title": "Úsporné rozpoznání kmenových dat",
        "historical_invoice_onboarding_economic_recognition_alert_title": "Vytvářejte kmenová data s nižšími náklady",
        "historical_invoice_onboarding_economic_recognition_description": "Každá příloha faktury je vyhodnocena lokálně pro vytvoření nebo přiřazení kmenových dat společnosti a dodavatele. Nevznikají žádné náklady na AI.",
        "historical_invoice_onboarding_preview_recognition_documents": "Odhad kontrol pomocí AI: {count}",
        "historical_invoice_onboarding_preview_recognition_unit_price": "Aktuální fakturační cena: {price} za úspěšně rozpoznanou fakturu",
        "historical_invoice_onboarding_preview_recognition_cost": "Odhadované náklady: {cost}",
        "historical_invoice_onboarding_preview_recognition_cost_with_margin": "Bezpečný odhad s rezervou {margin}%: až {cost} (rezerva se neúčtuje)",
        "historical_invoice_onboarding_recognition_cost_confirm_title": "Spustit placené rozpoznání faktur?",
        "historical_invoice_onboarding_recognition_cost_confirm": "Za vybrané období bylo nalezeno <strong>{emails}</strong> e-mailů, které se ještě kontrolují pro import. Z toho může být přibližně <strong>{invoices}</strong> faktur určených k rozpoznání pomocí AI. Celkový odhad je až <strong>{cost}</strong>. Odhad obsahuje bezpečnostní rezervu <strong>{margin}%</strong>; účtuje se pouze skutečná aktuální fakturační cena. Chcete pokračovat?",
        "historical_invoice_onboarding_analysis_limited_with_recognition": "Analýza a odhad nákladů vycházejí z prvních {count} e-mailů. Konečný počet se může lišit.",
        "historical_invoice_onboarding_recognition_requested": "Dokumenty odeslané k rozpoznání: {count}",
        "historical_invoice_onboarding_recognition_skipped": "Dokumenty lokálně vyhodnocené pro kmenová data: {count}",
        "historical_invoice_onboarding_clients_created": "Vytvořené společnosti: {count}",
        "historical_invoice_onboarding_clients_matched": "Přiřazené společnosti: {count}",
        "historical_invoice_onboarding_suppliers_created": "Vytvoření dodavatelé: {count}",
        "historical_invoice_onboarding_suppliers_matched": "Přiřazení dodavatelé: {count}",
        "historical_invoice_onboarding_master_data_conflicts": "Konflikty kmenových dat: {count}",
        "historical_invoice_onboarding_master_data_review_title": "Některá kmenová data vyžadují kontrolu",
        "historical_invoice_onboarding_master_data_review_description": "{pending} faktur vyžaduje přiřazení. Zkontrolujte níže uvedené faktury a zadejte název společnosti nebo dodavatele, pokud nebyla nalezena odpovídající položka.",
        "historical_invoice_onboarding_master_data_conflicts_title": "Konflikty kmenových dat vyžadují kontrolu: {count}",
        "historical_invoice_onboarding_master_data_conflicts_description": "Otevřete importované faktury a zkontrolujte přiřazení. Po kontrole můžete tuto zprávu potvrdit.",
        "historical_invoice_onboarding_master_data_conflicts_reviewed_btn": "Označit konflikty jako zkontrolované",
        "historical_invoice_onboarding_master_data_conflicts_reviewed_success": "Konflikty kmenových dat byly označeny jako zkontrolované.",
        "historical_invoice_onboarding_master_data_conflicts_reviewed_error": "Konflikty kmenových dat se nepodařilo potvrdit.",
        "historical_invoice_onboarding_master_data_review_btn": "Zkontrolovat kmenová data",
        "historical_invoice_onboarding_master_data_review_card_title": "Otevřená přiřazení kmenových dat",
        "historical_invoice_onboarding_master_data_review_card_description": "Společnost nebo dodavatel nebyli u těchto faktur automaticky přiřazeni. Název můžete zadat přímo zde.",
        "historical_invoice_onboarding_recognition_mode": "Režim rozpoznání",
        "historical_invoice_onboarding_recognition_mode_economic": "Úsporné rozpoznání kmenových dat",
        "historical_invoice_onboarding_recognition_mode_full": "Úplné rozpoznání faktur",
        "historical_invoice_onboarding_item_recognition": "Rozpoznání",
        "historical_invoice_onboarding_item_result": "Výsledek",
        "historical_invoice_onboarding_item_show_result": "Zobrazit výsledek",
        "historical_invoice_onboarding_item_result_dialog_title": "Výsledek rozpoznání faktury",
        "historical_invoice_onboarding_item_invoice_fallback": "Faktura #{id}",
        "historical_invoice_onboarding_item_open_invoice": "Otevřít fakturu",
        "historical_invoice_onboarding_item_client": "Společnost",
        "historical_invoice_onboarding_item_supplier": "Dodavatel",
        "historical_invoice_onboarding_item_not_assigned": "Nepřiřazeno",
        "historical_invoice_onboarding_item_invoice": "Faktura",
        "historical_invoice_onboarding_manual_client_btn": "Vytvořit společnost",
        "historical_invoice_onboarding_manual_supplier_btn": "Vytvořit dodavatele",
        "historical_invoice_onboarding_manual_name_title": "Ruční vytvoření kmenových dat",
        "historical_invoice_onboarding_manual_name_title_client": "Vytvořit novou společnost",
        "historical_invoice_onboarding_manual_name_title_supplier": "Vytvořit nového dodavatele",
        "historical_invoice_onboarding_manual_name_description": "Nebyla nalezena jednoznačná položka. Zadejte název pro {type} a uložte jej, aby bylo možné fakturu přiřadit.",
        "historical_invoice_onboarding_manual_name_invoice_context_title": "Rozpoznané údaje faktury",
        "historical_invoice_onboarding_manual_name_apply_title": "Použít pro další otevřené faktury ({count})",
        "historical_invoice_onboarding_manual_name_apply_all_btn": "Vybrat všechny faktury",
        "historical_invoice_onboarding_manual_name_apply_description": "Následující otevřené faktury ještě nemají přiřazení pro tento typ kmenových dat. Zkontrolujte výběr a přiřaďte nový záznam pouze k odpovídajícím fakturám.",
        "historical_invoice_onboarding_manual_name_label": "Název",
        "historical_invoice_onboarding_manual_name_placeholder": "Zadejte název",
        "historical_invoice_onboarding_manual_name_save": "Uložit a přiřadit",
        "historical_invoice_onboarding_manual_name_save_bulk": "Uložit a přiřadit k {count} fakturám",
        "historical_invoice_onboarding_manual_name_success": "Kmenová data byla vytvořena a přiřazena k faktuře.",
        "historical_invoice_onboarding_manual_name_bulk_success": "Kmenová data byla vytvořena a přiřazena k {count} fakturám.",
        "historical_invoice_onboarding_manual_name_partial_success": "Kmenová data byla vytvořena a přiřazena k {assigned} z {requested} faktur. {skipped} faktur bylo přeskočeno, protože již byly přiřazeny.",
        "historical_invoice_onboarding_manual_name_no_assignment": "Nebyla přiřazena žádná faktura. Vybrané faktury již byly přiřazeny.",
        "historical_invoice_onboarding_manual_name_error": "Kmenová data se nepodařilo uložit.",
        "historical_import_error": "Chyba",
        "historical_invoice_onboarding_target_client": "Společnost pro import",
        "historical_invoice_onboarding_mailbox_client_question": "Tato schránka je přiřazena ke společnosti „{client}“. Použít ji pro import?",
        "historical_invoice_onboarding_mailbox_client_question_prefix": "Tato schránka je přiřazena ke společnosti",
        "historical_invoice_onboarding_mailbox_client_question_client": "„{client}“",
        "historical_invoice_onboarding_mailbox_client_question_suffix": "Použít ji pro import?",
        "historical_invoice_onboarding_use_mailbox_client": "Ano, použít tuto společnost",
        "historical_invoice_onboarding_choose_other_client": "Ne, vybrat jinou společnost",
        "historical_invoice_onboarding_use_recognition": "Určit společnost z faktury",
        "historical_invoice_onboarding_recognition_title": "Společnost bude určena automaticky",
        "historical_invoice_onboarding_recognition_description": "Rozpoznání faktury použije název příjemce a DIČ. Faktury bez jednoznačné shody zůstanou k ruční kontrole.",
        "historical_invoice_onboarding_preview_recognition": "Společnost: určena rozpoznáním faktury",
        "historical_invoice_onboarding_preview_client": "Cílová společnost: {client}",
        "historical_import_inactive_error_title": "Poštovní schránka je deaktivována",
        "historical_import_inactive_error_description": "Před spuštěním historického importu faktur aktivujte tuto schránku v její konfiguraci.",
        "historical_import_historical_invoice_onboarding_failed_error_title": "Historický import faktur se nezdařil",
        "historical_import_historical_invoice_onboarding_failed_error_description": "Import se nepodařilo dokončit. Zkontrolujte konfiguraci schránky a zkuste to znovu.",
        "historical_import_preview_total": "Nalezené e-maily: {count}",
        "historical_import_preview_limited": "Náhled je omezen na prvních {count} e-mailů.",
        "historical_import_preview_ambiguous": "Nejednoznační dodavatelé: {count}",
        "historical_import_preview_unassigned": "Bez dodavatele: {count}",
        "historical_import_previously_processed": "Již zpracováno a vyřazeno: {count}",
        "historical_import_preview_no_eligible": "Všechny e-maily ve vybraném období již byly zpracovány a vyřazeny.",
        "historical_import_incremental_btn": "Importovat nové e-maily",
        "historical_import_continue_background_btn": "Pokračovat na pozadí",
        "historical_import_cancel_btn": "Zrušit import",
        "import_close_confirm_title": "Import stále probíhá",
        "import_close_confirm_message": "Import ještě není dokončen. Chcete toto okno zavřít? Import můžete nechat pokračovat na pozadí nebo ho zrušit.",
        "import_close_confirm_stay_btn": "Zůstat v okně",
        "historical_import_retry_btn": "Pokračovat v importu",
        "historical_import_retry_failed_btn": "Zopakovat neúspěšné části",
        "historical_invoice_onboarding_finished_btn": "Hotovo",
        "historical_invoice_onboarding_close_btn": "Zavřít",
        "historical_import_match_status": "Přiřazení dodavatele",
        "historical_import_match_matched": "Přiřazeno",
        "historical_import_match_ambiguous": "Nejednoznačné",
        "historical_import_match_none": "Nepřiřazeno",
        "historical_import_history_title": "Historie importů",
        "historical_import_latest_summary": "Poslední import: {date} · {status} · {count} e-mailů",
        "historical_import_previous_attention": "Poslední import má stav „{status}“.",
        "historical_import_show_history": "Zobrazit historii importů",
        "historical_import_hide_history": "Skrýt historii importů",
        "historical_import_active_selection_locked": "Před zobrazením jiného běhu musí být aktivní import dokončen.",
        "historical_import_history_period": "Období",
        "historical_import_history_status": "Stav",
        "historical_import_history_processed": "Zpracováno",
        "historical_import_history_duration": "Doba trvání",
        "historical_import_duration_seconds": "{count} s",
        "historical_import_duration_minutes_seconds": "{minutes} min {seconds} s",
        "historical_import_start_btn": "Spustit historický import",
        "historical_import_status_title": "Stav importu",
        "historical_import_status_pending": "Ve frontě",
        "historical_import_status_processing": "Zpracovává se",
        "historical_import_status_running": "Probíhá",
        "historical_import_status_finalizing": "Dokončují se kmenová data",
        "historical_import_status_completed": "Dokončeno",
        "historical_invoice_onboarding_status_completed": "Poslední import dokončen",
        "historical_import_status_imported": "Importováno",
        "historical_import_status_skipped": "Přeskočeno",
        "historical_import_status_failed": "Neúspěšné",
        "historical_import_status_cancelled": "Zrušeno",
        "historical_import_status_unknown": "Neznámé",
        "historical_import_processed": "Zpracováno: {processed} z {total}",
        "historical_import_eta": "Odhadovaný zbývající čas: {duration}",
        "historical_import_created": "Vytvořeno: {count}",
        "historical_import_matched": "Přiřazeno dodavateli: {count}",
        "historical_import_skipped": "Přeskočeno: {count}",
        "historical_import_failed": "Neúspěšné: {count}",
        "historical_import_messages_title": "Importované historické e-maily",
        "historical_import_messages_selected_title": "E-maily z importu dne {date}",
        "historical_import_show_all_messages": "Zobrazit všechny importované e-maily",
        "historical_import_show_messages": "Zobrazit e-maily",
        "historical_import_hide_messages": "Skrýt e-maily",
        "historical_import_refresh": "Obnovit",
        "historical_import_no_messages": "Zatím nebyly importovány žádné historické e-maily.",
        "historical_import_subject": "Předmět",
        "historical_import_sender": "Odesílatel",
        "historical_import_date": "Datum",
        "historical_import_supplier": "Dodavatel",
        "tab_invoice_onboarding": "Onboarding faktur",
        "tab_procurement_onboarding": "Onboarding objednávek",
        "section_procurement_onboarding": "Historické objednávky",
        "procurement_onboarding_info": "Importujte minulé objednávky jako historii pouze pro čtení a využijte rozpoznaná data pro kmenová data.",
        "historical_procurement_onboarding_initial_hint_title": "Vytvořte první kmenová data z objednávek",
        "historical_procurement_onboarding_initial_hint": "Společnost, dodavatele a kontakty lze odvodit z objednávkové schránky.",
        "historical_procurement_onboarding_confirmed_client": "Potvrdit společnost",
        "historical_procurement_onboarding_confirmed_client_placeholder": "Zadejte potvrzený název společnosti",
        "historical_procurement_onboarding_candidate_evidence": "Kandidát nalezen v {count} e-mailech (spolehlivost: {confidence} %). Před importem název potvrďte nebo opravte.",
        "historical_procurement_onboarding_client_required": "Před spuštěním úvodního importu potvrďte společnost.",
        "historical_procurement_onboarding_period": "Období",
        "historical_procurement_onboarding_mode": "Režim importu",
        "historical_procurement_onboarding_economic": "Úsporný (bez AI)",
        "historical_procurement_onboarding_ai": "Analýza AI",
        "historical_procurement_onboarding_economic_title": "Úsporné vytěžení",
        "historical_procurement_onboarding_economic_hint": "Používá odesílatele, předmět, text e-mailu a strukturované textové přílohy. Omezeno na období maximálně 30 dnů.",
        "historical_procurement_configuration_economic_hint": "Používá odesílatele, předmět, text e-mailu a strukturované textové přílohy.",
        "historical_procurement_onboarding_economic_period_limit": "Úsporná extrakce podporuje období maximálně 30 kalendářních dnů.",
        "historical_procurement_onboarding_gift_title": "Dárek AI pro onboarding",
        "historical_procurement_onboarding_gift_hint": "Při úvodním onboardingu zdarma: až 50 e-mailů nebo 30 příloh.",
        "historical_procurement_onboarding_ai_cost_title": "Analýza AI je zpoplatněna",
        "historical_procurement_onboarding_ai_cost_hint": "Odhad se potvrdí před importem a uloží se samostatně.",
        "historical_procurement_onboarding_preview": "Náhled importu",
        "historical_procurement_onboarding_preview_emails": "Zkontrolované e-maily: {count}",
        "historical_procurement_onboarding_preview_ai_emails": "E-maily odeslané k analýze AI: {count}",
        "historical_procurement_onboarding_preview_documents": "Přílohy k analýze AI: {count}",
        "historical_procurement_onboarding_preview_cost": "Odhadovaná cena: {cost}",
        "historical_procurement_onboarding_progress": "Zpracováno: {processed}; vytvořené historické objednávky: {imported}; neúspěšné: {failed}",
        "historical_procurement_onboarding_created_orders": "Vytvořené objednávky",
        "historical_procurement_onboarding_recognition_requested": "Provedené analýzy AI: {count}",
        "historical_procurement_onboarding_master_data_created": "Vytvořená kmenová data: {count}",
        "historical_procurement_onboarding_master_data_matched": "Přiřazená kmenová data: {count}",
        "historical_procurement_onboarding_show_details": "Zkontrolovat e-maily",
        "historical_procurement_onboarding_items_title": "E-maily z tohoto importu ({period})",
        "historical_procurement_onboarding_no_items": "Pro tento import nebyly nalezeny žádné e-maily.",
        "historical_procurement_onboarding_open_order": "Otevřít objednávku",
        "historical_procurement_onboarding_item_error_unexpected": "E-mail se nepodařilo zpracovat kvůli technické chybě. Zkuste import znovu.",
        "historical_procurement_onboarding_item_error_stage": "Zpracování selhalo ve fázi: {stage}.",
        "historical_procurement_onboarding_stage_email_content": "čtení obsahu e-mailu",
        "historical_procurement_onboarding_stage_ai_analysis": "analýza AI",
        "historical_procurement_onboarding_stage_historical_email_import": "uložení historického e-mailu",
        "historical_procurement_onboarding_stage_master_data": "zpracování kmenových dat",
        "historical_procurement_onboarding_stage_order_creation": "vytvoření objednávky",
        "historical_procurement_onboarding_analyse": "Analýza importu",
        "historical_procurement_onboarding_start": "Spustit historický onboarding objednávek",
        "historical_procurement_onboarding_cost_confirm_title": "Spustit placený import objednávek?",
        "historical_procurement_onboarding_cost_confirm": "Za vybrané období bylo nalezeno <strong>{emails}</strong> e-mailů. Obsah všech e-mailů bude odeslán k analýze AI; navíc bude analyzováno přibližně <strong>{documents}</strong> objednávkových dokumentů z příloh. Celkový odhad je až <strong>{cost}</strong>. Odhad obsahuje bezpečnostní rezervu <strong>{margin} %</strong>; účtuje se pouze aktuální skutečná cena. Chcete pokračovat?",
        "historical_procurement_insufficient_order_evidence": "Nebyl nalezen spolehlivý doklad objednávky.",
        "historical_procurement_client_confirmation_required": "Je vyžadováno potvrzení společnosti.",
        "historical_procurement_client_recognition_required": "Společnost se nepodařilo spolehlivě rozpoznat.",
        "historical_procurement_supplier_review_required": "Dodavatel vyžaduje ruční kontrolu.",
        "historical_import_status_completed_with_errors": "Dokončeno s chybami",
        "section_invoice_onboarding": "Onboarding z historické fakturační schránky",
        "invoice_onboarding_info": "Importuje historické přílohy faktur bez změny e-mailů ve schránce. Již zpracované zdroje jsou vyloučeny.",
        "historical_invoice_onboarding_period": "Období onboardingu faktur",
        "historical_invoice_onboarding_start": "Spustit historický onboarding faktur",
        "historical_invoice_onboarding_analysis_btn": "Analýza importu",
        "historical_invoice_onboarding_analysis_again_btn": "Nová analýza importu",
        "historical_invoice_onboarding_start_again": "Spustit import znovu",
        "historical_invoice_onboarding_completed_title": "Poslední import je dokončen",
        "historical_invoice_onboarding_completed_description": "Tento dialog můžete zavřít, nebo vybrat nové období a spustit další analýzu či import.",
        "historical_invoice_onboarding_analysis_title": "Analýza importu",
        "historical_invoice_onboarding_analysis_processing_title": "Připravuje se analýza importu",
        "historical_invoice_onboarding_analysis_processing_description": "Kontrolují se e-maily a přílohy. Počítá se odhadovaný počet rozpoznaných faktur a předpokládané náklady. Chvíli prosím počkejte.",
        "historical_invoice_onboarding_analysis_description": "Souhrn e-mailů nalezených ve vybraném období a jejich možného zpracování. Jednotlivé e-maily se zde nezobrazují.",
        "historical_invoice_onboarding_analysis_limited": "Analýza je omezena na prvních {count} e-mailů. Celkový počet zahrnuje všechny e-maily nalezené ve vybraném období.",
        "historical_invoice_onboarding_analysis_failed_title": "Některé e-maily nelze analyzovat",
        "historical_invoice_onboarding_analysis_failed_description": "Nelze analyzovat {failed} z {processed} kontrolovaných e-mailů. Před spuštěním importu zkontrolujte údaje schránky.",
        "historical_invoice_onboarding_long_period_confirm": "Vybrali jste {days} dní. Import historických faktur může chvíli trvat. Chcete pokračovat?",
        "historical_invoice_onboarding_preview_total": "Nalezené e-maily: {count}",
        "historical_invoice_onboarding_analysis_processed": "Kontrolované e-maily: {count}",
        "historical_invoice_onboarding_preview_eligible": "E-maily s přílohami faktur: {count}",
        "historical_invoice_onboarding_preview_no_attachment": "Bez přílohy faktury: {count}",
        "historical_invoice_onboarding_preview_failed": "Neanalyzované: {count}",
        "historical_invoice_onboarding_preview_failed_title": "Některé e-maily nelze analyzovat",
        "historical_invoice_onboarding_preview_failed_description": "{count} e-mailů nelze analyzovat. Před spuštěním importu zkontrolujte podrobnosti importu.",
        "historical_invoice_onboarding_preview_previously_imported": "Již importováno pro onboarding: {count}",
        "historical_invoice_onboarding_preview_empty": "Ve vybraném období nebyly nalezeny žádné nové přílohy faktur.",
        "historical_invoice_onboarding_imported": "E-maily s fakturami importovány: {count}",
        "historical_invoice_onboarding_master_data_created": "Vytvořená kmenová data: {count}",
        "historical_invoice_onboarding_master_data_matched": "Přiřazená kmenová data: {count}",
        "historical_invoice_onboarding_master_data_pending": "Kmenová data k ověření: {count}",
        "historical_invoice_onboarding_history": "Historie onboardingu",
        "historical_invoice_onboarding_items": "E-maily z onboardingu faktur dne {date}",
        "historical_invoice_onboarding_no_items": "Pro tento onboarding faktur zatím nebyly zpracovány žádné e-maily.",
        "historical_invoice_onboarding_attachments": "Přílohy faktur",
        "historical_invoice_onboarding_item_imported": "Importováno",
        "historical_invoice_onboarding_item_skipped": "Přeskočeno",
        "historical_invoice_onboarding_item_failed": "Selhalo",
        "historical_invoice_onboarding_item_processing": "Zpracovává se"
    }
    ,
    "marketplace": {
        "description": "Tržiště",
        "description_plural": "Tržiště",
        "name": "Název / Alias",
        "provider": "Poskytovatel",
        "country_code": "Země",
        "url": "URL",
        "email": "E-mail",
        "order_url": "URL objednávky",
        "order_auth_type": "Ověření objednávky",
        "order_auth_type_none": "Žádné",
        "order_auth_type_basic": "HTTP Basic Auth",
        "order_auth_username": "Uživatelské jméno",
        "order_auth_password": "Heslo",
        "identity": "Identita",
        "secret": "Tajný klíč",
        "section_configuration": "Konfigurace tržiště",
        "section_sender_identity": "Odesílatel / Identita",
        "section_order_authentication": "Ověření objednávky",
        "new": "Nový trh",
        "amazon_more_clients_info": "V Liftbase je nakonfigurováno více společností. <br>Aby byly faktury z Amazon Business přiřazeny správné firmě, <br>postupujte podle pokynů na <br><a href='https://liftbase.de/handbuch/einrichtung/amazon-business-mehrere-unternehmen.' target='_blank'>https://liftbase.de/handbuch/einrichtung/amazon-business-mehrere-unternehmen</a>."
    }
    ,
    "payment_options": {
        "label": "Platební metoda dodavatelské společnosti",
        "AUTOMATIC_DEBIT": "Prostřednictvím SEPA inkasa",
        "CREDIT_CARD": "Prostřednictvím kreditní karty",
        "BANK_TRANSFER": "Prostřednictvím bankovního převodu (IBAN/BIC)",
        "BANK_TRANSFER_FOREIGN": "Zahraniční bankovní převod (číslo účtu/kód banky)",
        "ONLINE_PAYMENT": "Online platební služby"
    }
    ,
    "errors": {
        "field_required": "Povinné pole ve formuláři nebylo vyplněno.",
        "specific_field_required": "Pole {field} je povinné.",
        "invalid_type": "Zadaná hodnota je neplatná.",
        "specific_invalid_type": "Hodnota \"{value}\" není platná pro typ {type}.",
        "unique_violation": "Tato hodnota se již používá.",
        "specific_unique_violation": "Záznam s touto hodnotou v poli {field} již existuje.",
        "foreign_key_violation": "Neplatný odkaz na jiný záznam.",
        "specific_foreign_key_violation": "Hodnotu v poli {field} nelze propojit s existujícím záznamem.",
        "permission_denied": "Nemáš oprávnění k této akci.",
        "check_violation": "Zadaná data nesplňují systémová kritéria.",
        "specific_check_violation": "Hodnota v poli {field} nesplňuje definovaná pravidla.",
        "value_too_long": "Hodnota přesahuje povolenou délku.",
        "specific_value_too_long": "Hodnota v poli {field} přesahuje povolenou délku.",
        "not_found": "Požadovaný prostředek nebyl nalezen.",
        "already_exists": "Tato položka je již zaregistrována.",
        "validation_failed": "Ověření dat selhalo.",
        "unexpected": "Něco se pokazilo. Zkus to znovu nebo kontaktuj podporu.",
        "specific_field_not_found": "Pole {field} nebylo nalezeno v typu {type}.",
        "expected_type_but_found": "Očekávalo se, že {field} bude typu {type}, ale nalezeno bylo {type_found}.",
        "duplicate_key_violation": "Zadaná hodnota již existuje a porušuje omezení unikátního klíče {field}.",
        "unexpected_null_value_for_type": "Neočekávaná hodnota null pro typ {type}.",
        "timeline_changed": "Doklad byl upraven jinou osobou. Stránka se automaticky obnoví. Zkontrolujte doklad znovu.",
        "timeline_locked": "Doklad právě upravil {name}. Stránka byla automaticky obnovena. Zkontrolujte doklad znovu.",
        "save_bcase_error": "Při ukládání došlo k chybě.<br>Formulář nebylo možné uložit.<br>Zkontrolujte zadané údaje a zkuste to znovu.<br>Pokud problém přetrvává, kontaktujte podporu."
    },
    "onboarding": {
        "flow_option": "Konfigurace",
        "custom_option": "Vybrat ukázková data ručně",
        "custom_option_description": "Vyberte si konkrétní ukázková data – ideální pro seznámení se systémem bez zadávání vlastních údajů.",
        "full_option": "Použít kompletní ukázková data (doporučeno)",
        "full_option_description": "Použijte kompletní konfiguraci ukázkových dat a začněte systém ihned používat – bez ručního nastavení.",
        "none_option": "Začít bez ukázkových dat",
        "none_option_description": "Začněte s prázdným prostředím a nakonfigurujte systém výhradně pomocí vlastních údajů.",
        "invoice_onboarding_option": "Importujte své historické faktury",
        "invoice_onboarding_option_description": "Připojte existující fakturační schránku a začněte se skutečnými doklady místo ukázkových dat.",
        "invoice_onboarding_mailbox_step": "Fakturační schránka",
        "invoice_onboarding_mailbox_step_title": "Vyberte fakturační schránku",
        "invoice_onboarding_mailbox_step_description": "Vyberte existující schránku nebo nastavte novou a začněte import.",
        "invoice_onboarding_import_step": "Historické faktury",
        "invoice_onboarding_mailbox": "Fakturační schránka",
        "invoice_onboarding_mailbox_placeholder": "Vyberte schránku",
        "invoice_onboarding_mailbox_default_folder": "INBOX",
        "invoice_onboarding_use_existing_mailbox": "Použít existující schránku",
        "invoice_onboarding_use_existing_mailbox_description": "Vyberte schránku, která je již pro import nastavena.",
        "invoice_onboarding_existing_mailboxes_title": "Našli jsme již nastavené fakturační schránky.",
        "invoice_onboarding_existing_mailboxes_description": "Chcete některou použít, nebo nastavit novou schránku?",
        "invoice_onboarding_create_mailbox": "Nastavit novou schránku",
        "invoice_onboarding_create_mailbox_description": "Připojte novou schránku a začněte import.",
        "invoice_onboarding_mailbox_setup_step": "Připojit schránku",
        "invoice_onboarding_mailbox_setup_title": "Připojit fakturační schránku",
        "invoice_onboarding_mailbox_setup_description": "Zadejte pouze přístupové údaje ke schránce. Další nastavení můžete doplnit později.",
        "invoice_onboarding_mailbox_setup_hint_title": "Přístupové údaje jsou bezpečně uloženy",
        "invoice_onboarding_mailbox_setup_hint_description": "Pro historické faktury stačí přístup pro čtení do vybrané složky.",
        "invoice_onboarding_mailbox_setup_name_placeholder": "např. Faktury",
        "invoice_onboarding_mailbox_setup_protocol_imap": "Přístupové údaje IMAP",
        "invoice_onboarding_mailbox_setup_protocol_imap_description": "Pro Gmail, GMX, IONOS a další schránky IMAP.",
        "invoice_onboarding_mailbox_setup_protocol_ews": "Microsoft Exchange (EWS)",
        "invoice_onboarding_mailbox_setup_protocol_ews_description": "Přihlaste se pomocí uživatelského účtu Microsoft 365.",
        "invoice_onboarding_mailbox_setup_protocol_graph": "Microsoft 365 (Microsoft Graph)",
        "invoice_onboarding_mailbox_setup_protocol_graph_description": "Připojte uživatelský účet přes Microsoft Graph.",
        "invoice_onboarding_mailbox_setup_protocol_ms365": "Microsoft 365 – podniková aplikace",
        "invoice_onboarding_mailbox_setup_protocol_ms365_description": "Pro centrálně spravovaný přístup s ID tenant, ID aplikace a tajným klíčem.",
        "invoice_onboarding_mailbox_setup_connect_title": "Vyžaduje se přihlášení k Microsoft 365",
        "invoice_onboarding_mailbox_setup_connect_description": "Po uložení se v novém okně otevře přihlášení Microsoft. Poté se vraťte k tomuto onboardingu.",
        "invoice_onboarding_mailbox_setup_host_placeholder": "např. imap.vase-domena.cz",
        "invoice_onboarding_mailbox_setup_save": "Uložit schránku a pokračovat",
        "invoice_onboarding_mailbox_setup_save_and_connect": "Uložit a připojit k Microsoft 365",
        "invoice_onboarding_mailbox_setup_saved": "Schránka byla nastavena.",
        "invoice_onboarding_no_mailbox": "Zatím není nastavena žádná aktivní fakturační schránka",
        "invoice_onboarding_no_mailbox_description": "Nejprve nastavte fakturační schránku, abyste mohli importovat historické faktury.",
        "invoice_onboarding_configure_mailbox": "Nastavit schránku",
        "btn_start": "Začínáme!",
        "btn_finish": "Spustit!",
        "select_client": "Vyberte společnosti, se kterými chcete pracovat.",
        "select_cost_center": "Vyberte střediska nákladů, se kterými chcete pracovat.",
        "select_department": "Vyberte oddělení, se kterými chcete pracovat.",
        "select_ledger_account": "Vyberte hlavní účty, se kterými chcete pracovat.",
        "select_posting_key": "Vyberte daňové klíče, se kterými chcete pracovat.",
        "select_supplier": "Vyberte dodavatele, se kterými chcete pracovat.",
        "select_product": "Vyberte produkty, se kterými chcete pracovat.",
        "general_config": "Zadejte nejdůležitější základní nastavení.",
        "profile_config": "Zadejte důležité informace o profilu – pro rychlejší procesy a snadnější objednávky."
    },
    "contract": {
        "description": "Smlouva",
        "name": "Popis",
        "contract_date": "Datum smlouvy",
        "contract_number_formatted": "SM-číslo",
        "contract_number": "Číslo smlouvy",
        "category": "Kategorie",
        "status": "Stav",
        "type": "Typ",
        "notes": "Poznámka",
        "payment_method": "Platební metoda",
        "payment_direction": "Směr",
        "external_contract_number": "Externí číslo smlouvy",
        "responsible_id": "Odpovědná osoba",
        "recurring_invoice": "Opakovaná faktura",
        "start_date": "Datum zahájení",
        "end_date": "Datum ukončení",
        "duration": "Doba trvání",
        "min_duration": "Minimální doba trvání smlouvy",
        "duration_unit_type": "Jednotka doby trvání",
        "renewal_type": "Typ obnovení",
        "renewal_duration": "Doba obnovení",
        "renewal_duration_unit_type": "Jednotka obnovení",
        "notice_period": "Výpovědní lhůta",
        "notice_period_unit_type": "Jednotka výpovědní lhůty",
        "termination_special_right": "Zvláštní právo ukončení",
        "termination_deadline": "Termín ukončení",
        "next_possible_contract_end": "Další možný konec smlouvy",
        "terminated_on": "Ukončeno dne",
        "termination_to": "Ukončení k",
        "reminder_date": "Datum připomenutí",
        "reminder_duration": "Připomenutí před datem výpovědi",
        "reminder_unit_type": "Časová jednotka připomenutí výpovědi",
        "term_type": "Typ trvání",
        "termination_to_options": {
            "none": "Žádný",
            "day": "Den",
            "year_end": "Konec roku",
            "half_year_end": "Konec pololetí",
            "quarter_end": "Konec čtvrtletí",
            "month_end": "Konec měsíce",
            "week_end": "Konec týdne"
        },
        "duration_unit_type_options": {
            "month": "Měsíc(e)",
            "quarter": "Čtvrtletí",
            "semester": "Pololetí",
            "year": "Rok(y)",
            "week": "Týden(y)"
        },
        "renewal_type_options": {
            "auto": "Automaticky obnoveno",
            "none": "Bez obnovení",
            "once": "Jednorázové obnovení",
            "manual": "Ruční obnovení"
        },
        "payment_timing": "Typ platby",
        "payment_timing_options": {
            "advance": "Předem",
            "postpaid": "Dodatečně",
            "midterm": "Uprostřed období"
        },
        "usage_type": "Frekvence použití",
        "usage_type_options": {
            "usage_based": "Podle použití",
            "monthly": "Měsíčně",
            "quarterly": "Čtvrtletně",
            "semiannually": "Pololetně",
            "yearly": "Ročně"
        },
        "category_options": {
            "service": "Služba",
            "subscription": "Předplatné",
            "license": "Licence",
            "maintenance": "Údržba",
            "consulting": "Konzultace",
            "leasing": "Leasing",
            "rental": "Pronájem",
            "support": "Podpora",
            "other": "Jiné"
        },
        "term_type_options": {
            "fixed": "Na dobu určitou",
            "indefinite": "Na dobu neurčitou",
            "none": "Bez trvání"
        },
        "payment_direction_options": {
            "incoming": "Příchozí",
            "outgoing": "Odchozí",
            "both": "Oba směry"
        },
        "ai": {
            "back": "Zpět",
            "add_title": "Nová smlouva",
            "add_subtitle": "Zvolte, jak chcete smlouvu vytvořit.",
            "manual_title": "Zadat údaje smlouvy",
            "manual_description": "Vytvořte smlouvu ručně pomocí stávajícího formuláře.",
            "ai_title": "Rozpoznat smlouvu pomocí AI",
            "ai_description": "Nahrajte PDF a zkontrolujte extrahované údaje.",
            "disabled": "AI je pro tohoto tenanta deaktivována.",
            "upload_title": "Rozpoznat smlouvu pomocí AI",
            "upload_subtitle": "Nahrajte jedno nebo více PDF. Extrahované údaje se zobrazí vedle dokumentu ke kontrole.",
            "upload_info": "Přetáhněte sem PDF smluv nebo kliknutím vyberte soubory.",
            "upload_hint": "Pouze PDF, maximálně 30 MB a 50 stran.",
            "file_invalid": "Podporovány jsou pouze soubory PDF.",
            "file_too_large": "PDF nesmí být větší než 30 MB.",
            "file_size": "{size} MB",
            "select_file_preview": "Vyberte soubor pro zobrazení náhledu.",
            "start_recognition": "Odeslat smlouvy k rozpoznání",
            "recognition_failed": "Smlouvu se nepodařilo rozpoznat. Zkuste to znovu.",
            "document_review_hint": "Před uložením zkontrolujte extrahovaná pole.",
            "document_loading": "Načítání dokumentu…",
            "new_upload": "Nové nahrání",
            "document_preview_failed": "Náhled dokumentu se nepodařilo načíst. Rozpoznaná data můžete přesto zkontrolovat a uložit.",
            "client_review": "Dokument uvádí jako klienta „{client}“. Zkontrolujte vybranou společnost.",
            "persistence_failed": "Smlouva byla vytvořena, ale PDF a AI analýzu se zatím nepodařilo uložit.",
            "retry_save": "Zkusit uložit znovu"
        },
        "statuses": {
            "active": "Aktivní",
            "inactive": "Neaktivní",
            "declined": "Zrušeno",
            "expired": "Vypršelo",
            "pending": "Čekající",
            "recognition": "Rozpoznávání",
            "completed": "Podepsáno",
            "check": "Kontrola",
            "clearing": "Vyjasnění smlouvy"
        },
        "page": {
            "new": "Nová smlouva",
            "create_btn": "Vytvořit smlouvu",
            "no_edit_permission": "Nemáte oprávnění k úpravě dat. Odešlete smlouvu k objasnění, abyste mohli provést změny.",
            "before_leave_msg": "Vaše smlouva nebyla uložena. Opravdu chcete stránku opustit?",
            "no_procurement": "Pro tuto smlouvu nebyly zaznamenány žádné objednávky.",
            "no_invoice": "Pro tuto smlouvu nebyly zaznamenány žádné faktury.",
            "recognition_data_title": "Nezpracovaná data rozpoznávání",
            "no_recognition_data": "Nebyla rozpoznána žádná data.",
            "no_permission_create_contract": "Nemáte oprávnění vytvořit novou smlouvu.",
            "period": "Období",
            "no_invoice_for_period": "Žádné faktury pro toto období.",
            "confirm_before_leave_msg": "Vaše smlouva nebyla uložena. Opravdu chcete stránku opustit?",
            "reminder_tooltip": "V tento den vám e-mailem připomeneme tuto smlouvu.",
            "tour": {
                "description": "",
                "save_btn": ""
            },
            "validation": {
                "client_id_required": "Vyberte společnost.",
                "department_id_required": "Vyberte oddělení.",
                "department_id_required_client_missing": "Nejprve vyberte společnost.",
                "cost_center_id_required": "Vyberte nákladové středisko.",
                "cost_center_id_required_filters_missing": "Nejprve vyberte společnost a oddělení.",
                "cost_center_id_required_department_missing": "Nejprve vyberte oddělení.",
                "cost_center_id_required_client_missing": "Nejprve vyberte společnost."
            }
        },
        "reminder_type": {
            "contract_end": "Konec smlouvy",
            "cancellation_notice": "Výpovědní lhůta",
            "invoice_missing": "Chybějící faktura",
            "custom": "Vlastní"
        },
        "procurements": {
            "quantity_ordered": "Objednáno",
            "quantity_received": "Přijato"
        },
        "documents": "Dokumenty"
    },
    "contract_line": {
        "title": "Položka smlouvy",
        "new_title": "Nová položka smlouvy",
        "name": "Popis",
        "type": "Typ",
        "type_options": {
            "service": "Služba",
            "product": "Produkt",
            "license": "Licence",
            "maintenance": "Údržba",
            "subscription": "Předplatné",
            "other": "Ostatní"
        },
        "item_number": "Číslo položky",
        "quantity": "Množství",
        "total": "Celkem",
        "image_url": "URL obrázku",
        "webshop_url": "URL e-shopu",
        "offer_number": "Číslo nabídky",
        "offer_date": "Datum nabídky",
        "usage_type": "Frekvence použití",
        "add_btn": "Přidat novou položku",
        "delete_btn": "Odstranit položku smlouvy",
        "edit_btn": "Upravit položku smlouvy",
        "confirm_before_delete_msg": "Opravdu chcete tuto položku trvale smazat?",
        "confirm_before_delete_title": "Smazat položku",
        "confirm_before_delete_btn": "Smazat"
    },
    "contract_term": {
        "title": "Doba trvání smlouvy",
        "add_btn": "Přidat novou dobu trvání smlouvy",
        "delete_btn": "Odstranit dobu trvání smlouvy",
        "edit_btn": "Upravit dobu trvání smlouvy",
        "section_duration": "Doba trvání",
        "section_renewal": "Obnovení",
        "section_termination": "Ukončení",
        "section_reminder": "Připomenutí",
        "section_term_type": "Typ trvání",
        "term_type_indefinite": "Smlouvy na dobu neurčitou nemají obnovení",
        "show_termination_fields_msg": "Obnovené smlouvy lze ukončit na konci období následujícím způsobem.",
        "do_not_show_termination_fields_msg": "Smlouvy na dobu určitou mají pevné datum ukončení a lze je ukončit dříve pouze se zvláštním právem.",
        "no_termination_possible_msg": "Dosažen konec smlouvy, ukončení není možné.",
        "no_renewal_msg": "Smlouvy na dobu neurčitou nemají obnovení"
    },
    "copy_contract_dialog": {
        "title": "Přenést data",
        "title_select_contract": "Přenést data smlouvy",
        "select_contract": "Vyberte smlouvu.",
        "message": "Chcete přenést některá data smlouvy do této objednávky?",
        "overwrite_checkbox": "Přepsat existující data ve formuláři.",
        "confirm_btn": "Potvrdit"
    },
    "custom_field": {
        "description": "Vlastní pole",
        "label": "Popisek",
        "type": "Typ pole",
        "multilingual": "Vícejazyčné",
        "export_enabled": "Použít pro export",
        "export_field_name": "Název v exportu {export_name}",
        "bcase_type": "Typ dokumentu",
        "bcase_types": {
            "default_value": "Výchozí hodnota",
            "required": "Povinné pole",
            "readonly": "Pouze pro čtení",
            "show_in_search": "Vyhledávací pole",
            "show_in_export": "Exportní pole",
            "show_in_column_dialog": "Dialog sloupců",
            "show_in_api": "API",
            "order": "Pořadí",
            "visible_in_step_types": "Zobrazit v krocích",
            "all_steps": "Všechny kroky"
        },
        "tooltip": "Tooltip",
        "default_value": "Výchozí hodnota",
        "field_key": "Název API",
        "type_options": {
            "text": "Text",
            "textarea": "Víceřádkový text",
            "number": "Číslo",
            "currency": "Měna",
            "checkbox": "Zaškrtávací políčko",
            "radio": "Výběr (radio)",
            "enum": "Rozbalovací seznam",
            "date": "Datum",
            "html": "Rich Text (HTML)"
        },
        "page": {
            "new_title": "Nové pole",
            "tab_general": "Obecné",
            "tab_options": "Možnosti",
            "tab_validation": "Validace",
            "tab_labels": "Popisky",
            "tab_tooltips": "Tooltips",
            "tab_permissions": "Skupiny oprávnění",
            "tab_clients": "Společnosti",
            "tab_bcase_types": "Propojené typy dokumentů",
            "tab_bcase_description": "Doplňující pole",
            "validation": {
                "label_required": "Zadejte štítek.",
                "field_key_required": "Zadejte název API.",
                "export_field_name_required": "Zadejte název pole pro export."
            },
            "options": {
                "repeated": "Stejnou možnost nelze zadat vícekrát.",
                "required_fields": "Musíte zadat popisek a ID možnosti.",
                "language_empty": "Musíte vybrat jazyk.",
                "at_least_one_required": "Musíte zadat alespoň jednu možnost."
            }
        }
    },
    "custom_field_label": {
        "description": "Popisky"
    },
    "ai_access_request": {
        "title": "Požádat o přístup k AI",
        "headline": "Získejte ze svých dat více",
        "intro": "Po aktivaci přístupu k AI můžete využívat inteligentní funkce, které omezí rutinní práci a urychlí vaše procesy.",
        "benefit_recognition_title": "Automatické rozpoznávání dokumentů",
        "benefit_recognition_description": "Rychleji zachyťte a zpracujte faktury i další důležitý obsah.",
        "benefit_data_title": "Kvalitnější kmenová data",
        "benefit_data_description": "Spolehlivě přiřazujte společnosti, dodavatele a obsah dokumentů.",
        "benefit_workflow_title": "Rychlejší výsledky",
        "benefit_workflow_description": "Méně ruční práce a více času na důležité úkoly.",
        "description": "AI pro tohoto tenanta zatím není aktivní. Odešlete žádost obchodnímu týmu o aktivaci přístupu.",
        "action": "Požádat o přístup",
        "requested": "Vaše žádost byla odeslána obchodnímu týmu.",
        "already_requested": "Žádost pro tuto oblast již byla dnes odeslána."
    },
    "custom_field_tooltip": {
        "description": "Tooltips"
    },
    "custom_field_option": {
        "description": "Možnosti"
    },
    "custom_field_bcase_type": {
        "description": "Propojené typy dokumentů",
        "visible_in_step_types": "Zobrazit v krocích"
    },
    "bcase_custom_field": {
        "description": "Doplňující pole"
    },
    "ai_llm_configuration": {
        "menu": "AI a LLM",
        "title": "AI a LLM",
        "subtitle": "Spravujte skupiny modelů a LLM připojení zákazníka.",
        "general": "Obecné",
        "model_groups": "Skupiny modelů",
        "model_groups_hint": "Skupina modelů představuje jeden model a může obsahovat více rovnocenných deploymentů.",
        "task_routing": "Přiřazení úloh",
        "consumption": "Využití",
        "consumption_hint": "Zobrazuje zaznamenané tokeny podle úlohy AI a skupiny modelů. Fakturace podle tokenů není součástí tohoto přehledu.",
        "all_model_groups": "Všechny skupiny modelů",
        "all_tasks": "Všechny úlohy AI",
        "date": "Datum",
        "total_calls": "Volání",
        "input_tokens": "Vstupní tokeny",
        "output_tokens": "Výstupní tokeny",
        "total_tokens": "Tokeny celkem",
        "input_tokens_millions": "Vstupní tokeny (mil.)",
        "output_tokens_millions": "Výstupní tokeny (mil.)",
        "total_tokens_millions": "Tokeny celkem (mil.)",
        "configuration_source": "Konfigurace",
        "source_customer": "Vlastní zákazníka",
        "source_liftbase": "Výchozí Liftbase",
        "deleted_deployment": "Odstraněné nasazení",
        "no_model_group": "Žádná skupina modelů",
        "default_model_group": "Výchozí skupina modelů",
        "default_model_group_hint": "Použije se pro každou KI úlohu bez výslovně přiřazené skupiny modelů.",
        "no_default_model_group": "Žádná výchozí skupina modelů",
        "default_model_group_required": "Vyberte výchozí skupinu modelů.",
        "task_assignments": "Skupiny modelů podle úlohy",
        "task_assignments_hint": "Vyberte skupinu modelů pro každou KI úlohu nebo použijte výchozí skupinu modelů.",
        "task": "KI úloha",
        "assigned_model_group": "Skupina modelů",
        "use_default_model_group": "Použít výchozí skupinu modelů",
        "allow_liftbase_fallback": "Záloha Liftbase",
        "allow_liftbase_fallback_tooltip": "Pokud všechny deploymenty vybrané skupiny modelů technicky selžou, použije se interní výchozí model Liftbase.",
        "no_model_groups_for_routing": "Nejprve vytvořte alespoň jednu aktivní skupinu modelů.",
        "task_routing_saved": "Přiřazení úloh bylo uloženo.",
        "tasks": {
            "historical_import": "Historický import",
            "historical_import_hint": "Zpracovává dokumenty a e-maily během onboardingu a importu historických dat.",
            "invoice_recognition": "Rozpoznání faktury",
            "invoice_recognition_hint": "Načítá údaje z faktury z nahraných dokumentů.",
            "invoice_validation": "Kontrola faktury",
            "invoice_validation_hint": "Kontroluje věrohodnost a rizika rozpoznaných údajů faktury.",
            "invoice_custom_prompt": "Vlastní prompt pro rozpoznání faktur",
            "invoice_custom_prompt_hint": "Použije další pokyny zákazníka na rozpoznané údaje z faktury.",
            "invoice_supplier_identification": "Identifikace dodavatele",
            "invoice_supplier_identification_hint": "Přiřadí fakturu dodavateli podle jejích údajů.",
            "procurement_offer_extraction": "Rozpoznání nabídky",
            "procurement_offer_extraction_hint": "Načítá údaje a položky nabídky z dokumentu.",
            "contract_analysis": "Analýza smlouvy",
            "contract_analysis_hint": "Analyzuje nahrané smlouvy a extrahuje relevantní informace."
        },
        "new_group": "Nová skupina modelů",
        "edit_group": "Upravit skupinu modelů",
        "group_name": "Název skupiny modelů",
        "group_name_tooltip": "Volně zvolený název této skupiny modelů. Příklad: „Rozpoznání faktur – GPT-4.1“.",
        "model_identifier": "LLM model",
        "model_identifier_tooltip": "Použitý LLM nezávisle na konkrétním deploymentu. Příklady: „gpt-4.1“, „gpt-4o-mini“ nebo „llama-3.1-70b“.",
        "provider": "Poskytovatel LLM",
        "provider_tooltip": "Azure OpenAI se používá pro endpointy Azure.",
        "provider_azure_openai": "Azure OpenAI",
        "provider_openai_compatible": "Kompatibilní s OpenAI",
        "provider_openai_compatible_tooltip": "Podpora rozhraní API kompatibilních s OpenAI bude přidána později.",
        "deployments": "Deploymenty",
        "link_existing_deployment": "Vybrat existující deployment",
        "deployment_select_placeholder": "Vybrat deployment",
        "link_existing_deployment_hint": "K dispozici jsou pouze deploymenty se stejným poskytovatelem a LLM modelem.",
        "link_deployment": "Propojit deployment",
        "linked_deployments": "Propojené deploymenty",
        "linked_deployments_hint": "Priorita fallbacku určuje pořadí při technických výpadcích.",
        "unlink_deployment_confirmation": "Odebrat tento deployment pouze ze skupiny modelů? Samotný deployment zůstane zachován.",
        "link_existing_group": "Propojit skupiny modelů",
        "manage_deployments": "Spravovat deploymenty",
        "default": "Výchozí",
        "default_group": "Použít jako výchozí skupinu modelů",
        "default_group_tooltip": "Použije se, když ke KI úloze není výslovně přiřazena skupina modelů.",
        "active_group_tooltip": "Neaktivní skupiny modelů nelze použít pro KI úlohy.",
        "status": "Stav",
        "new_deployment": "Nový deployment",
        "new_deployment_hint": "Vytvořte deployment pro tento model. Po uložení bude automaticky propojen s touto skupinou modelů.",
        "edit_deployment": "Upravit deployment",
        "deployments_hint": "Fallback mezi deploymenty bude aktivován v dalším kroku implementace.",
        "deployment_display_name": "Zobrazovaný název deploymentu",
        "deployment_display_name_tooltip": "Srozumitelný název tohoto endpointu. Příklad: „Frankfurt – Produkce“.",
        "deployment_name": "Technický název deploymentu",
        "deployment_name_tooltip": "Název, pod kterým poskytovatel model nasadil. Příklad: „gpt-4o-prod“.",
        "endpoint_url": "URL endpointu",
        "endpoint_url_tooltip": "Adresa instance Azure nebo kompatibilního LLM. Příklad: „https://muj-ucet.openai.azure.com“.",
        "endpoint_placeholder": "https://your-resource.openai.azure.com",
        "api_key": "Klíč API",
        "api_key_tooltip": "Přístupový klíč poskytovatele pro tento endpoint. Ukládá se zašifrovaně a znovu se nezobrazuje.",
        "api_key_hint": "Klíč je před uložením zašifrován.",
        "api_key_keep_hint": "Ponechte prázdné pro zachování uloženého klíče. Klíč již nebude zobrazen.",
        "test_connection": "Otestovat připojení",
        "test_connection_hint": "Ověří uložený koncový bod, deployment a klíč API krátkým požadavkem na Azure OpenAI.",
        "test_connection_save_first": "Před testem připojení změny uložte.",
        "connection_test_succeeded": "Připojení bylo úspěšně otestováno.",
        "connection_test_failed": "Test připojení selhal.",
        "priority": "Priorita fallbacku",
        "priority_tooltip": "Pořadí technické redundance v rámci této skupiny modelů. Nejdříve se použije 1, poté 2 a tak dále.",
        "active_deployment": "Deployment aktivní",
        "active_deployment_tooltip": "Neaktivní deploymenty se nepoužívají pro požadavky.",
        "configured": "Nakonfigurováno",
        "not_configured": "Nenakonfigurováno",
        "validation_error": "Vyplňte všechna povinná pole.",
        "incompatible_group_link_error": "Propojené skupiny modelů musí používat stejného poskytovatele a stejný LLM model.",
        "incompatible_deployment_link_error": "Propojené deploymenty musí používat stejného poskytovatele a stejný LLM model.",
        "delete_group_confirmation": "Odstranit tuto skupinu modelů? Propojené deploymenty zůstanou zachovány.",
        "delete_deployment_confirmation": "Odstranit tento deployment a všechna propojení se skupinami modelů?",
        "saved": "Konfigurace uložena."
    }

}
